import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Switch from "react-switch";
import './index.scss';
import { ActionList, Badge, Banner, BlockStack, Button, ButtonGroup, Card, Checkbox, Collapsible, DropZone, Icon, InlineStack, Link, Modal, Page, Pagination, Popover, RadioButton, Scrollable, SkeletonBodyText, SkeletonDisplayText, Spinner, Tag, Text, TextField, Thumbnail, Tooltip } from '@shopify/polaris';
import { withRouter } from 'react-router-dom';
import Language from '../../../../i18n/Language';
import {
    CodeAddIcon,
    AlertCircleIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    XIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronUpIcon,
    ClockIcon,
    CollectionIcon,
    DuplicateIcon,
    EditIcon,
    LinkIcon,
    ListBulletedIcon,
    MaximizeIcon,
    MinimizeIcon,
    NoteIcon,
    QuestionCircleIcon,
    RefreshIcon,
    SearchResourceIcon,
    AdjustIcon,
    LightbulbIcon,
    CodeIcon,
    MagicIcon,
} from "@shopify/polaris-icons";
import SearchFilterList from '../../../../components/SearchFilterList';
import FooterPageSelect from '../../../../components/FooterPageSelect/indexPage';
import CircularViewGauge from '../../../../components/CircularViewGauge';
import CircularGauge from '../../../../components/CircularGauge';
import { AiLanguageArr } from '../../../../utils/LanguageList';
import Countrys from '../../../../utils/country';
import SaveBarTop from '../../../../components/SaveBarTop';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
import ProgressRing from './components/ProgressRing';
import ReviewPopup from './components/ReviewPopup';
import ProductMediaGrid from './components/ProductMediaGrid';
import PagesModal from '../../../../components/PagesModal';
import AnalyzeContent from './components/AnalyzeContent';
// import KeywordSuggestions from './components/KeywordSuggestions';
import SelectTargetKeyword from '../components/SelectTargetKeyword';
import {
    reqGetOnPageList,
    reqUserComboByCard,
    reqPublishAiBlogArticle,
    reqSelectDetailLanguage,
    reqGetTrResources,
    reqGetKeywordSearch,
    reqInsertLinks,
    reqSaveContentAudit,
    reqAiKeywordSuggestion,
    reqUpdTranslationsRegister,
    reqHandleAIUsagePayment,
    reqUpdEnableOverage,
    reqGetAuditAnalysis,
    reqPostAuditAnalysis,
    reqGetAuditAnalysisIntents,
    reqDiscardAuditAnalysis,
    reqGetSearchPerformance,
    reqStartAiOptimize,
    reqGetAiOptimizeResultData,
    reqDetectStructuredState,
    reqGetJumpGoogleapisAuth,
    reqGetGscBindState,
    reqGetAiProductTags,
    reqGetPageDetailData,
    reqUploadMedia,
} from '../../../../api';
import { cloneDeep, debounce } from 'lodash-es';
import OptimizeImageAlt from '../index/components/OptimizeImageAlt/indexModal';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import { store } from '../../../../redux/store';
import utils from '../../../../utils/utils';
import TinyMce from '../../../../components/TinyMce/indexv2';
import { useOnPageProton } from '../../../../hooks/useOnPageProton';
import SearchIntent from './components/SearchIntent';
import StructuredData from './components/StructuredData';
import SearchPerformance from './components/SearchPerformance';
import AdvancedSettings from './components/AdvancedSettings';
import { diffEditorContent, formatTableHtml } from './richTextDiff';
import { withWindowWidth } from '../../../../components/UseWindowWidth/withWindowWidth';
import { formatPreviewUrl, formatOutUrl } from './extraFunc';
import TagTextInput from '../../NewUserGuide/components/TagTextInput';
import CopyIcon from '../../../../assets/CopyIcon';
import { mergeDetectedStructuredData } from './structuredDataUtils';
const t = Language;

// 产品 Tag 的最大数量，需与 TagTextInput 的 maxTags 保持一致
const PRODUCT_TAGS_MAX = 15;

/** Auto-Optimize Compare 弹窗：左右栏标签（Original / Optimized） */
function AutoOptCompareSideLabel({ variant }) {
    const isOriginal = variant === 'original';
    return (
        <div className='auto_opt_compare_side_label'>
            <InlineStack gap='200' blockAlign='center' wrap={false}>
                <span
                    className={
                        isOriginal
                            ? 'auto_opt_compare_dot auto_opt_compare_dot--original'
                            : 'auto_opt_compare_dot auto_opt_compare_dot--optimized'
                    }
                />
                <Text as='span' variant='bodyMd' tone={isOriginal ? 'subdued' : undefined}>
                    {isOriginal ? t('Original') : t('Optimized')}
                </Text>
            </InlineStack>
        </div>
    );
}

/** 两栏对比布局 + 中间竖线 */
function AutoOptCompareTwoCol({ original, optimized }) {
    return (
        <div className='auto_opt_compare_grid'>
            <div className='auto_opt_compare_col'>{original}</div>
            <div className='auto_opt_compare_col auto_opt_compare_col--divider'>{optimized}</div>
        </div>
    );
}

// 使用对象状态
// 替换关键词提示关闭状态的 sessionStorage 缓存 key（按 recordId 记录，仅当前会话内生效）
const REPLACE_TIP_CLOSED_STORAGE_KEY = 'seoant_ca_replace_tip_closed';

const useObjectState = (initialState) => {
    const [state, setState] = useState(initialState);
    const patchState = (patch) => {
        setState((prev) => ({
            ...prev,
            ...(typeof patch === 'function' ? patch(prev) : patch),
        }));
    };
    return [state, patchState, setState];
};

// 选择定义的字段
const pickDefinedFields = (source, keys = []) =>
    keys.reduce((acc, key) => {
        if (source?.[key] !== undefined) {
            acc[key] = source[key];
        }
        return acc;
    }, {});


let timerArr = [], aiTimerArr = [];

// 产品媒体图片数量上限
const PRODUCT_MEDIA_MAX = 5;

// Sidekick 资源类型
const SIDEKICK_RESOURCE_TYPE_MAP = {
    Product: 'product',
    Collection: 'collection',
    Article: 'article',
    Page: 'page',
};

// pagetype -> 后端 sourceType 映射（暂用假设值，后端确认后只需改这里统一替换）
const PAGE_SOURCE_TYPE_MAP = {
    product: 'product',
    collections: 'collection',
    blog: 'article',
    otherpage: 'page',
};
const getSourceType = (type) => PAGE_SOURCE_TYPE_MAP[type] || type || 'product';

// pagetype -> 前端显示类型
const PAGE_SOURCE_TYPE_TEXT_MAP = {
    product: 'Product',
    collections: 'Collection',
    blog: 'Blog Post',
    otherpage: 'Other Page',
};
const getSourceTypeText = (type) => PAGE_SOURCE_TYPE_TEXT_MAP[type] || type || 'product';

// pagetype -> 该类型下的结构化数据字段（与 StructuredData 组件 TYPE_SCHEMA_FIELDS 保持一致）
const STRUCTURED_DATA_TYPE_FIELDS = {
    product: ['has_product', 'has_review', 'has_shipping', 'has_return', 'has_breadcrumb', 'has_organization', 'has_faq'],
    article: ['has_article', 'has_author', 'has_faq', 'has_how_to', 'has_organization', 'has_breadcrumb'],
    collection: ['has_faq', 'has_breadcrumb', 'has_organization'],
    page: ['has_how_to', 'has_breadcrumb', 'has_organization'],
};

// pagetype -> 预览/分数计算使用的 URL 前缀
const PAGE_URL_PREFIX_MAP = {
    product: 'products',
    collections: 'collections',
    blog: 'blogs',
    otherpage: 'pages',
};
// 根据类型拼接实体 URL
const buildEntityUrl = (type, set = {}) => {
    if (type === 'blog') {
        return `/blogs/${set?.blog_handle || ''}/${set?.handle || ''}`;
    }
    const prefix = PAGE_URL_PREFIX_MAP[type] || '';
    return `/${prefix}/${set?.handle || ''}`;
};

// 自动优化偏好默认值（仅产品类型，前端编辑态）
const DEFAULT_AUTO_OPT_PREFERENCES = {
    faq: 'relevant',        // 'relevant' | 'never'
    length: 'adaptive',     // 'adaptive' | 'custom'
    minWords: '200',
    maxWords: '500',
    instructions: '',
};

// 后端结构 -> 前端编辑态
// 后端结构: { faq, content_length: { mode, min, max }, instructions }
const normalizeAutoOptPref = (raw) => {
    if (!raw || typeof raw !== 'object') return { ...DEFAULT_AUTO_OPT_PREFERENCES };
    const contentLength = raw.content_length || {};
    return {
        faq: raw.faq === 'never' ? 'never' : 'relevant',
        length: contentLength.mode === 'custom' ? 'custom' : 'adaptive',
        minWords: contentLength.min != null ? String(contentLength.min) : DEFAULT_AUTO_OPT_PREFERENCES.minWords,
        maxWords: contentLength.max != null ? String(contentLength.max) : DEFAULT_AUTO_OPT_PREFERENCES.maxWords,
        instructions: typeof raw.instructions === 'string' ? raw.instructions : '',
    };
};

// 前端编辑态 -> 后端结构
const serializeAutoOptPref = (pref) => {
    const p = pref || DEFAULT_AUTO_OPT_PREFERENCES;
    return {
        faq: p.faq,
        content_length: {
            mode: p.length,
            min: Number(p.minWords) || 0,
            max: Number(p.maxWords) || 0,
        },
        instructions: p.instructions?.trim() || '',
    };
};

// 根据类型过滤 json_ld
const filterTypeJsonLd = (type, json_ld = null) => {
    if (!json_ld) return {};
    const PARTICIPATE_SCORING = {
        product: ['has_product', 'has_review', 'has_shipping', 'has_return', 'has_breadcrumb', 'has_faq'],
        article: ['has_article', 'has_faq', 'has_breadcrumb'],
        collection: ['has_breadcrumb'],
        page: ['has_breadcrumb'],
    };
    const fields = PARTICIPATE_SCORING[type] || [];
    let format_jsonld = {};
    fields.forEach((item) => {
        format_jsonld[item] = Boolean(json_ld[item]);
    });
    return format_jsonld;
};

const ContentAuditDetail = (props) => {

    const {
        level,
        windowWidth, // 获取窗口宽度

    } = props;

    // 计算wasm（首次调用时 WASM 可能尚未就绪，calculate 会返回 null，需延后执行）
    const { calculate, ready: protonReady } = useOnPageProton({
        wasmUrl: '/wasm/onpageproton.wasm',
    });

    const isShowSaveBarRef = useRef(false);
    const pendingScoreCalcRef = useRef(undefined);
    const isDetectFirstRef = useRef(true);
    // const isActivePreviewRef = useRef(false);
    // const isHoverPreviewRef = useRef(false);
    const keywordCoverageMouseTypeRef = useRef('');
    const fixImageRef = useRef('');
    const langeNameRef = useRef('');
    const startResearchRef = useRef(false);
    const startResearchTypeRef = useRef('');
    const overchargeNumRef = useRef(4);     // 开通超额数量
    const listParamsRef = useRef({});     // 列表参数
    const pagetypeRef = useRef('product');   // 始终保存最新的 pagetype，避免异步流程拿到闭包旧值
    const pageIdsRef = useRef({ productId: -1, collectionId: -1, collectionType: -1, blogId: -1, articleId: -1, pageId: -1 }); // 始终保存最新的页面 id，避免闭包旧值
    const isHeadingRef = useRef(2); // 1-正常 2-缺失 3-超出
    const intentPageTypeRef = useRef(''); // 意图选择类型
    const analysisTypeRef = useRef(''); // 分析类型
    const analysisReqTokenRef = useRef(0); // 分析请求令牌：切换产品/停止轮询时自增，用于丢弃过期(上一个产品)的异步响应

    // 筛选条件 ==============================================
    const productStatusData = [{
        label: t('Active'),
        value: 'Active',
    }, {
        label: t('Draft'),
        value: 'Draft',
    }, {
        label: t('Unlisted'),
        value: 'Unlisted',
    }]; // 产品状态
    const blogVisibleData = [{
        value: 1,
        label: t("Visible"),
    }, {
        value: 0,
        label: t("Hidden"),
    }]; // 博客可见数据
    const scoreListData = [{
        value: 0,
        label: `${t("Well Done")} (67-100)`,
    }, {
        value: 1,
        label: `${t("Can Be Improved")} (34-66)`,
    }, {
        value: 2,
        label: `${t("Critical Issues")} (0-33)`,
    }]; // 评分数据
    const focusKeywordListData = [{
        value: 1,
        label: t("With Keywords"),
    }, {
        value: 0,
        label: t("Without Keywords"),
    }]; // 关键词数据

    // 筛选条件 ==============================================

    // 页面状态
    const [paramsSet, setParamsSet] = useState(null);
    const [files, setFiles] = useState([]);
    const [isShowUpdOpt, setIsShowUpdOpt] = useState(false);
    const [isShowEditImg, setIsShowEditImg] = useState(false);
    const [editImageAltData, setEditImageAltData] = useState({});
    const [bulkAltConfig, setBulkAltConfig] = useState({});
    const [isShowKeywordTip, setIsShowKeywordTip] = useState(false);
    // const [contentAuditVMState, setContentAuditVMState] = useState(false);      // 内容审核视频弹窗
    const [historyRecordModalOpen, setHistoryRecordModalOpen] = useState(false);
    const [selectedHistoryVersionId, setSelectedHistoryVersionId] = useState(-1);
    const [sidePanel, setSidePanel] = useState('right');
    const [isOpenList, setIsOpenList] = useState(false); // 移动端左侧列表展开/收起
    const [pagesModalOpen, setPagesModalOpen] = useState(false); // 页面选择弹窗
    const [metaCollStatus, setMetaCollStatus] = useState(true);
    const [autoOptCompareKey, setAutoOptCompareKey] = useState(null); // 'title' | 'content' | 'meta' | 'tags' | null
    const [keywordCoverageCol, setKeywordCoverageCol] = useState(false);
    const [coverageTab, setCoverageTab] = useState('all');
    const [SEOChecklistCol, setSEOChecklistCol] = useState(false);
    const [searchPerformanceCol, setSearchPerformanceCol] = useState(false); // Search Performance 折叠状态
    const [gscConnecting, setGscConnecting] = useState(false); // GSC 授权链接中
    const [gscFailModalOpen, setGscFailModalOpen] = useState(false); // GSC 链接失败提示弹窗
    const [gscPermissionModalOpen, setGscPermissionModalOpen] = useState(false); // GSC 授权权限不足提示弹窗
    const [reviewPopupOpen, setReviewPopupOpen] = useState(false);
    const gscAuthTimerRef = useRef(null); // GSC 授权轮询定时器
    const gscAuthWinRef = useRef(null);   // GSC 授权弹窗引用
    // const [selectPageCount, setSelectPageCount] = useState(0); // 选择页面数量+
    const [selectPageIdArr, setSelectPageIdArr] = useState({
        product: [],
        blog: [],
        collections: [],
        homepage: [],
        otherpage: [],
    }); // 选择页面id列表
    const [issueListData, setIssueListData] = useState([{
        value: 1,
        label: `${t("All issue")} -`,
    }, {
        value: 6,
        label: `${t("SEO score issue")} -`,
    }, {
        value: 2,
        label: `${t("Alt text not added")} -`,
    }, {
        value: 3,
        label: `${t("Meta title issue")} -`,
    }, {
        value: 4,
        label: `${t("Meta description issue")} -`,
    }, {
        value: 5,
        label: `${t("H1 issue")} -`,
    }]); // 过滤问题标题
    // 独立模块状态 ==============================================
    const [pendingScoreCalc, setPendingScoreCalc] = useState(null); // 评分计算
    const [structureModalType, setStructureModalType] = useState(''); // 结构化数据弹窗类型
    const [fixLoadingType, setFixLoadingType] = useState(''); // 当前正在修复的检查项 key
    const [originalOptimizeData, setOriginalOptimizeData] = useState({}); // 原始自动优化数据
    const [autoOptimizeData, setAutoOptimizeData] = useState({}); // 自动优化数据
    const [autoOptimizeModalData, setAutoOptimizeModalData] = useState({}); // 自动优化弹窗数据
    const [descSetNumModal, setDescSetNumModal] = useState(0); // 富文本内容输入次数
    const [notSaveModalOpen, setNotSaveModalOpen] = useState(false); // 未保存弹窗
    const [nextStepType, setNextStepType] = useState(''); // 下一步类型
    const [unsaveConfirmLoading, setUnsaveConfirmLoading] = useState(false); // 未保存确认加载
    const [changeItemObjData, setChangeItemObjData] = useState({}); // 切换产品数据
    const [changeItemObjType, setChangeItemObjType] = useState('next'); // 切换产品类型 next | prev
    const [insertNextStepType, setInsertNextStepType] = useState(''); // 插入内链下一步类型
    const [insertConfirmLoading, setInsertConfirmLoading] = useState(false); // 插入内链确认加载
    const [autoOptimizeNextStepType, setAutoOptimizeNextStepType] = useState(''); // 自动优化下一步类型
    const [autoOptimizeConfirmLoading, setAutoOptimizeConfirmLoading] = useState(false); // 自动优化确认加载
    const [updOpenJSONLD, setUpdOpenJSONLD] = useState(false); // 更新JSON-LD弹窗
    const [optPurpleArray, setOptPurpleArray] = useState([]); // 优化对象数组 'titleValue', 'descValue', 'metaTitleValue', 'metaDescriptionValue', 'urlValue'
    const [isShowVideoAudit, setIsShowVideoAudit] = useState(true); // 是否显示视频审核
    const [rollbackLoading, setRollbackLoading] = useState(''); // 回退加载 title | desc | meta_tag
    const [structuredOptimize, setStructuredOptimize] = useState({}); // 结构化优化对象
    const [isShowOverExcessModal, setIsShowOverExcessModal] = useState(false); // 超额弹窗
    const [enableOverageLoading, setEnableOverageLoading] = useState(false); // 超额加载
    const [currentSelectedIntent, setCurrentSelectedIntent] = useState({}); // 当前选择意图
    const [fulfillmentTip, setFulfillmentTip] = useState(false); // 满足度提示
    // 月限制次数提示banner
    const [isShowMonthlyLimitBanner, setIsShowMonthlyLimitBanner] = useState(false); // 月限制次数提示banner
    const [isShowRepeatAnalysisBanner, setIsShowRepeatAnalysisBanner] = useState(false); // 重复分析提示banner
    // 当前页面数据
    const [pageInfoState, patchPageInfoState] = useObjectState({
        // c_id: -1,
        c_page: 1,
        c_size: 10,
    })
    const {
        // c_id,
        c_page,
        c_size,
    } = pageInfoState;
    // 独立模块状态 ==============================================


    // 页面公共状态
    const [pagePublicState, patchPagePublicState] = useObjectState({
        productState: 0,
        isPublishState: false,
        jsonLdTestUrl: '',
        noindex: 0,
        nofollow: 0,
        pagetype: 'blog',
        typeId: 1,
        domain: '',
        isShowSaveBar: false,
        setSaveLoading: false,
        curLanguageSel: '',
        isShowMoreLangTip: true,
        SheetTitle: '',
        isEditObjState: false,
        publishLoading: false,
        initState: false,
        itemNavPrevDisabled: true,
        itemNavNextDisabled: true,
        changeType: '',
        versionHistoryRecords: [],
        fromPage: 1,
        editableObj: [],
    });
    const {
        productState,
        isPublishState,
        jsonLdTestUrl,
        noindex,
        nofollow,
        pagetype,
        typeId,
        domain,
        isShowSaveBar,
        setSaveLoading,
        curLanguageSel,
        isShowMoreLangTip,
        SheetTitle,
        isEditObjState,
        publishLoading,
        initState,
        itemNavPrevDisabled,
        itemNavNextDisabled,
        changeType,
        versionHistoryRecords,
        fromPage,
        editableObj,
    } = pagePublicState;

    // 同步最新 pagetype 到 ref（兜底：正常的状态更新流程）
    useEffect(() => {
        pagetypeRef.current = pagetype;
    }, [pagetype]);

    // 配置状态
    const [settingState, patchSettingState] = useObjectState({
        descSetNum: 0,
        seo_score: 0,
        autoOriginScore: 0,
        autoOptScore: 0,
        aiLang: 'en',
        titleValue: '',
        targetKeywordValue: '',
        targetKeywordPreviewValue: '',
        countryValue: '',
        metaTitleValue: '',
        metaDescriptionValue: '',
        urlValue: '',
        panelState: '1',                                      // 1: 关键词面板 1-2: 分析中 2: 内容审核面板 3: 自动优化面板
        recommendKeywordsList: [],
        recommendLoading: false,
        product_use: [],
        creditsPoints: 0,
        aiUse: 0,
        ai_usage_status: 0,
        agreeLoading: false,
        previewUrl: '',
        LanguageList: [],
        isShowLangList: false,
        tLoading: false,
        langeName: 'Languages',
        isShowKeywordSugPop: false,
        keywordSugData: [],
        keywordSearchLoading: false,
        customeSetState: false,
        country_sel: {},
        aiLangLabel: '',
        searchSettingsModalState: false,
        cancelAutoOptModalOpen: false,
        descValue: "",
        TinyMceFocus: false,
        avg_score: 0,
        top_score: 0,
        wordsValue: 0,
        headingsValue: 0,
        paragraphsValue: 0,
        words_min: 0,
        words_max: 0,
        headings_min: 0,
        headings_max: 0,
        paragraphs_avg: 0,
        semantic_keywords: [],
        semantic_keywords_headings: [],
        coverageLens: 0,
        checklistData: [],
        checkLens: 0,
        insertLoading: false,
        intentResData: null,
        autoOptimizeLoading: false,
        researchLoading: false,
        isNeedUpdAnalysis: false,
        updAnalysisText: '',
        structured_data: {},
        isShowSuggestion: false,
        keywordTabSel: 'suggested',                           // 关键词建议tab: ranking(链接GSC后的排名关键词) | suggested(AI建议关键词)
        isGscConnected: false,                                // 是否已链接GSC（链接后展示 Ranking Keywords tab）
        rankingKeywordsList: [],                              // GSC排名关键词数据（search-performance queries）
        rankingLoading: false,                                // Ranking Keywords 加载状态
        searchPerformanceData: null,                          // GSC搜索性能聚合数据（current/previous/state）
        analysisError: false,
        recordData: null,
        activeKeyword: '',
        activeKeyStatus: 0,
        hoverKeyword: '',
        hoverKeyStatus: 0,
        activeTab: 'write_optimize', // write_optimize || research
        isShowRefreshAnalysis: false,
        featureImages: [],
        isHasImage: false,
        recordId: -1,
        settingChangeState: false,
        originSearchSettings: {},
        blog_handle: '',
        imageInfo: {},
        uploadLoading: false,
        inactiveNum: 0,
        metaTitleTip: '',
        metaDescriptionTip: '',
        cancelInsertOpen: false,
        intentLoading: true,
        startOverLoading: false,
        autoOptStructureSel: false,
        productTags: [],
        autoGenerateTagsLoading: false,
        recommendTags: [],            // AI 推荐的产品 Tags（不直接写入输入框）
        showRecommendTags: false,     // 是否展示推荐区域
        autoOptPrefModalOpen: false,                          // 自动优化偏好设置弹窗（仅产品类型）
        autoOptPrefSaveLoading: false,                        // 偏好设置保存中
        autoOptPreferences: { ...DEFAULT_AUTO_OPT_PREFERENCES }, // 已保存的偏好
        autoOptPrefDraft: { ...DEFAULT_AUTO_OPT_PREFERENCES },   // 弹窗内编辑中的偏好草稿
        isRepetitionKey: false, // 是否重复关键词
        isShowKeywordBannerTip: true, // 是否显示关键词banner提示
        isShowGscBanner: true,
        isShowRepetitionKeyBanner: true,
        isShowAccordTypeBanner: true,
        isShowCompetitorsModal: false,
        auto_optimize_pref: {},
        listKeywords: [],
        dominant_page_type: '',
        isUsePositionKeyword: false,
        isHeading: '',
        syncStructLoading: true,
    });
    const {
        descSetNum,
        seo_score,
        autoOriginScore,
        autoOptScore,
        aiLang,
        titleValue,
        targetKeywordValue,
        targetKeywordPreviewValue,
        countryValue,
        metaTitleValue,
        metaDescriptionValue,
        urlValue,
        panelState,
        recommendKeywordsList,
        recommendLoading,
        product_use,
        creditsPoints,
        aiUse,
        ai_usage_status,
        previewUrl,
        LanguageList,
        isShowLangList,
        tLoading,
        langeName,
        isShowKeywordSugPop,
        keywordSugData,
        keywordSearchLoading,
        customeSetState,
        country_sel,
        aiLangLabel,
        searchSettingsModalState,
        cancelAutoOptModalOpen,
        descValue,
        TinyMceFocus,
        avg_score,
        top_score,
        wordsValue,
        headingsValue,
        paragraphsValue,
        words_min,
        words_max,
        headings_min,
        headings_max,
        paragraphs_avg,
        semantic_keywords,
        semantic_keywords_headings,
        coverageLens,
        checklistData,
        checkLens,
        insertLoading,
        intentResData,
        autoOptimizeLoading,
        researchLoading,
        isNeedUpdAnalysis,
        updAnalysisText,
        structured_data,
        isShowSuggestion,
        keywordTabSel,
        isGscConnected,
        rankingKeywordsList,
        rankingLoading,
        searchPerformanceData,
        analysisError,
        recordData,
        activeKeyword,
        activeKeyStatus,
        hoverKeyword,
        hoverKeyStatus,
        activeTab,
        isShowRefreshAnalysis,
        featureImages,
        isHasImage,
        recordId,
        settingChangeState,
        originSearchSettings,
        blog_handle,
        imageInfo,
        uploadLoading,
        inactiveNum,
        metaTitleTip,
        metaDescriptionTip,
        cancelInsertOpen,
        intentLoading,
        startOverLoading,
        autoOptStructureSel,
        productTags,
        autoGenerateTagsLoading,
        recommendTags,
        showRecommendTags,
        autoOptPrefModalOpen,
        autoOptPrefSaveLoading,
        autoOptPreferences,
        autoOptPrefDraft,
        isRepetitionKey,
        isShowKeywordBannerTip,
        isShowGscBanner,
        isShowRepetitionKeyBanner,
        isShowAccordTypeBanner,
        isShowCompetitorsModal,
        auto_optimize_pref,
        listKeywords,
        dominant_page_type,
        isUsePositionKeyword,
        isHeading,
        syncStructLoading,
        
    } = settingState;

    // 页面列表状态
    const [pageListState, patchPageListState] = useObjectState({
        pageLoading: true,
        productId: -1,
        collectionId: -1,
        collectionType: -1,
        blogId: -1,
        articleId: -1,
        pageId: -1,
        page: 1,
        size: 10,
        total: 0,
        current_PageSize: 10,
        searchQuery: '',
        tableList: [],
        tableListLoading: true,
        selectItem: [],
        selectItemTag: '',
        selectItemTagNums: 0,
        issueValueSel: -1,
        seoScoreSel: [],
        focusKeywordSel: -1,
        onpage_BlogVisible: -1,
        onpage_ProductStatus: [],
        // FAQ / How-To schema 筛选 (对应后端 hasFaq / hasHowto; -1 表示不筛选) + Product Tag 多选 (productTags[]; 仅 product)
        faqSchemaSel: -1,
        howtoSchemaSel: -1,
        productTagSel: -1,
        productTagListData: [],
        selectedOptimize: [],
        listPre: false,
        listNext: false,
        shopName: '',
        initPageData: {},
        isTableAddLine: false,
        lastSelectItem: null,
        isShowErrorTip: '',
        productsStatus: [],
    });
    const {
        pageLoading,
        productId,
        collectionId,
        collectionType,
        blogId,
        articleId,
        pageId,
        page,
        size,
        total,
        current_PageSize,
        searchQuery,
        tableList,
        tableListLoading,
        selectItem,
        selectItemTag,
        selectItemTagNums,
        issueValueSel,
        seoScoreSel,
        focusKeywordSel,
        onpage_BlogVisible,
        onpage_ProductStatus,
        faqSchemaSel,
        howtoSchemaSel,
        productTagSel,
        productTagListData,
        selectedOptimize,
        listPre,
        listNext,
        shopName,
        initPageData,
        isTableAddLine,
        lastSelectItem,
        isShowErrorTip,
        productsStatus,

    } = pageListState;

    // 同步最新的页面 id 到 ref，避免异步流程/存入 state 的回调拿到闭包旧值
    useEffect(() => {
        pageIdsRef.current = { productId, collectionId, collectionType, blogId, articleId, pageId };
    }, [productId, collectionId, collectionType, blogId, articleId, pageId]);

    // 重复关键词监听
    useEffect(() => {
        if (listKeywords.length > 0) {
            let _keywords = listKeywords;
            let _type = pagetypeRef.current || pagetype;
            let _id = _type === 'blog' ? (pageIdsRef.current?.articleId || articleId) :
                _type === 'collections' ? (pageIdsRef.current?.collectionId || collectionId) :
                    Object.values(pageIdsRef.current).find(item => item !== -1);
            let isExistKeyword = _keywords.some(item => Number(item.source_id) !== Number(_id) && targetKeywordValue && (item.keyword).toLowerCase() === targetKeywordValue.toLowerCase());
            patchSettingState({
                isRepetitionKey: Boolean(isExistKeyword),
            })
        }
    }, [listKeywords, targetKeywordValue]);

    // 判断gsc链接状态 获取搜索性能数据
    useEffect(() => {
        let _id = Object.values({ productId, collectionId, articleId, pageId }).find(item => item !== -1);
        if (_id && _id !== -1) {
            getSearchPerformanceData(_id);  // 获取搜索性能数据
        }
    }, [isGscConnected, productId, collectionId, collectionType, blogId, articleId, pageId]);

    // 同步意图选择类型
    useEffect(() => {
        intentPageTypeRef.current = currentSelectedIntent?.dominant_page_type || dominant_page_type || '';
    }, [currentSelectedIntent, dominant_page_type]);

    // 统一收敛评分入参：任一相关字段变化时，都用最新 state 派生同一份入参
    const scoreInput = useMemo(() => {
        const p_type = pagetypeRef.current || pagetype;
        const buildImgTag = (src, alt) => src
            ? `<img src="${src}" alt="${String(alt ?? '').replace(/"/g, '&quot;')}" />`
            : '';
        // 产品是多图模式：把所有图片一起拼入内容参与评分（含 alt 检测）
        // 其它类型仍只用单张主图
        const m_img = p_type === 'product'
            ? (featureImages || []).map((img) => buildImgTag(img?.src || img?.data || '', img?.alt ?? img?.altText ?? '')).join('')
            : buildImgTag(imageInfo?.src, imageInfo?.alt);

        return {
            title: titleValue,
            content: descValue,
            meta_title: metaTitleValue,
            meta_description: metaDescriptionValue,
            url: buildEntityUrl(p_type, { blog_handle: blog_handle, handle: urlValue }),
            domain: domain,
            target_keyword: targetKeywordValue,
            json_ld: structured_data,
            m_img,
            product_tags: productTags,
            intentPageType: dominant_page_type || currentSelectedIntent?.dominant_page_type || intentPageTypeRef.current || '',
            c_panelState: panelState,
            isHeadingState: isHeading,
            ...recordData,
        };
    }, [
        titleValue, descValue, metaTitleValue, metaDescriptionValue,
        urlValue, blog_handle, domain, targetKeywordValue, structured_data,
        imageInfo, featureImages, productTags, panelState, currentSelectedIntent, recordData, pagetype, dominant_page_type,
        isHeading,
    ]);

    // 只在最新数据下计算分数（替代原先散落在意图/内容/主图等多处的手动触发）
    useEffect(() => {
        handleCalculateScore(scoreInput);
    }, [scoreInput]);

    // 国家状态
    const [countryState, patchCountryState] = useObjectState({
        nationState: false,
        languageState: false,
        isShowAudienceLocal: false,
        currents: {},
        countryView: [],
        countryLens: 0,
        locationId: 2840,
        cpage: 1,
        csize: 20,
    });
    const {
        nationState,
        languageState,
        isShowAudienceLocal,
        currents,
        countryView,
        countryLens,
        locationId,
        cpage,
        csize,
    } = countryState;

    // 关闭过的替换关键词提示（sessionStorage 缓存数组，元素为 `${pagetype}_${实体id}`，用 pagetype 前缀避免不同类型 id 重复）
    const [closedReplaceTipIds, setClosedReplaceTipIds] = useState({});

    // 滚动
    const scrollToSite = (type = 'top') => {
        let site = type === 'top' ? 0 : document.documentElement.scrollHeight;
        window.scrollTo({
            top: site,
            behavior: 'smooth',
        });
    }

    // 切换侧边栏
    const toggleSidePanel = () => setSidePanel((prev) => (prev === 'left' ? 'right' : 'left'));

    // 格式化文案，方便翻译
    const handleFormatText = (data = []) => {
        let newData = cloneDeep(data);
        newData.forEach(item => {
            item.origin = item.message;
            let _key = item.key;
            let _info = item.message;
            if (_key === "h2_count" && _info.includes(" H2 headings found.")) {
                let num = _info.split(" ")[0];
                item.message = t("{{v1}} H2 headings found.", num);
            } else if (_key === "internal_links" && _info.includes(" internal links found. (3–8 recommended)") && !_info.includes("No")) {
                let num = _info.split(" ")[0];
                item.message = t("{{v1}} internal links found. (3–8 recommended)", num);
            } else if (_key === "images" && _info.includes(" images found. All include alt text.") && !_info.includes("(")) {
                let num = _info.split(" ")[0];
                item.message = t("{{v1}} images found. All include alt text.", num);
            } else if (_key === "images" && _info.includes(" images found. All include alt text.") && _info.includes("(")) {
                let num1 = _info.split(" ")[0];
                let num2 = (_info.split("(")[1]).split(" ")[0];
                item.message = t("{{v1}} images found. All include alt text. ({{v2}} with empty alt)", num1, num2);
            } else if (_key === "images" && _info.includes(" images are missing alt text.") && !item.passed) {
                let num = _info.split(" ")[0];
                item.message = t("{{v1}} images are missing alt text.", num);
            } else { }
        })

        return newData;
    }

    // 计算分数
    const handleCalculateScore = (data = {}) => {
        if (!protonReady) {
            pendingScoreCalcRef.current = data;
            setPendingScoreCalc(data);
            return;
        }
        const { title, content, meta_title, meta_description, url, domain, words_min, words_max, headings_min, headings_max, paragraphs_avg, semantic_keywords, json_ld, avg_score, top_score, target_keyword, m_img, product_tags, intentPageType, c_panelState, isHeadingState } = data;
        let newContent = `${m_img}${content}`; // 需要把主图拼接到内容里统一计算
        let input = {
            title,
            content: newContent,
            meta_title,
            meta_description,
            url,
            domain,
            words_min,
            words_max,
            headings_min,
            headings_max,
            paragraphs_avg,
            semantic_keywords,
            target_keyword,
        }
        // 判断类型
        const s_type = getSourceType(pagetypeRef.current || pagetype);
        input.source_type = s_type;
        // json_ld
        input.json_ld = filterTypeJsonLd(s_type, json_ld);
        // 判断heading
        input.is_heading = Number(isHeadingState || isHeadingRef.current);
        // 是否存在分析记录
        input.is_analysis = !recordData?.record_id || recordData?.status === 2 ? false : true;
        // 意图 是否符合当前类型
        const accordType = {
            'product': "Product",
            'collection': "Collection",
            'article': "Blog Post",
            // 'page': "Other Page",
        }
        // 排除page
        if (s_type !== 'page') {
            const i_type = (intentPageType || intentPageTypeRef.current);
            input.keyword_type_match = !i_type ? true : Boolean(i_type && (accordType[s_type] === (intentPageType || intentPageTypeRef.current)));
        }
        // 产品特有tag
        if (s_type === 'product') {
            input.product_tags = product_tags;
        }

        const result = calculate(input);
        // console.log("分数检测：", data, input, result);
        if (!result || result?.error) {
            console.error('Error:', result?.error?.message || 'calculate error');
        } else {
            const _ = result;
            // 根据值keywords_score 从大到小排序
            let sk_all = _.semantic_keywords.sort((a, b) => Number(b.keywords_score) - Number(a.keywords_score));
            let sk_headings = sk_all.filter(e => e.headings_df_max > 0);
            let coverageLens = sk_all.filter(e => e.total_matched > 0).length;
            let checklistData = handleFormatText(_.checklist_items);
            let checkLens = checklistData.filter(e => e.passed === true).length;
            patchSettingState({
                seo_score: _.score,
                autoOptScore: c_panelState !== '3' ? 0 : (autoOptScore > 0 && autoOptScore > autoOriginScore) ? autoOptScore : _.score,
                avg_score,
                top_score,
                wordsValue: _.structure_detail.word_count.value,
                words_min: _.structure_detail.word_count.min,
                words_max: _.structure_detail.word_count.max,
                headingsValue: _.structure_detail.headings_count.value,
                headings_min: _.structure_detail.headings_count.min,
                headings_max: _.structure_detail.headings_count.max,
                paragraphsValue: _.structure_detail.paragraphs_count.value,
                paragraphs_avg: _.structure_detail.paragraphs_count.avg,
                semantic_keywords: sk_all,
                semantic_keywords_headings: sk_headings,
                coverageLens,
                checklistData,
                checkLens,
            })

            // 把分数更新到左侧列表对应项
            if (startResearchRef.current) {
                handleUpdListScore(getCurrentEntityId(), _.score);
            }

        }
    };

    useEffect(() => {
        if (!protonReady) return;
        if (pendingScoreCalcRef.current === undefined) return;
        const pending = pendingScoreCalcRef.current;
        pendingScoreCalcRef.current = undefined;
        handleCalculateScore(pending);
    }, [protonReady, pendingScoreCalc]);

    // 超过 2 个月时，按整月/整年显示更新时间
    const getUpdAnalysisText = useCallback((time) => {
        if (!time) return '';

        const updatedAt = new Date(time * 1000);
        const now = new Date();

        let totalMonths = (now.getFullYear() - updatedAt.getFullYear()) * 12 + (now.getMonth() - updatedAt.getMonth());
        if (now.getDate() < updatedAt.getDate()) {
            totalMonths -= 1;
        }

        if (totalMonths < 2) return '';

        if (totalMonths >= 12) {
            const years = Math.floor(totalMonths / 12);
            return `Updated ${years} ${years === 1 ? 'year' : 'years'} ago`;
        }

        return `Updated ${totalMonths} ${totalMonths === 1 ? 'month' : 'months'} ago`;
    }, []);

    // 更新数据
    const updJsonldTriggered = async (id) => {
        isDetectFirstRef.current = false;
        let params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: id,
        }
        const res = await reqDetectStructuredState(params);
        if (res.ack === 1) {
            isHeadingRef.current = res.data.is_heading;
            patchSettingState({
                isHeading: res.data.is_heading,
                syncStructLoading: false,
            })
            return res.data;
        }
        return null;
    }

    // 结构化内容保存后，以实时检测结果覆盖 structured_data 中已有的同名字段。
    const updStructuredDataByDetect = async () => {
        const _id = getCurrentEntityId();
        const _pagetype = pagetypeRef.current || pagetype;
        let params = {
            sourceType: getSourceType(_pagetype),
            id: _id,
        }
        const res = await reqDetectStructuredState(params);
        if (res.ack === 1) {
            isHeadingRef.current = res.data.is_heading;
            patchSettingState((prev) => {
                const nextStructuredData = mergeDetectedStructuredData(prev.structured_data, res.data);
                const typeFields = STRUCTURED_DATA_TYPE_FIELDS[getSourceType(_pagetype)] || STRUCTURED_DATA_TYPE_FIELDS.product;
                const inactiveNum = Object.keys(nextStructuredData).filter(item => ([
                    "has_product", "has_article", "has_faq", "has_how_to", "has_breadcrumb", "has_organization"
                ].includes(item) && typeFields.includes(item) && nextStructuredData[item] === 0)).length;

                return {
                    structured_data: nextStructuredData,
                    inactiveNum,
                    isHeading: res.data.is_heading,
                };
            });
        }
    }

    // 清除定时器
    const clearTypeInterval = (type) => {
        switch (type) {
            case 'timerArr':
                // 令牌自增：让本轮已发出但尚未返回的分析请求响应失效，避免旧产品数据回填到新产品详情
                analysisReqTokenRef.current++;
                timerArr.map(timer => {
                    clearInterval(timer);
                    timerArr.pop();
                    return false;
                })
                break;
            case 'aiTimerArr':
                aiTimerArr.map(timer => {
                    clearInterval(timer);
                    aiTimerArr.pop();
                    return false;
                })
                break;
            default:
                break;
        }
    }

    // 获取关键词ai建议
    const handleGetAiSuggestionData = async (value) => {
        patchSettingState({
            isShowSuggestion: true,
            recommendLoading: true,
            keywordTabSel: 'suggested', // 点击AI建议后默认切到 Suggested Keywords tab
        })
        let ptype = pagetypeRef.current || pagetype;
        let params = {
            title: value,
            product_id: getCurrentEntityId(),
            page_type: ptype === 'otherpage' ? 'page' : ptype
        };
        const res = await reqAiKeywordSuggestion(params);
        if (Number(res.code) === 1000) {
            patchSettingState({
                isShowSuggestion: false,
                recommendLoading: false,
                recommendKeywordsList: [],
            })
            props.handleShowGetMoreUsageModal('onpage', product_use);
        } else if (res.ack === 1) {
            let formatData = res.data.filter(i => typeof i !== 'string');
            let singleData = formatData.map((item, index) => {
                return {
                    id: `${item.keyword}-${index}`,
                    keyword: item.keyword,
                    competition: item.competition,
                    volume: item.volume,
                }
            })
            patchSettingState({
                recommendLoading: false,
                recommendKeywordsList: singleData,
            })
        } else {
            patchSettingState({
                isShowSuggestion: false,
                recommendLoading: false,
                recommendKeywordsList: [],
            })
            props.toggleToast(t("Try again later"), true)
        }
    }

    // 根据当前 pagetype 从 state 取对应实体 id（用于用户交互场景，闭包状态已是最新）
    const getCurrentEntityId = () => {
        const type = pagetypeRef.current || pagetype;
        switch (type) {
            case 'product': return productId;
            case 'collections': return collectionId;
            case 'blog': return articleId;
            case 'otherpage': return pageId;
            default: return productId;
        }
    };

    // 从传入 data 中按类型解析实体 id，兼容历史的 article_id 字段
    const resolveAnalysisId = (data = {}) => {
        if (data.id !== undefined && data.id !== null) return data.id;
        return getCurrentEntityId();
    };

    useEffect(() => {
        if (!rankingLoading && (rankingKeywordsList || [])?.length > 0 && !(targetKeywordValue.trim())) {
            let newRecord = cloneDeep(recordData);
            let gscFirstKeyword = String(rankingKeywordsList[0]?.keyword || '');
            if (newRecord) {
                newRecord.keyword = gscFirstKeyword;
            }
            patchSettingState({
                targetKeywordValue: gscFirstKeyword,
                targetKeywordPreviewValue: gscFirstKeyword,
                recordData: newRecord,
                isUsePositionKeyword: true,
            })
        } else {
            patchSettingState({
                isUsePositionKeyword: false,
            })
        }
    }, [targetKeywordValue, rankingLoading, rankingKeywordsList])

    // 获取搜索性能数据（GSC）: queries 列表用于 Ranking Keywords tab
    // 说明: 初次进入/异步流程下闭包里的实体 id 可能仍是默认值(-1)，因此优先取传入的 data.id，
    // 再回退到 getCurrentEntityId()（与 getBlogAnalysisData 保持一致）
    const getSearchPerformanceData = async (id) => {
        patchSettingState({ rankingLoading: true });
        let params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id,
        }
        const res = await reqGetSearchPerformance(params);
        if (res && res.ack === 1 && res.data) {
            const _data = res.data;
            const queries = Array.isArray(_data.queries) ? _data.queries : [];
            const rankingList = queries.map((item, index) => ({
                id: `${item.keyword}-${index}`,
                keyword: item.keyword,
                clicks: item.clicks,
                impressions: item.impressions,
                ctr: item.ctr,
                position: item.position,
            }));
            patchSettingState({
                rankingLoading: false,
                rankingKeywordsList: rankingList,
                searchPerformanceData: {
                    state: _data?.state,
                    current: _data?.current || null,
                    previous: _data?.previous || null,
                    synced_at: _data?.synced_at || null,
                },
            });
            // patchSettingState((prev) => {
            //     const next = {
            //         rankingLoading: false,
            //         rankingKeywordsList: rankingList,
            //         searchPerformanceData: {
            //             state: _data?.state,
            //             current: _data?.current || null,
            //             previous: _data?.previous || null,
            //             synced_at: _data?.synced_at || null,
            //         },
            //     };
            //     // 页面关键词为空、GSC 已链接且有 ranking 数据时，自动使用第一条 query 关键词
            //     if (prev.isGscConnected && !prev.targetKeywordValue?.trim() && rankingList.length > 0) {
            //         const firstKeyword = rankingList[0].keyword;
            //         next.targetKeywordValue = firstKeyword;
            //         next.targetKeywordPreviewValue = firstKeyword;
            //     }
            //     return next;
            // });
        } else {
            patchSettingState({
                rankingLoading: false,
                rankingKeywordsList: [],
            });
        }
    }

    // 停止 GSC 授权状态轮询
    const stopGscPolling = () => {
        if (gscAuthTimerRef.current) {
            clearInterval(gscAuthTimerRef.current);
            gscAuthTimerRef.current = null;
        }
    };

    // 轮询 GSC 绑定状态：授权成功后标记已链接并拉取搜索性能数据
    const checkGscBindState = async () => {
        try {
            const res = await reqGetGscBindState();
            const data = (res && res.data) || {};
            const state = Number(data.state);
            if (res && Number(res.code) === 200 && state === 1) {
                stopGscPolling();
                setGscConnecting(false);
                if (gscAuthWinRef.current && !gscAuthWinRef.current.closed) gscAuthWinRef.current.close();
                patchSettingState({ isGscConnected: true });
                props.toggleToast(t("Google Search Console connected"), false);
                // getSearchPerformanceData(getCurrentEntityId()); // 链接成功后拉取搜索性能数据
            } else if (state === 2) {
                // 授权权限不足
                stopGscPolling();
                setGscConnecting(false);
                if (gscAuthWinRef.current && !gscAuthWinRef.current.closed) gscAuthWinRef.current.close();
                setGscPermissionModalOpen(true);
            } else if (!gscAuthWinRef.current || gscAuthWinRef.current.closed) {
                // 弹窗已关闭且未连接成功，停止轮询
                stopGscPolling();
                setGscConnecting(false);
                // 打开失败链接弹窗
                setGscFailModalOpen(true);
            }
        } catch (e) {
            stopGscPolling();
            setGscConnecting(false);
        }
    };

    // 链接 GSC：打开 Google 授权弹窗并轮询绑定状态
    const handleConnectGsc = async () => {
        if (gscConnecting) return;
        setGscConnecting(true);
        try {
            const response = await reqGetJumpGoogleapisAuth();
            if (response && response.ack === 1 && response.data?.jump_url) {
                // 关闭
                patchSettingState({
                    searchSettingsModalState: false,
                })
                const iWidth = 650;
                const iHeight = 700;
                const iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                const iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                gscAuthWinRef.current = window.open(
                    response.data.jump_url,
                    "",
                    `height=${iHeight},innerHeight=${iHeight},width=${iWidth},innerWidth=${iWidth},top=${iTop},left=${iLeft},status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no`
                );
                stopGscPolling();
                gscAuthTimerRef.current = setInterval(checkGscBindState, 2000);
            } else {
                props.toggleToast(t(response?.msg || "Failed"), true);
                setGscConnecting(false);
            }
        } catch (e) {
            setGscConnecting(false);
        }
    };

    // 卸载时清理 GSC 授权轮询
    useEffect(() => {
        return () => stopGscPolling();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 获取分析数据
    const getBlogAnalysisData = async (data = {}, type = 'init') => {
        // 读取最新的 pagetype（异步流程下闭包里的 pagetype 可能仍是旧值）
        analysisTypeRef.current = type;
        const _pagetype = pagetypeRef.current || pagetype;
        const _id = resolveAnalysisId(data);
        if (_id === -1 || _id === undefined || _id === null) return;
        // 记录本次请求发起时的令牌与目标实体，用于响应回来后校验是否仍是当前详情
        const _reqToken = analysisReqTokenRef.current;
        let params = {
            sourceType: getSourceType(_pagetype),
            id: _id,
        }
        let res = await reqGetAuditAnalysis(params);
        // 过期响应保护：响应回来时，若期间已切换产品/停止轮询（令牌变化），或当前详情的页面类型/实体 id 已不同，
        // 直接丢弃本次响应，避免上一个产品最后一次未返回的数据(如关键词)污染新产品详情
        const _curPagetype = pagetypeRef.current || pagetype;
        const _curIds = pageIdsRef.current || {};
        const _curId = _curPagetype === 'blog' ? _curIds.articleId
            : _curPagetype === 'collections' ? _curIds.collectionId
                : _curPagetype === 'otherpage' ? _curIds.pageId
                    : _curIds.productId;
        if (_reqToken !== analysisReqTokenRef.current || _pagetype !== _curPagetype || String(_id) !== String(_curId)) {
            return;
        }
        if (res.ack === 1) {
            // 定义数据
            const _t = res.data;
            const _record = _t.record;
            const updAnalysisText = getUpdAnalysisText(_record?.last_created_at); // 两个月及以上

            // 更新公共
            intentPageTypeRef.current = _record?.dominant_page_type || '';
            patchSettingState({
                isNeedUpdAnalysis: !!updAnalysisText,   // 是否需要重新分析
                updAnalysisText,
                dominant_page_type: _record?.dominant_page_type || '',
            });
            patchPageListState({
                pageLoading: false,
            });

            // 获取首页默认语言和地区数据
            let _store = store.getState().public.publicInit;
            let no_r_c_lang = _store.shop_data?.content_language || 'en';
            let no_r_c_local = (_store.shop_data?.audience_location || 'US').toLowerCase();
            let no_r_selectArea = Countrys.find(item => (item.abb.toLowerCase()).indexOf(no_r_c_local) > -1) || Countrys[0];
            // 未存在记录，默认显示分析模块
            if (!_record) {
                patchSettingState({
                    isShowRefreshAnalysis: false,
                    analysisError: false,
                    panelState: '1',
                    aiLang: no_r_c_lang,
                    aiLangLabel: AiLanguageArr.find(item => item.value.toLowerCase() === no_r_c_lang)?.label || 'English',
                    country_sel: no_r_selectArea,
                    researchLoading: false,
                });
                selectCountryData(no_r_selectArea);
            }

            // 是否更新jsonld结构数据
            let latestStructuredData = _t.structured_data || {};
            if ((!_t.json_ld_triggered && isDetectFirstRef.current) || type === 'init') {
                const detectedStructuredData = await updJsonldTriggered(_id);
                latestStructuredData = mergeDetectedStructuredData(latestStructuredData, detectedStructuredData);
                isDetectFirstRef.current = false;

                // 检测请求期间可能已切换详情，避免旧页面的检测结果覆盖当前页面。
                const latestPagetype = pagetypeRef.current || pagetype;
                const latestIds = pageIdsRef.current || {};
                const latestId = latestPagetype === 'blog' ? latestIds.articleId
                    : latestPagetype === 'collections' ? latestIds.collectionId
                        : latestPagetype === 'otherpage' ? latestIds.pageId
                            : latestIds.productId;
                if (_reqToken !== analysisReqTokenRef.current || _pagetype !== latestPagetype || String(_id) !== String(latestId)) {
                    return;
                }
            }

            // 调用分数计算api
            let _page = type === 'init' ? data : {
                title: titleValue,
                body_html: descValue,
                seo_title: metaTitleValue,
                seo_desc: metaDescriptionValue,
                handle: urlValue,
                shop_domain: domain,
                blog_handle: blog_handle,
                primaryKeywords: targetKeywordPreviewValue || targetKeywordValue,
                product_tags: productTags || [],
            };
            let _set = _page?.initPageData || _page;
            let m_img = imageInfo?.src ? `<img src="${imageInfo.src}" alt="${imageInfo.alt}" />` :
                _set?.images?.length > 0 ? `<img src="${_set.images[0].src}" alt="${_set.images[0].alt}" />` : '';  // 主图
            let s_params = {
                title: _set?.title || titleValue,
                content: _set?.body_html || descValue,
                meta_title: _set?.seo_title || metaTitleValue,
                meta_description: _set?.seo_desc || metaDescriptionValue,
                url: buildEntityUrl(_pagetype, _set),
                domain: domain,
                json_ld: latestStructuredData,
                // has_faq: Boolean(latestStructuredData?.has_faq),
                // has_article: Boolean(latestStructuredData?.has_article),
                target_keyword: _record?.keyword || _set.primaryKeywords,
                m_img,
                product_tags: _set?.product_tags || productTags || [],
                c_panelState: panelState,
            }

            // 设置区域信息
            let _area = (_record?.location || no_r_c_local || 'US').toLowerCase();
            let selectArea = Countrys.find(item => (item.abb.toLowerCase()).indexOf(_area) > -1) || Countrys[0];
            let _lang = _record?.language || no_r_c_lang || 'en';
            let selectLang = AiLanguageArr.find(item => item.value.toLowerCase() === _lang.toLowerCase())?.label || 'English';
            // 计算inactive数量（只统计当前页面类型下、且本应用可管理的字段）
            const s_type = getSourceType(_pagetype);
            const _typeFields = STRUCTURED_DATA_TYPE_FIELDS[s_type] || STRUCTURED_DATA_TYPE_FIELDS.product;
            let inactiveNum = Object.keys(latestStructuredData).filter(item => ([
                "has_product", "has_article", "has_faq", "has_how_to", "has_breadcrumb", "has_organization"
            ].includes(item) && _typeFields.includes(item) && latestStructuredData[item] === 0)).length;

            // 设置数据
            patchSettingState({
                country_sel: selectArea,
                aiLangLabel: selectLang,
                aiLang: _lang,
                structured_data: latestStructuredData,
                inactiveNum,
                recordData: _record,
                recordId: _record?.record_id || -1,
                originSearchSettings: {
                    keyword: _record?.keyword || targetKeywordPreviewValue || targetKeywordValue,
                    language: _lang,
                    location: selectArea?.abb,
                }
            })

            // 存在即复用
            if (_record?.keyword) {
                patchSettingState({
                    targetKeywordValue: _record?.keyword,
                })
            }

            selectCountryData(selectArea); // 设置国家信息
            // 判断分析状态 '0:未执行 1:完成 2:舍弃'
            let startResearchType = startResearchTypeRef.current; // 开始分析类型
            let keyColState = ['re-intent', 'refresh'].includes(type) ? keywordCoverageCol : true;
            let c_panelState = ['re-intent', 'refresh'].includes(type) ? panelState : (
                ((startResearchType === 'panel') || (startResearchType === 'modal' && panelState.includes('1'))) ? '1-2' : '2-2'
            );  // 如果开始分析类型为面板或模态框且面板状态为1，则设置为1-2，否则设置为2-2
            if (_record?.status === 0) {
                setKeywordCoverageCol(keyColState);
                patchSettingState({
                    panelState: c_panelState,
                    researchLoading: true,
                    isShowRefreshAnalysis: true,
                    analysisError: false,
                });
                // 未执行 - 轮询
                if (timerArr.length === 0) {
                    let timer = setInterval(() => {
                        getBlogAnalysisData(data, type);
                    }, 3000);
                    timerArr.push(timer);
                }
            } else if (_record?.status === 1) {
                // 分析完成 - 调用分数计算api
                patchSettingState({
                    panelState: '2',
                    isShowRefreshAnalysis: false,
                    analysisError: false,
                    researchLoading: false,
                });
                s_params = {
                    ...s_params,
                    ..._record
                }
                // 接口刚返回、state 未提交，用本次拉到的数据即时算分（此路径不走统一 effect）
                handleCalculateScore(s_params);
                getIntentData(params.sourceType, _id, _record.record_id);   // 获取意图数据
            } else if (_record?.status === 2) {
                // 失败
                setKeywordCoverageCol(keyColState);
                patchSettingState({
                    panelState: '1-2',
                    analysisError: true,
                    researchLoading: false,
                });
            } else {
                handleCalculateScore(s_params);
            }

            // 如果状态不是0，则清除轮询定时器
            if (_record?.status !== 0) {
                clearTypeInterval('timerArr');
            }

            patchSettingState({ startOverLoading: false })
        }
    }

    // 获取页面列表
    const getPageList = async (data = null, issueSel = -1, isFrist = false, isUpdateInfo = false, language = null, upDetail = true, loading = true, _new = {}) => {
        // 页面类型（用 ref 读取最新值，避免初始化同步流程拿到闭包旧值）
        const _pagetype = pagetypeRef.current || pagetype;

        // 动态参数
        const _page = _new.state ? (_new?.page ?? page) : (data?.page ?? page);
        const _size = _new.state ? (_new?.size ?? size) : (data?.size ?? size);
        // 不能用 `||`：清空搜索时 searchQuery 为 '' 会被当成 falsy 而回退到旧值
        const _queryValue = _new.state ? (_new.searchQuery !== undefined ? _new.searchQuery : searchQuery) : searchQuery;
        const _selectedOptimize = _new.state ? (_new.selectedOptimize !== undefined ? _new.selectedOptimize : selectedOptimize) : selectedOptimize;
        const _onpage_ProductStatus = _new.state ? (_new.onpage_ProductStatus !== undefined ? _new.onpage_ProductStatus : onpage_ProductStatus) : onpage_ProductStatus;
        const _onpage_BlogVisible = _new.state ? (_new.onpage_BlogVisible !== undefined ? _new.onpage_BlogVisible : onpage_BlogVisible) : onpage_BlogVisible;
        const _focusKeywordSel = _new.state && _new.focusKeywordSel !== undefined ? _new.focusKeywordSel : focusKeywordSel;
        // FAQ / How-To schema + Product Tag 筛选 (与列表页 OnPageSeoTable 的 hasFaq / hasHowto / productTags 对齐)
        const _faqSchemaSel = _new.state && _new.faqSchemaSel !== undefined ? _new.faqSchemaSel : faqSchemaSel;
        const _howtoSchemaSel = _new.state && _new.howtoSchemaSel !== undefined ? _new.howtoSchemaSel : howtoSchemaSel;
        const _productTagSel = _new.state && _new.productTagSel !== undefined ? _new.productTagSel : productTagSel;

        // 设置loading
        patchPageListState({ tableListLoading: loading });
        let params = Boolean(paramsSet) ? {
            ...paramsSet,
        } : {
            selectedActive: "",
            selectedImg: "",
            selectMetaTitle: "",
            selectMetaDesc: "",
            selectHeading: "",
            selectDetect: "",
            selectUrlsUnderScores: "",
            selectSeoCheck: '',
            orderBy: '',
            selectId: 0,
        };
        params.page = _page;
        params.size = _size;
        params.q = _queryValue;
        params.type = _pagetype;
        // 分数筛选
        params.selectedOptimize = _selectedOptimize || [];
        // 问题筛选
        if (issueSel > 0) {
            if (issueSel === 99) {
                params.selectedActive = 'Active';
            } else {
                params.selectIssue = Number(issueSel);
            }
        } else {
            delete params.selectIssue;
        }

        // Onpage 产品状态
        if (_pagetype === 'product') {
            if (_onpage_ProductStatus !== -1) {
                params.productsStatus = _onpage_ProductStatus || [];
            } else {
                delete params.productsStatus;
            }
        }
        // Onpage 博客可见状态
        if (_pagetype === 'blog') {
            params.selectedActive = _onpage_BlogVisible === -1 ? '' : _onpage_BlogVisible[0] === 1 ? 'Active' : 'Hidden';
        }
        // 是否设置关键词（与 _new 同步，避免批量清空时仍用闭包里的旧值）
        if (_focusKeywordSel !== -1) {
            params.is_keyword = _focusKeywordSel[0];
        } else {
            if (Object.keys(params).includes("is_keyword")) {
                delete params.is_keyword;
            }
        }

        // FAQ schema 筛选 (hasFaq: 1 有 / 0 无; 四类页面均支持)
        const _faqVal = Array.isArray(_faqSchemaSel) ? _faqSchemaSel[0] : _faqSchemaSel;
        if (_faqVal === 0 || _faqVal === 1) {
            params.hasFaq = _faqVal;
        } else {
            delete params.hasFaq;
        }
        // How-To schema 筛选 (hasHowto: 1 有 / 0 无; 仅 blog / otherpage)
        const _howtoVal = Array.isArray(_howtoSchemaSel) ? _howtoSchemaSel[0] : _howtoSchemaSel;
        if ((_howtoVal === 0 || _howtoVal === 1) && ['blog', 'otherpage'].includes(_pagetype)) {
            params.hasHowto = _howtoVal;
        } else {
            delete params.hasHowto;
        }
        // Product Tag 多选筛选 (productTags[]; 仅 product, 最多 50 个 OR 精确匹配)
        if (_pagetype === 'product' && Array.isArray(_productTagSel) && _productTagSel.length > 0) {
            params.productTags = _productTagSel.slice(0, 50);
        } else {
            delete params.productTags;
        }

        // 小语种更新
        if (Boolean(language)) {
            params.language = language;
        } else {
            delete params.language;
        }
        let res = {};
        if (Boolean(data) && Boolean(data?.tableRes)) {
            res = data.tableRes;
        } else {
            res = await reqGetOnPageList(params);
        }

        listParamsRef.current = params;

        if (res.code === 200) {
            let getData = res.data;
            // 默认选择第一项
            let selectId = [];
            let obj = {
                tableListLoading: false,
                tableList: getData.result,
                total: res.data.count,
                listPre: _page > 1,
                listNext: _page < Math.ceil(res.data.count / _size),
                shopName: getData.shopName,
                changeTypeLoading: false,
                page: _page,
                size: _size,
            }
            if (isUpdateInfo) {
                getUserComboByCard(language);
            }
            if (getData.result?.length > 0 && !isFrist) {
                selectId = [Number(getData.result[0]['id'])];
                if (_pagetype === 'product') {
                    obj.productId = getData.result[0]['id'];
                } else if (_pagetype === 'collections') {
                    obj.collectionId = getData.result[0]['id'];
                    obj.collectionType = getData.result[0]['collection_type'];
                } else if (_pagetype === 'blog') {
                    obj.blogId = getData.result[0]['blog_id'];
                    obj.articleId = getData.result[0]['article_id'];
                } else if (_pagetype === 'otherpage') {
                    obj.pageId = getData.result[0]['id'];
                } else { }
                if (_pagetype === 'blog') {
                    obj.selectItem = getData.result[0]['article_id'];
                } else {
                    obj.selectItem = selectId;
                }
            }

            // 设置状态
            patchPageListState(obj);

            //更新状态
            if (selectId?.length > 0 && !isFrist && !isEditObjState) {
                getPageDetailData(null, true, false, null, true, {
                    productId: obj.productId,
                    collectionId: obj.collectionId,
                    collectionType: obj.collectionType,
                    blogId: obj.blogId,
                    articleId: obj.articleId,
                    pageId: obj.pageId
                });
            }
            if (!upDetail && isEditObjState) {
                changeLanguageDetail(curLanguageSel, langeName, true, false);
            }
            return { ok: true, rows: getData.result || [], res };
        }
        patchPageListState({ tableListLoading: false });
        return { ok: false };
    }
    // 防抖
    const debouncedGetPageList = debounce((value) => {
        getPageList(...value);
    }, 300);

    const sendDataToMain = (info = '', _type = 'url') => {
        const wpener = window.opener;
        if (!wpener) return;
        if (_type === 'url') {
            const { url, objs, _state, _query } = info;
            wpener.postMessage({ mode: 'UpgradeOpener', url, objs, _state, _query }, window.location.origin);
        } else if (_type === 'publish') {
            wpener.postMessage({ mode: 'UpdatePublish', data: info }, window.location.origin);
        } else {
            wpener.postMessage({ page: 'Edit', mode: info }, window.location.origin);
        }
    };

    // 获取意图数据
    const getIntentData = async (sourceType, id, record_id) => {
        patchSettingState({ intentLoading: true });
        let params = {
            sourceType,
            id,
            record_id,
        }
        const res = await reqGetAuditAnalysisIntents(params);
        patchSettingState({
            intentResData: res,
        })
        if (res.ack !== 1) {
            setErrorBanner(res.msg);
        } else {
            const _t = res.data;
            let _list = _t?.intents || [];      // 意图数据
            // 需要判断选择文章是在哪个意图下, 不存在选择推荐
            let c_obj = _t?.selected_intent_id ? _list.find(item => item.id === _t.selected_intent_id) : _list.find(item => item.type === 1) || {};  // 推荐意图数据
            // 设置
            setCurrentSelectedIntent(c_obj);
        }
        patchSettingState({ intentLoading: false });
    }

    // 更新页面详情
    const updatePageDetail = (isDiscard, detailData) => {
        const _t = detailData;
        if (!_t) return;

        let formImgDataIdArr = [], fformImgDataArr = [];
        if ((pagetypeRef.current || pagetype) !== 'otherpage') {
            if (_t?.images) {
                for (let i = 0; i < _t?.images.length; i++) {
                    formImgDataIdArr.push(_t.images[i].id);
                    fformImgDataArr.push(_t.images[i].alt);
                }
            }
        }

        patchSettingState({
            targetKeywordValue: _t.primaryKeywords ?? '',
            targetKeywordPreviewValue: _t.primaryKeywords ?? '',
            titleValue: _t.title ?? '',
            metaTitleValue: _t.seo_title ?? '',
            metaDescriptionValue: _t.seo_desc ?? '',
            urlValue: _t.handle ?? '',
            imageInfo: _t?.images?.[0] || {},
            featureImages: _t.images ?? [],
            isHasImage: _t.images?.length > 0 ? true : false,
            blog_handle: _t.blog_handle ?? '',
            productTags: _t.product_tags ?? [],
            recommendTags: [],
            showRecommendTags: false,
        });
    };

    // 重新获取上次选中数据
    function reGetLastData() {
        const item = lastSelectItem;
        if (!item) return;
        const obj = item?.id ? { productId: item.id } : item;
        patchPageListState(obj);
        getPageDetailData(null, true, false, null, true, { ...item });
    }

    // 获取页面详情
    async function getPageDetailData(data = null, isGetAnalysis = true, isGetList = false, language = null, isLoading = true, state = {}) {
        startResearchRef.current = false; // 重置开始研究状态
        if (isLoading) {
            patchPageListState({ pageLoading: true });
        }
        const types = pagetypeRef.current || pagetype;
        let response = {};
        // 页面类型（用 ref 读取最新值，避免初始化同步流程拿到闭包旧值）
        let { productId, collectionId, articleId, pageId, id } = state;
        const s_id = types === 'product' ? productId : types === 'collections' ? collectionId : types === 'blog' ? articleId : types === 'otherpage' ? pageId : id;
        let params = {
            sourceType: getSourceType(types),
            id: id && id !== -1 ? id : s_id,
        };
        if (Boolean(data)) {
            response = data;
        } else {
            response = await reqGetPageDetailData(params);
        }

        const codeOk = (c) => String(c) === '200' || c === 200;
        const code400 = (c) => String(c) === '400' || c === 400;

        if (!response) {
            return;
        }

        if (codeOk(response.code)) {
            patchPagePublicState({ isShowSaveBar: false }); // 隐藏保存bar
            isShowSaveBarRef.current = false;
            setCoverageTab('all');
            // 清空选择页面id列表
            setSelectPageIdArr({
                product: [],
                blog: [],
                collections: [],
                homepage: [],
                otherpage: [],
            })

            let getData = cloneDeep(response.data);
            isHeadingRef.current = getData.is_heading;
            const publicPatch = {};
            if (isTableAddLine && Boolean((getData.body_html || '').includes('<table'))) {
                getData.body_html = formatTableHtml(getData.body_html);
            }
            let v_record = (getData?.upd_logs || []).map((item, index) => {
                return {
                    id: item.version,
                    title: index === 0 ? t('Original Version') : t('Previous Version'),
                    description: index === 0 ? t('The initial version when the audit started') : t('The last saved version before changes'),
                    timeLabel: utils.timeFormat(item.updated_at),
                    data: item
                }
            }).reverse();
            patchPageListState({
                initPageData: getData,
                selectItem: types === 'blog' ? [Number(getData.article_id)] : [Number(getData.id)],
                lastSelectItem: params,

            });

            patchPagePublicState({
                initState: true,
                SheetTitle: getData.title,
                changeType: '',
                isPublishState: Boolean(getData?.published_status),
                versionHistoryRecords: v_record,
                jsonLdTestUrl: getData?.json_ld_test || '',
                noindex: getData?.noindex ?? 0,
                nofollow: getData?.nofollow ?? 0,
                productState: getData?.product_status || '',
                ...publicPatch,
            });
            patchSettingState({
                descValue: getData.body_html ?? '',
                // 切换实体：关闭富文本查找浮层并清空关键词，避免沿用上一个产品的查找态
                activeKeyword: '',
                activeKeyStatus: 0,
                // 始终保存带域名的完整预览前缀；窄屏截断仅用于输入框展示，避免 View 打开相对路径继承当前域名 404
                previewUrl: getData.preview_url || '',
                insertLoading: false,
                autoOptimizeLoading: false,
                keywordSugData: [],
                auto_optimize_pref: getData.auto_optimize_pref ?? {},
                autoOptPreferences: normalizeAutoOptPref(getData?.auto_optimize_pref),
                isHeading: getData.is_heading,
            });
            updatePageDetail(false, getData);

            if (isGetList) {
                const selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
                getPageList(null, issueValueSel, true, true, selState);
            }

            // 关闭 SEO 检查清单和搜索性能列
            setSEOChecklistCol(false);
            setSearchPerformanceCol(false);

            // 获取分析数据（product/collections/blog/otherpage 均支持）
            if (isGetAnalysis) {
                // 按类型取实体 id（state 参数已是最新，避免闭包旧值）
                const _analysisId = params.id;
                let obj = {
                    id: _analysisId,
                    initPageData: {
                        title: getData.title,
                        body_html: getData.body_html,
                        seo_title: getData.seo_title,
                        seo_desc: getData.seo_desc,
                        handle: getData.handle,
                        shop_domain: getData.shop_domain,
                        blog_handle: getData.blog_handle,
                        primaryKeywords: getData.primaryKeywords,
                        images: getData.images,
                        product_tags: getData?.product_tags || [],
                    }
                }
                getBlogAnalysisData(obj, 'init');
            }

            // 设置路由参数
            handleSetRouteParams(types, { productId, collectionId, collectionType, blogId, articleId, pageId });
        } else if (code400(response.code)) {
            reGetLastData();
            patchPageListState({
                isShowErrorTip: 'Switch failed. The selected page no longer exists.',
            });
            updatePageDetail(false, initPageData);
            const selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
            getPageList(null, issueValueSel, true, true, selState);
        } else {
            patchPageListState({
                isShowErrorTip: response.msg,
            });
            reGetLastData();
        }
    }

    //获取用户套餐数量卡片
    const getUserComboByCard = async (lang = '') => {
        let type = pagetypeRef.current || pagetype;
        let params = { type, is_opt: 1 };
        if (Boolean(lang)) {
            params['language'] = lang;
        } else {
            delete params['language'];
        }
        const res = await reqUserComboByCard(params);
        if (res.ack === 1) {
            let _data = res.data;
            // 格式化问题选择列表
            let newIssueData = Object.keys(_data.issuesCount).map(item => {
                let text = item === 'all_issues' ? 'All issue' :
                    item === 'alt_issues' ? 'Alt text not added' :
                        item === 'title_issues' ? 'Meta title issue' :
                            item === 'desc_issues' ? 'Meta description issue' :
                                item === 'heading_issues' ? 'H1 issue' :
                                    item === 'score_issues' ? 'SEO score issue' : '';
                let value = item === 'all_issues' ? 1 :
                    item === 'alt_issues' ? 2 :
                        item === 'title_issues' ? 3 :
                            item === 'desc_issues' ? 4 :
                                item === 'heading_issues' ? 5 :
                                    item === 'score_issues' ? 6 : 0;

                return _data.issuesCount[item] > 0 && {
                    label: `${t(text)} (${_data.issuesCount[item]})`,
                    value: value
                }
            })

            // 博客不添加
            if (type !== 'blog') {
                newIssueData.push({
                    label: t("Published"),
                    value: 99,
                })
            }

            // 设置问题列表
            setBulkAltConfig(_data.bulkAltConfig);
            setIssueListData(newIssueData.filter(item => Boolean(item)));
            // 产品标签候选 (仅产品类型返回; 不受分页/筛选影响), 供详情页搜索模块的 Product Tag 筛选使用
            patchPageListState({ productTagListData: Array.isArray(_data.productTags) ? _data.productTags : [] });
            patchSettingState({
                creditsPoints: _data.productQuota.ai_points,
                aiUse: _data.productQuota.ai_points_gift_use + _data.productQuota.ai_points_paid_use,
                ai_usage_status: _data.ai_usage_status,
                product_use: _data.productQuota.product_use,
                isGscConnected: Boolean(_data.gsc_status),
                listKeywords: _data.keywords,
            })
            setStructuredOptimize(_data.structured_optimize)

            // 评价问卷卡片：进入页面时按接口状态（res.data.reviewPopup）决定是否展示
            if (_data.reviewPopup?.shouldShow === true) {
                setReviewPopupOpen(true);
            }
        }
    }

    // 开始重做
    const handleStartOver = async () => {
        patchSettingState({ startOverLoading: true });

        let params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: getCurrentEntityId(),
            record_id: recordId
        }
        const res = await reqDiscardAuditAnalysis(params);
        if (res.ack === 1) {
            // 重新获取分析数据
            // getBlogAnalysisData({ id: getCurrentEntityId() }, 'poll');
            // 重新发起分析
            handleStartResearch('panel');
        } else {
            props.toggleToast(t(res.msg), true);
            patchSettingState({ startOverLoading: false })
        }
    }

    // 设置下拉语言状态
    const setLanguageListState = (type, list = []) => {
        let data = cloneDeep(list);
        data.forEach(item => {
            if (item['abbr'] === type) {
                item['active'] = true;
            } else {
                item['active'] = false;
            }
        })
        patchSettingState({
            LanguageList: data,
        })
    }

    // 判断是否显示保存|舍弃
    const handleShowOperaButton = (_state = false) => {
        isShowSaveBarRef.current = _state;
        patchPagePublicState({
            isShowSaveBar: _state,
        })
        const isShopify = window.shopify;
        if (isShopify) {
            if (_state) {
                sendDataToMain("showSavebar", 'savebar');
            } else {
                sendDataToMain("hideSavebar", 'savebar');
            }
        }
    }

    //改版 语言选择器
    const handleImportedAction = (lang) => {
        try {
            sessionStorage.setItem('aiLanguage', lang);
        } catch (e) { }
    }

    // 格式化返回数据
    const formatLanguageValue = (data, type) => {
        if (data.length === 0) {
            return ''
        } else {
            let objs = data.filter(i => i['key'] === type);
            if (objs.length > 0) {
                return objs[0]['value'];
            } else {
                return '';
            }
        }
    }

    useEffect(() => {
        setLanguageListState(curLanguageSel, LanguageList);
    }, [curLanguageSel]);

    // 切换语种数据
    const changeLanguageDetail = async (type, name, state, isObj = true, ids = {}) => {
        if (name === langeNameRef.current && isObj) {
            patchSettingState({
                isShowLangList: false,
            })
            return false;
        } else {
            setIsShowEditImg(false);
            if (!Boolean(state)) {
                // 切换回主语言列表
                getPageList(null, issueValueSel, true, true);
            } else {
                if (isObj) {
                    getPageList(null, issueValueSel, true, true, type, true);
                }
            }
            handleShowOperaButton(false);
            // 更新公共状态
            patchPagePublicState({
                curLanguageSel: type,
            })
            patchPageListState({
                pageLoading: true,
                isShowErrorTip: '',
            })
            langeNameRef.current = name;
            patchSettingState({
                isShowLangList: false,
                langeName: name,
                descSetNum: 0,
            })
            handleImportedAction(type);
            scrollToSite('top'); // 返回顶部

            // 从 ref 读取最新的页面 id，避免存入 state 的 onAction 回调拿到闭包旧值
            let latestIds = pageIdsRef.current;
            let i_data = Object.keys(ids).length > 0 ? ids : latestIds;

            // 设置id和类型
            let _type = pagetypeRef.current || pagetype;
            let id = _type === 'product' ? (i_data?.productId || latestIds.productId) :
                _type === 'collections' ? (i_data?.collectionId || latestIds.collectionId) :
                    _type === 'blog' ? (i_data?.articleId || latestIds.articleId) :
                        _type === 'otherpage' ? (i_data?.pageId || latestIds.pageId) : -1;
            let ptype = _type === 'product' ? 'product' :
                _type === 'collections' ? 'collection' :
                    _type === 'blog' ? 'blog' :
                        _type === 'otherpage' ? 'page' : '';
            if (!Boolean(state)) {
                // 切换回主语言
                patchPagePublicState({
                    isEditObjState: false,
                })
                getPageDetailData(null, true, false, null, true, i_data);
            } else {
                // 进行小语种数据获取
                let params = {
                    "data_id": id,
                    "page_type": ptype,
                    "language": type
                }
                const res = await reqGetTrResources(params);
                if (res.ack === 1) {
                    setSidePanel('left');
                    let getData = res.data;
                    // 更新状态
                    patchPagePublicState({
                        SheetTitle: getData.original.filter(i => i['key'] === 'title')[0]['value'],
                        changeType: '',
                        editableObj: getData.original,
                        isEditObjState: Boolean(state),
                        initState: true,
                    })

                    patchSettingState({
                        targetKeywordValue: getData.keyword,
                        titleValue: formatLanguageValue(getData.translate, 'title'),
                        descValue: formatLanguageValue(getData.translate, 'body_html'),
                        metaTitleValue: formatLanguageValue(getData.translate, 'meta_title'),
                        metaDescriptionValue: formatLanguageValue(getData.translate, 'meta_description'),
                        urlValue: getData.handle,
                        previewUrl: getData.preview_url,
                        productTags: getData.product_tag ?? [],
                        recommendTags: [],
                        showRecommendTags: false,
                    })
                    let initPageData = {
                        title: formatLanguageValue(getData.translate, 'title'),
                        body_html: formatLanguageValue(getData.translate, 'body_html'),
                        seo_title: formatLanguageValue(getData.translate, 'meta_title'),
                        seo_desc: formatLanguageValue(getData.translate, 'meta_description'),
                        handle: getData.handle,
                        primaryKeywords: getData.keyword,
                        images: [],
                    }
                    patchPageListState({
                        initPageData,
                    })

                    // 设置路由参数
                    handleSetRouteParams(pagetype, i_data);
                    // getUserAiDetails(type);
                    // setEmptyMetaTagValue(false);
                    //调用请求SEO检测
                    // seoTesting(true, getData.keyword);
                } else {
                    setErrorBanner(res.msg);
                }
                if (res) {
                    patchPageListState({
                        pageLoading: false,
                    })
                }

            }
        }
    }

    // 选择翻译
    const changeSelectLanguage = async (isVerify = false, lang = '', list = []) => {
        if (isShowSaveBarRef.current) {
            handleChangeSavebarState(true, 'changeSelectLanguage');
            return;
        } else if (list.length > 0) {
            patchSettingState({
                isShowLangList: !isShowLangList,
            })
        } else {
            patchSettingState({
                tLoading: true,
            })
            const res = await reqSelectDetailLanguage();
            if (res.ack === 1) {
                let data = res.data;
                let langList = [];
                (data?.all_lang || []).forEach(item => {
                    if (Boolean(item['primary'])) {
                        langList.unshift({
                            active: false,
                            disabled: false,
                            abbr: item['locale'],
                            content: item['localeName'],
                            suffix: <Badge tone="attention">{t("Primary")}</Badge>,
                            onAction: () => changeLanguageDetail(item['locale'], item['localeName'], false),
                        })
                    } else {
                        langList.push({
                            active: false,
                            disabled: !Boolean(Object.keys(data.sup_lang).includes(item['locale'])),
                            abbr: item['locale'],
                            content: <div>
                                {
                                    !Boolean(Object.keys(data.sup_lang).includes(item['locale'])) ?
                                        <Tooltip content={t("Not Supported")}>
                                            <div>{item['localeName']}</div>
                                        </Tooltip> : <div>{item['localeName']}</div>
                                }
                            </div>,
                            onAction: () => changeLanguageDetail(item['locale'], item['localeName'], true),
                        })
                    }
                })
                patchSettingState({
                    isShowLangList: isVerify ? false : true,
                    LanguageList: langList,
                })
                // 判断是否传参跳转
                if (Boolean(isVerify)) {
                    let pLang = (data?.all_lang || []).filter(i => i['primary']); // 主语言
                    let nameObj = (data?.all_lang || []).filter(i => i['locale'].includes(lang));
                    let name = nameObj.length > 0 ? nameObj[0]['localeName'] : '';
                    // 判断是否主语言
                    if (pLang[0]['locale'].includes(lang)) {
                        changeLanguageDetail(lang, name, false, false);
                    } else {
                        changeLanguageDetail(lang, name, true, true);
                    }
                }
            } else if (res.ack === 1000) {
                patchSettingState({
                    isShowAuthModal: true,
                    authUrl: res.url,
                })
            } else {
                patchSettingState({
                    isShowErrorTip: res.msg,
                })
            }

            if (res) {
                patchSettingState({
                    tLoading: false,
                })
            }
        }
    }

    // 设置页面数据
    const handleSetPageData = (objData = {}) => {
        // 参数兼容
        const params = new URLSearchParams(window.location.search);
        let obj = {}, typeId = 0;
        if (objData) {
            if (Boolean(['google', 'more-action', 'KeywordContentPlanner', 'AiBlogGenerator-detail', 'StructuredData'].includes(objData?.from || ''))) {
                let t = objData;
                obj.pagetype = t.action === 'product' ? 'product' : t.action === 'collection' ? 'collections' : t.action === 'article' ? 'blog' : t.action === 'page' ? 'otherpage' : 'blog';
                if (t.action === "product") {
                    typeId = 0;
                    obj.productId = t.id;
                    obj.lastSelectItem = { productId: t.id };
                } else if (t.action === "collection") {
                    typeId = 2;
                    obj.collectionId = t.id;
                    obj.collectionType = t.collection_type;
                    obj.lastSelectItem = {
                        collectionId: t.collectionId,
                        collectionType: t.collectionType,
                    };
                } else if (t.action === "article") {
                    typeId = 1;
                    obj.articleId = t.id;
                    obj.blogId = t.blog_id;
                    obj.lastSelectItem = {
                        blogId: t.blogId,
                        articleId: t.articleId,
                    };
                } else if (t.action === "page") {
                    typeId = 4;
                    obj.pageId = t.id;
                    obj.lastSelectItem = { pageId: t.id };
                } else { }
                obj.selectItem = [Number(t.id)];
            } else {
                if (Boolean(objData)) {
                    let t = cloneDeep(objData);
                    // 生成博客内容跳转
                    if (t.type === 'generate-blog') {
                        typeId = 1;
                        obj.blogId = t.blogId;
                        obj.articleId = t.articleId;
                        obj.selectItem = [t.articleId];
                        obj.issueValueSel = -1;
                        obj.initPageData = null;
                        obj.pagetype = 'blog';
                        obj.isTableAddLine = true;
                    } else {
                        obj = {
                            // pagetype: t.pagetype,
                            SheetTitle: t.title,
                            changeType: '',
                            tableRes: t.tableList,
                            initPageData: t.initPageData,
                            issueListData: t.issueListData,
                            selectItemTag: Boolean(t.issueCheck) ? t.issueCheck[0] : '',
                            selectItemTagNums: Boolean(t.issueCheck) ? t.issueCheck[1] : 0,
                            paramsSet: Boolean(t.issueCheck) ? t.issueCheck[2] : null,
                            page: Boolean(t.issueCheck) ? t.issueCheck[2].page : 1,
                            size: Boolean(t.issueCheck) ? t.issueCheck[2].size : 10,
                            current_PageSize: Boolean(t.issueCheck) ? t.issueCheck[2].size : 10,
                            searchQuery: Boolean(t.issueCheck) ? t.issueCheck[2].q : '',
                            pagetype: Boolean(t.issueCheck) ? t.issueCheck[2].type : 'blog',
                            issueValueSel: t.issueSel ? t.issueSel : Boolean(t.issueCheck) ? t.issueCheck[2].selectIssue : -1,
                            seoScoreSel: Boolean(t?.issueCheck[3]) ? t.issueCheck[3] : -1,
                            selectedOptimize: Boolean(t.issueCheck[3]) ? t.issueCheck[3] : [],
                            productsStatus: Boolean(t.issueCheck[4]) ? t.issueCheck[4] : [],
                            onpage_ProductStatus: Boolean(t.issueCheck[4]) ? t.issueCheck[4] : [],
                            focusKeywordSel: Boolean(t.issueCheck[2]?.is_keyword >= 0) ? [t.issueCheck[2]?.is_keyword] : -1,
                            // FAQ / How-To schema + Product Tag 筛选: 从列表页带入的 paramsSet 还原, 与详情页搜索模块同步
                            faqSchemaSel: (t.issueCheck[2]?.hasFaq === 0 || t.issueCheck[2]?.hasFaq === 1) ? [t.issueCheck[2].hasFaq] : -1,
                            howtoSchemaSel: (t.issueCheck[2]?.hasHowto === 0 || t.issueCheck[2]?.hasHowto === 1) ? [t.issueCheck[2].hasHowto] : -1,
                            productTagSel: (Array.isArray(t.issueCheck[2]?.productTags) && t.issueCheck[2].productTags.length > 0) ? t.issueCheck[2].productTags : -1,
                            seo_score: t.initPageData.seo_score,
                            onpage_BlogVisible: Boolean(t.issueCheck && t.issueCheck[2]?.selectedActive) ? (t.issueCheck[2]?.selectedActive === 'Active' ? [1] : [0]) : -1,
                        }
                        if (Boolean(t.issueCheck[3])) {
                            t.issueCheck[2].selectedOptimize = t.issueCheck[3];
                            obj.selectedOptimize = t.issueCheck[3];
                            obj.seoScoreSel = t.issueCheck[3];
                        }
                        if (t.pagetype === "product") {
                            obj.productId = t.productId;
                            typeId = 0;
                            obj.lastSelectItem = { productId: t.productId };
                        } else if (t.pagetype === "collections") {
                            obj.collectionId = t.collectionId;
                            obj.collectionType = t.collectionType;
                            typeId = 2;
                            obj.lastSelectItem = {
                                collectionId: t.collectionId,
                                collectionType: t.collectionType,
                            };
                        } else if (t.pagetype === "blog") {
                            obj.blogId = t.blogId;
                            obj.articleId = t.articleId;
                            typeId = 1;
                            obj.lastSelectItem = {
                                blogId: t.blogId,
                                articleId: t.articleId,
                            };
                        } else if (t.pagetype === "otherpage") {
                            obj.pageId = t.pageId;
                            typeId = 4;
                            obj.lastSelectItem = { pageId: t.pageId };
                        } else { }

                        if (t.pagetype === "blog") {
                            obj.selectItem = [Number(obj.initPageData?.data?.article_id)];
                        } else {
                            obj.selectItem = [Number(obj.initPageData?.data?.id)];
                        }
                    }
                }
            }
        }
        // 设置固定状态值
        // obj.windowWidth = window.innerWidth;
        obj.typeId = typeId;
        // 同步最新 pagetype，保证后续同步触发的 getPageDetailData / getBlogAnalysisData 能拿到正确类型
        if (obj.pagetype) {
            pagetypeRef.current = obj.pagetype;
        }
        // app 跳转参数
        if (params.get('id')) {
            let t = params.get('action');
            let lang = params.get('language');
            // 判断跳转哪个类别
            obj.pagetype = t === 'product' ? 'product' : t === 'collection' ? 'collections' : t === 'article' ? 'blog' : t === 'page' ? 'otherpage' : 'product';
            pagetypeRef.current = obj.pagetype;
            if (t === 'product') {
                obj.productId = Number(params.get('id'));
                obj.lastSelectItem = { productId: Number(params.get('id')) };
            } else if (t === 'collection') {
                obj.collectionId = Number(params.get('id'));
                obj.collectionType = Number(params.get('collection_type'));
                obj.lastSelectItem = {
                    collectionId: Number(params.get('id')),
                    collectionType: Number(params.get('collection_type')),
                };
            } else if (t === 'article') {
                obj.blogId = Number(params.get('blog_id'));
                obj.articleId = Number(params.get('id'));
                obj.lastSelectItem = {
                    blogId: Number(params.get('blog_id')),
                    articleId: Number(params.get('id')),
                };
            } else if (t === 'page') {
                obj.pageId = Number(params.get('id'));
                obj.lastSelectItem = { pageId: obj.pageId };
            }
            obj.selectItem = [Number(params.get('id'))]; // 选中id

            // 是否存在语言
            if (Boolean(lang)) {
                obj.isEditObjState = true;
                obj.curLanguageSel = lang;
                changeSelectLanguage(true, lang);
            } else {
                getUserComboByCard('');
                getPageList(obj, -1, true); // 获取侧边列表
                let { productId, collectionId, collectionType, blogId, articleId, pageId } = obj;
                getPageDetailData(null, true, false, null, true, { productId, collectionId, collectionType, blogId, articleId, pageId });
            }
        } else {
            // 不带参数跳转
            getUserComboByCard('');
            if (!Boolean(objData)) {
                getPageList(obj, -1, false); // 获取侧边列表
            } else {
                getPageList(obj, obj.issueValueSel, true); // 获取侧边列表
                let { productId, collectionId, collectionType, blogId, articleId, pageId } = obj;
                getPageDetailData(obj.initPageData, true, false, null, true, { productId, collectionId, collectionType, blogId, articleId, pageId });
            }
        }

        // 筛选条件
        setParamsSet(obj.paramsSet);
        // 设置状态
        patchPageListState(pickDefinedFields(obj, [
            'page',
            'size',
            'current_PageSize',
            'issueValueSel',
            'selectedOptimize',
            'seoScoreSel',
            'issueListData',
            'selectItemTag',
            'selectItemTagNums',
            'searchQuery',
            'onpage_ProductStatus',
            'focusKeywordSel',
            'onpage_BlogVisible',
            'faqSchemaSel',
            'howtoSchemaSel',
            'productTagSel',
            'productId',
            'collectionId',
            'collectionType',
            'articleId',
            'blogId',
            'pageId',
            'selectItem',
            'initPageData',
            'isTableAddLine',
            'productsStatus',
            'lastSelectItem',

        ]))
        patchPagePublicState(pickDefinedFields(obj, [
            'pagetype',
            'typeId',
            'SheetTitle',
            'changeType',
            'isEditObjState',
            'curLanguageSel',

        ]));
        patchSettingState(pickDefinedFields(obj, [
            'seo_score',
            'descValue',
        ]));
    }

    // 关键词搜索
    const handleKeywordSearch = async (value) => {
        let params = {
            keyword: value,
            location_id: locationId,
            language: aiLang,
        }
        const res = await reqGetKeywordSearch(params);
        let formatData = []
        if (res.ack === 1) {
            formatData = (res.data.slice(0, 5)).map(item => {
                return {
                    keyword: item.keyword,
                    competition: item.competition,
                    volume: item.volume,
                }
            })
            formatData.unshift({
                keyword: "Keyword",
                competition: "Competition",
                volume: "Volume",
            })
            patchSettingState({
                keywordSugData: formatData,
            });
        } else {
            // setTipBanner(res.msg);
            patchSettingState({
                isShowKeywordSugPop: false,
            });
        }
        patchSettingState({
            keywordSearchLoading: false,
        });
    }
    const debouncedKeywordSearch = useMemo(() => debounce((value) => {
        if (value) {
            handleKeywordSearch(value);
        } else {
            patchSettingState({
                isShowKeywordSugPop: false,
                keywordSearchLoading: false,
            });
        }
    }, 1000), [handleKeywordSearch]); // 300ms 可根据需求调整

    // 判断上下页面详情内容 切换是否禁用
    const handleDisabledPageChange = () => {
        const rawId = Array.isArray(selectItem) ? selectItem[0] : selectItem;
        const idArr = tableList.map(item => getListRowKey(item));
        if (!idArr.includes(rawId)) {
            return;
        }
        const rawIndex = idArr.indexOf(rawId);
        const disPrev = (page === 1 && rawIndex === 0) ? true : false;
        const disNext = (page === Math.ceil(total / size) && rawIndex === tableList.length - 1) ? true : false;
        patchPagePublicState({
            itemNavPrevDisabled: disPrev,
            itemNavNextDisabled: disNext,
        });
    }

    const getListRowKey = useCallback(
        (row) => (pagetype === 'blog' ? Number(row.article_id) : Number(row.id)),
        [pagetype],
    );

    // 上下页面详情内容 切换（跨页仅复用 getPageList，与底部分页一致）
    const handlePageItemChange = (type) => {
        // 保存判断
        if (isShowSaveBarRef.current) {
            setChangeItemObjType(type);
            handleChangeSavebarState(true, 'handlePageItemChange');
            return;
        }

        setIsShowEditImg(false);
        patchPagePublicState({
            SheetTitle: '',
            changeType: type,
        })
        const run = async () => {
            if (pageLoading || tableListLoading) {
                return;
            }
            const rawId = Array.isArray(selectItem) ? selectItem[0] : selectItem;
            if (rawId === undefined || rawId === null || rawId === '') {
                return;
            }
            const currentId = Number(rawId);
            const idx = tableList.findIndex((row) => getListRowKey(row) === currentId);
            const selLang = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;

            // 如果不存在，代表在其他页
            if (idx === -1) {
                const targetPage = c_page;
                const targetSize = c_size;
                const out = await getPageList(null, issueValueSel, true, false, selLang, true, true, {
                    state: true,
                    page: targetPage,
                    size: targetSize,
                });
                if (!out?.ok || !out.rows?.length) {
                    patchPagePublicState({ changeType: '' });
                    return;
                }
                const idx = (out.rows).findIndex((row) => getListRowKey(row) === currentId);
                let objs = out.rows[0];
                if (idx !== -1) {
                    // 判断是不是最后一个或者第一个
                    if ((type === 'prev' && idx === 0) || (type === 'next' && idx === out.rows.length - 1)) {
                        objs = out.rows[idx];
                    } else {
                        objs = type === 'next' ? out.rows[idx + 1] : out.rows[idx - 1];
                    }
                }
                handleChangeItemObj(objs);
                return;
            }

            if (type === 'next') {
                if (idx < tableList.length - 1) {
                    handleChangeItemObj(tableList[idx + 1]);
                    return;
                }
                if (!listNext) {
                    return;
                }
                const targetPage = page + 1;
                const out = await getPageList(null, issueValueSel, true, false, selLang, true, true, {
                    state: true,
                    page: targetPage,
                    size,
                });
                if (!out?.ok || !out.rows?.length) {
                    return;
                }
                handleChangeItemObj(out.rows[0]);
                return;
            }

            if (type === 'prev') {
                if (idx > 0) {
                    handleChangeItemObj(tableList[idx - 1]);
                    return;
                }
                if (!listPre) {
                    return;
                }
                const targetPage = page - 1;
                const out = await getPageList(null, issueValueSel, true, false, selLang, true, true, {
                    state: true,
                    page: targetPage,
                    size,
                });
                if (!out?.ok || !out.rows?.length) {
                    return;
                }
                handleChangeItemObj(out.rows[out.rows.length - 1]);
            }
        };
        void run();
    };

    // 选择国家
    const togglePopSelect = (type) => {
        if (type === "nationState") {
            patchCountryState({ nationState: !nationState });
            resetCountryData();
        } else if (type === "languageState") {
            patchCountryState({ languageState: !languageState });
        }
    }

    // 重置数据
    const resetCountryData = () => {
        if (nationState) {
            let oData = Countrys.slice(0, 20);
            let lens = Countrys.length;
            patchCountryState({
                cpage: 1,
                csize: 20,
                countryView: oData,
                countryLens: lens,
            });
            patchSettingState({ countryValue: '' });
        }
    }

    // 选中国家
    const selectCountryData = (data) => {
        patchCountryState({
            currents: data,
            nationState: false,
            locationId: data.id,
        });
        try {
            sessionStorage.setItem('nationData', JSON.stringify(data));
        } catch (e) { }
        resetCountryData();
    }

    // 获取更多国家
    const getMoreCountry = () => {
        if (countryValue) {
            let searchVal = countryValue.toLowerCase();
            let newData = Countrys.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
            let firstArr = [];
            let lastArr = [];
            newData.forEach(item => {
                if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                    firstArr.push(item);
                } else {
                    lastArr.push(item);
                }
            })
            newData = [...firstArr, ...lastArr];
            patchCountryState({
                countryView: newData.slice(0, (cpage + 1) * csize),
                countryLens: newData.length,
                cpage: cpage + 1,
            });
        } else {
            patchCountryState({
                countryView: Countrys.slice(0, (cpage + 1) * csize),
                cpage: cpage + 1,
            });
        }

    }

    // 国家数据格式化
    const changeCountryData = (val) => {
        let searchVal = val.toLowerCase();
        let newData = Countrys.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
        let firstArr = [];
        let lastArr = [];
        newData.forEach(item => {
            if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                firstArr.push(item);
            } else {
                lastArr.push(item);
            }
        })
        newData = [...firstArr, ...lastArr];
        patchCountryState({
            countryView: newData.slice(0, 20),
            countryLens: newData.length,
            cpage: 1,
            csize: 20,
        });
    }

    // 清空筛选条件
    const clearFilterTag = () => {
        setParamsSet(null);
        patchPageListState({
            selectItemTag: '',
            selectItemTagNums: 0,
        });
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, -1, true, false, selState);
    }

    /** 清空全部 */
    const handleFiltersClearAll = () => {
        setParamsSet(null);
        const newState = {
            state: true,
            searchQuery: '',
            issueValueSel: -1,
            seoScoreSel: -1,
            selectedOptimize: [],
            focusKeywordSel: -1,
            onpage_ProductStatus: -1,
            onpage_BlogVisible: -1,
            faqSchemaSel: -1,
            howtoSchemaSel: -1,
            productTagSel: -1,
            page: 1,
            size: 10,
            current_PageSize: 10,
        };
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, -1, true, false, selState, true, true, newState);
    };

    // 选择分类
    const setIssueTypeChange = (e) => {
        let issueVal = e === -1 ? -1 : Number(e[0]);
        let newState = {
            state: true,
            issueValueSel: issueVal,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueVal, true, false, selState);
    }

    // 搜索
    const handleSetSearchQuery = useCallback((val) => {
        let params = cloneDeep(listParamsRef.current);
        let stateObj = {
            state: true,
            searchQuery: val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        let newState = {
            ...params,
            ...stateObj,
        }
        patchPageListState(stateObj);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        debouncedGetPageList([null, -1, true, false, selState, true, true, newState]);
    }, [isEditObjState, curLanguageSel]);

    // 选中产品切换数据
    const handleChangeItemObj = (data) => {
        // 选中产品切换数据
        if (pageLoading || tableListLoading) {
            return false;
        }

        // 判断内容是否发生改变
        if (isShowSaveBarRef.current) {
            // 内容未保存 弹窗提示
            handleChangeSavebarState(true, 'handleChangeItemObj');
            setChangeItemObjData(data);
        } else {
            // 自动优化判断 || 插入判断
            if (insertLoading || autoOptimizeLoading) {
                return false;
            }

            clearTypeInterval('timerArr'); // 清除定时器
            scrollToSite('top'); // 返回顶部
            let types = pagetype;
            isDetectFirstRef.current = true;
            let obj = {
                pageLoading: true,
                isShowErrorTip: '',
                seo_score: 0,
                selectItem: pagetype === 'blog' ? [Number(data.article_id)] : [Number(data.id)],
                initState: false,
                descSetNum: 0,
                isGscConnected: false,
                isShowKeywordBannerTip: true,
                isShowGscBanner: true,
                isShowRepetitionKeyBanner: true,
                isShowAccordTypeBanner: true,
                isShowCompetitorsModal: false,
            };
            if (types === 'product') {
                obj.productId = data.id;
            } else if (types === 'collections') {
                obj.collectionId = data.id;
                obj.collectionType = data.collection_type;
            } else if (types === 'blog') {
                obj.blogId = data.blog_id;
                obj.articleId = data.article_id;
            } else if (types === 'otherpage') {
                obj.pageId = data.id;
            } else { }
            // 初始化状态
            setIsShowEditImg(false);
            setIsShowKeywordTip(false);
            setSelectedHistoryVersionId(-1);
            patchPagePublicState({
                initState: false,
            })
            patchPageListState(pickDefinedFields(obj, [
                'pageLoading',
                'productId',
                'collectionId',
                'collectionType',
                'blogId',
                'articleId',
                'pageId',
                'isShowErrorTip',
                'selectItem',

            ]))
            patchSettingState(pickDefinedFields(obj, [
                'descSetNum',
                'seo_score',
                'isGscConnected',
                'isShowKeywordBannerTip',
                'isShowGscBanner',
                'isShowRepetitionKeyBanner',
                'isShowAccordTypeBanner',
                'isShowCompetitorsModal',
            ]))
            setCurrentSelectedIntent({});
            getUserComboByCard('');
            // 切换对象
            const ids = {
                productId: obj.productId,
                collectionId: obj.collectionId,
                collectionType: obj.collectionType,
                blogId: obj.blogId,
                articleId: obj.articleId,
                pageId: obj.pageId
            }

            // 判断语种
            if (Boolean(isEditObjState && curLanguageSel)) {
                changeLanguageDetail(curLanguageSel, langeName, true, false, ids);
            } else {
                getPageDetailData(null, true, false, null, true, ids);
            }
        }
    }

    // 设置分数筛选
    const setSeoScoreChange = (val) => {
        const issuesMap = {
            0: 'Well Done',
            1: 'Need Improve',
            2: 'Important Issued'
        };
        let type = val === -1 ? [] : val.map(n => issuesMap[n]);
        let newState = {
            state: true,
            selectedOptimize: type,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        if (val === -1) {
            newState.seoScoreSel = -1;
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 是否存在关键词筛选
    const setFocusKeywordChange = (val) => {
        let newState = {
            state: true,
            focusKeywordSel: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 设置onpage产品状态
    const setOnpageProductStatusChange = (val) => {
        let newState = {
            state: true,
            onpage_ProductStatus: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 设置onpage博客可见状态
    const setOnpageBlogVisibleChange = (val) => {
        let newState = {
            state: true,
            onpage_BlogVisible: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 设置 FAQ schema 筛选 (对应后端 hasFaq: 1 有 / 0 无)
    const setFaqSchemaChange = (val) => {
        let newState = {
            state: true,
            faqSchemaSel: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 设置 How-To schema 筛选 (对应后端 hasHowto: 1 有 / 0 无; 仅 blog / otherpage)
    const setHowtoSchemaChange = (val) => {
        let newState = {
            state: true,
            howtoSchemaSel: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 设置 Product Tag 多选筛选 (对应后端 productTags[]; 仅 product)
    const setProductTagChange = (val) => {
        let newState = {
            state: true,
            productTagSel: val === -1 ? -1 : val,
            page: 1,
            size: 10,
            current_PageSize: 10,
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 改变页数
    const changePageSize = (e) => {
        const newState = {
            state: true,
            page: 1,
            size: Number(e),
            current_PageSize: Number(e)
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 系统分页
    const handlePageBlur = (e) => {
        const newState = {
            state: true,
            page: Number(e),
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 上下页
    const changeListPage = (e) => {
        let newState = {
            state: true,
            page: e,
            size: size,
            current_PageSize: size,
            tableListLoading: true
        }
        patchPageListState(newState);
        let selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, false, selState, true, true, newState);
    }

    // 开始研究
    const handleStartResearch = async (type = 'panel') => {
        startResearchRef.current = true;
        startResearchTypeRef.current = type;
        if (type === 'panel') {
            if (!targetKeywordValue) {
                setIsShowKeywordTip(true);
                return;
            }
            patchSettingState({
                researchLoading: true,
            })
        } else if (type === 'modal') {
            // 设置外层配置
            let _label = AiLanguageArr.find(i => i.value === aiLang)?.label || "English";
            setIsShowKeywordTip(false);
            patchSettingState({
                researchLoading: true,
                aiLangLabel: _label,
                country_sel: currents,
                targetKeywordValue: targetKeywordPreviewValue,
            })
        } else if (type === 're_analyze') {
            setKeywordCoverageCol(true);
            patchSettingState({
                researchLoading: true,
                isShowUpdOpt: false,
                panelState: '2-2',
                // activeTab: 'research',
            })
        }

        // 开始研究
        let params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: getCurrentEntityId(),

            keyword: targetKeywordPreviewValue,
            language: aiLang,
            location: currents.abb,
        }
        const res = await reqPostAuditAnalysis(params);
        if (Number(res.code) === 1000) {
            props.handleShowGetMoreUsageModal('onpage', product_use);
            patchSettingState({
                researchLoading: false,
            })
        } else if (res.ack === 1) {
            patchSettingState({
                searchSettingsModalState: false,
            })
            getBlogAnalysisData({ id: getCurrentEntityId() }, 'poll');
        } else {
            if (res.code === 409) {
                // 重复分析提示
                setIsShowRepeatAnalysisBanner(true);
            } else if (res.code === 429) {
                // 分析限制提示
                setIsShowMonthlyLimitBanner(true);
            } else {
                setErrorBanner(res.msg);
            }
            patchSettingState({
                researchLoading: false,
            })
        }
    }

    // 操作搜索设置
    const handleToggleSettingSearch = (state) => {
        let _store = store.getState().public.publicInit;
        let c_lang = _store.shop_data?.content_language || 'en';
        patchSettingState({
            searchSettingsModalState: state,
            isShowSuggestion: false,
            recommendLoading: false,
            recommendKeywordsList: [],
            // targetKeywordPreviewValue: targetKeywordPreviewValue || targetKeywordValue || recordData?.keyword || initPageData?.primaryKeywords || initPageData?.data?.primaryKeywords,
            aiLang: recordData?.language || c_lang,
            aiLangLabel: AiLanguageArr.find(i => i.value === (recordData?.language || c_lang))?.label || "English",
        })

        // 重置地区
        let c_local = recordData?.location ? recordData.location : (_store.shop_data?.audience_location || 'US');
        let c_selectArea = Countrys.find(item => (item.abb).indexOf(c_local) > -1) || Countrys[0];
        selectCountryData(c_selectArea);
    }

    // 超额操作
    const handleOverchargeState = async (state, defalutPoints = 0) => {
        // 直接扣费（ai_usage_status === true 场景）
        patchSettingState({
            agreeLoading: true,
        });
        let params = {
            points: defalutPoints
        }
        const res = await reqHandleAIUsagePayment(params);
        if (res.ack === 1) {
            props.toggleToast(t(res.msg));
            getUserComboByCard();
        } else {
            props.toggleToast(t(res.msg), true);
        }

        if (res) {
            patchSettingState({
                agreeLoading: false,
            });
        }
    }

    // 判断超额状态
    const verifyOverchargeState = (c_points = 0, c_level = 1, c_ai_usage_status = 0, c_aiUse = 0) => {
        // 结构化类型
        if (c_points === 0.1) {
            if (c_level !== 1 && [30002, 30003, 40002].includes(c_ai_usage_status)) {
                if ([40002].includes(c_ai_usage_status)) {
                    props.openUpdateLimit();
                } else {
                    // 打开弹窗
                    setIsShowOverExcessModal(true);
                }
            } else if (c_ai_usage_status === true) {
                handleOverchargeState(true, 2);
            } else {
                props.handleShowGetMoreUsageModal('ai', c_aiUse);
            }
        } else {
            overchargeNumRef.current = c_points;
            if (c_level !== 1 && [30002, 30003, 40002].includes(c_ai_usage_status)) {
                if ([40002].includes(c_ai_usage_status)) {
                    props.openUpdateLimit();
                } else {
                    props.openOverageModal({
                        type: 'points',
                        points: c_points,
                        onSuccess: (res) => {
                            if (res && res.msg) props.toggleToast(t(res.msg));
                            getUserComboByCard();
                        },
                    });
                }
            } else if (c_ai_usage_status === true) {
                handleOverchargeState(true, c_points);
            } else if (c_level === 1) {
                props.handleShowGetMoreUsageModal('onpage', c_aiUse);
            } else {
                props.upgradeModal(c_level < 2 ? 1 : 2, 'OnPageSEO', 'content_audit_detail', false);
            }
        }
    }

    // 打开选择链接弹窗
    const handleOpenInsertModal = () => {
        if (isShowSaveBarRef.current) {
            setNextStepType('handleOpenInsertModal');
            handleChangeSavebarState(true, 'handleOpenInsertModal');
        } else if (level !== 3) {
            props.upgradeModal(2, 'AIInternalLinking', 'content_audit_detail')
        } else {
            // 判断额度
            if (Number(creditsPoints) < 2) {
                verifyOverchargeState(2, level, ai_usage_status, aiUse);
                return;
            }
            // 打开弹窗
            setPagesModalOpen(true)
        }
    }

    // 获取优化结果
    const handleGetAiOptimizeResult = async (taskId, type = 'auto-opt') => {
        let params = {
            task_id: taskId,
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: getCurrentEntityId(),
        }
        const res = await reqGetAiOptimizeResultData(params);
        if (res.ack === 1) {
            const _t = res.data;
            if (_t.status === 0) {
                // 轮询
                if (aiTimerArr.length === 0) {
                    let timer = setInterval(() => {
                        handleGetAiOptimizeResult(taskId, type);
                    }, 3000);
                    aiTimerArr.push(timer);
                }
            } else {
                clearTypeInterval('aiTimerArr');
                isShowSaveBarRef.current = true;
                patchPagePublicState({
                    isShowSaveBar: true,
                });
                // 执行对应类型事件
                if (type === 'auto-opt') {
                    let optObj = {
                        autoOptimizeLoading: false,
                        descSetNum: 1,
                        autoOptStructureSel: inactiveNum > 0,
                    };
                    const _ext = _t?.ext_content || {};
                    setAutoOptimizeData(_ext);
                    // 需要增加源和优化后的内容 diff 比较
                    let modalRes = cloneDeep(_ext);
                    if (_ext?.description) {
                        modalRes.description = diffEditorContent(descValue, _ext.description);
                        optObj.descSetNum = descSetNum > 1 ? descSetNum + 1 : 2;
                    }
                    setAutoOptimizeModalData(modalRes);
                    const map = {
                        titleValue: 'title',
                        descValue: 'description',
                        metaTitleValue: 'meta_title',
                        metaDescriptionValue: 'meta_description',
                        urlValue: 'url_slug',
                        productTags: 'product_tags',
                    };
                    // 存在优化的对象
                    let optObjArr = [];
                    Object.entries(map).forEach(([key, sourceKey]) => {
                        const value = _ext?.[sourceKey];
                        // 数组类型（产品标签）需要有内容才算优化项
                        if (Array.isArray(value) ? value.length > 0 : value) {
                            if (key === 'descValue') {
                                optObj[key] = diffEditorContent(descValue, value); // 比较富文本内容
                            } else {
                                optObj[key] = value;
                            }
                            optObjArr.push(key);
                        }
                    });
                    setOptPurpleArray(optObjArr);
                    patchSettingState(optObj);

                    // 如果optObjArr存在metaTitleValue, metaDescriptionValue, urlValue，则打开meta编辑状态
                    if (optObjArr.includes('metaTitleValue') || optObjArr.includes('metaDescriptionValue') || optObjArr.includes('urlValue')) {
                        setMetaCollStatus(true);
                    }
                }
                if (type === 'insert-link') {
                    props.toggleToast(t("Add successfully"));
                    patchSettingState({
                        insertLoading: false,
                        descValue: _t?.ext_content?.description || descValue,
                        descSetNum: descSetNum > 1 ? descSetNum + 1 : 2,
                    })
                }
            }
        } else {
            // setErrorBanner(res.msg);
            clearTypeInterval('aiTimerArr');
            props.toggleToast(t("Failed. Try again."), true);
            if (type === 'auto-opt') {
                // 回退状态
                patchSettingState({
                    panelState: '2',
                    autoOptimizeLoading: false,
                });
            }

            if (type === 'insert-link') {
                patchSettingState({
                    insertLoading: false,
                });
            }
        }
    }

    // 自动优化
    // 打开自动优化偏好设置弹窗（用已保存偏好初始化草稿）
    const handleOpenAutoOptPref = () => {
        patchSettingState({
            autoOptPrefModalOpen: true,
            autoOptPrefDraft: { ...DEFAULT_AUTO_OPT_PREFERENCES, ...autoOptPreferences },
        });
    };

    // 关闭偏好弹窗（不保存草稿）
    const handleCloseAutoOptPref = () => {
        patchSettingState({ autoOptPrefModalOpen: false });
    };

    // 修改偏好草稿
    const handleChangeAutoOptPref = (patch) => {
        patchSettingState((prev) => ({
            autoOptPrefDraft: { ...prev.autoOptPrefDraft, ...patch },
        }));
    };

    // 保存 Advanced settings（Meta robots index/follow）— 独立保存接口，action=IndexAndFollow，避免与其它保存逻辑混用
    const handleSaveIndexAndFollow = async ({ noindex: nextNoindex, nofollow: nextNofollow }) => {
        const params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: getCurrentEntityId(),
            action: 'IndexAndFollow',
            noindex: nextNoindex,
            nofollow: nextNofollow,
        };
        const res = await reqSaveContentAudit(params);
        if (res.code === '200') {
            patchPagePublicState({ noindex: Number(nextNoindex), nofollow: Number(nextNofollow) });
        }
        return res;
    };

    // 保存偏好设置（复用页面保存接口，action=saveAutoOptimizePref，仅传偏好参数）
    const handleSaveAutoOptPref = async () => {
        if (autoOptPrefSaveLoading) return;
        const draft = { ...DEFAULT_AUTO_OPT_PREFERENCES, ...autoOptPrefDraft };
        const serialized = serializeAutoOptPref(draft);
        const p_type = pagetypeRef.current || pagetype;
        const params = {
            sourceType: getSourceType(p_type),
            id: getCurrentEntityId(),
            action: "saveAutoOptimizePref",
            auto_optimize_pref: serialized,
        };
        patchSettingState({ autoOptPrefSaveLoading: true });
        const res = await reqSaveContentAudit(params);
        if (res.code === "200") {
            patchSettingState({
                autoOptPreferences: { ...draft },
                auto_optimize_pref: serialized,
                autoOptPrefModalOpen: false,
                autoOptPrefSaveLoading: false,
            });
            props.toggleToast(t(res.msg || "Success"));
        } else {
            patchSettingState({ autoOptPrefSaveLoading: false });
            props.toggleToast(res.msg, true);
        }
    };

    const handleAutoOptimize = async (isSave = false) => {
        // 判断是否保存
        if (isSave) {
            handleChangeSavebarState(true, 'handleAutoOptimize'); // 打开未保存弹窗
            return;
        }

        // 需要判断积分是否足够
        if (Number(creditsPoints) < 4) {
            verifyOverchargeState(4, level, ai_usage_status, aiUse);
            return;
        }

        // 设置loading状态
        patchSettingState({
            autoOptimizeLoading: true,
            activeKeyword: '',
            activeKeyStatus: false,
        });
        let params = {
            sourceType: getSourceType(pagetypeRef.current || pagetype),
            id: getCurrentEntityId(),
        }
        // 产品类型携带自动优化偏好设置
        if ((pagetypeRef.current || pagetype) === 'product') {
            params.auto_optimize_pref = serializeAutoOptPref(autoOptPreferences || DEFAULT_AUTO_OPT_PREFERENCES);
        }
        const res = await reqStartAiOptimize(params);
        if (res.ack === 1) {
            // 设置原始优化数据
            setOriginalOptimizeData({
                titleValue: titleValue,
                descValue: descValue,
                metaTitleValue: metaTitleValue,
                metaDescriptionValue: metaDescriptionValue,
                urlValue: urlValue,
                productTags: productTags,
            })
            patchSettingState({
                panelState: '3',
                autoOriginScore: seo_score,
            });
            // 获取优化结果
            const _t = res.data;
            handleGetAiOptimizeResult(_t.task_id, 'auto-opt');
        } else {
            setErrorBanner(res.msg);
            patchSettingState({
                autoOptimizeLoading: false,
            });
        }
    }

    // 选择ai输出语言
    const handleSelectAiLanguage = (val) => {
        patchSettingState({ aiLang: val });
    }

    // 选择语言（受众弹窗内）
    const selectLanguageData = (data) => {
        patchSettingState({ aiLang: data.value, aiLangLabel: data.label });
        patchCountryState({ languageState: false });
    }

    // 上传图片（blog/collections 主图）：改用 reqUploadMedia 拿 CDN 链接
    const handleDropZoneDrop = async (file) => {
        if (file.length === 0) return;
        // 判断类型是否符合
        const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        // 判断大小，不能超过3M
        if (file[0].size > 3 * 1024 * 1024) {
            props.toggleToast(t("Cannot exceed 3MB"), true);
            return;
        }
        if (!validImageTypes.includes(file[0].type)) {
            props.toggleToast(t("Accepts .jpg, and .png"), true);
            return;
        }

        patchSettingState({ uploadLoading: true });
        try {
            const dataUrl = await readFileAsDataURL(file[0]);
            // 上传到后端换取 CDN 地址
            const res = await reqUploadMedia({
                sourceType: getSourceType(pagetypeRef.current || pagetype),
                id: getCurrentEntityId(),
                images: [{
                    data: dataUrl,
                    mimeType: file[0].type,
                    filename: file[0].name,
                    altText: '',
                }],
            });

            if (String(res.code) === "200" || res.ack === 1) {
                // 与多图上传保持一致：从 res.data.images 取列表，单图只取第一张
                const payload = res.data?.images || [];
                const uploaded = Array.isArray(payload) ? payload : [];
                const img = uploaded[0];
                const cdnSrc = img?.src || img?.url || img?.image || '';
                if (!cdnSrc) {
                    props.toggleToast(t("Upload failed"), true);
                    patchSettingState({ uploadLoading: false });
                    return;
                }
                const fileInfo = {
                    id: img.id ?? '',
                    src: cdnSrc,
                    type: file[0].type,
                    name: file[0].name,
                    alt: img.alt ?? img.altText ?? '',
                };
                patchSettingState({
                    imageInfo: fileInfo,
                    uploadLoading: false,
                });
                setFiles(file);
            } else {
                props.toggleToast(res.msg || t("Upload failed"), true);
                patchSettingState({ uploadLoading: false });
            }
        } catch (err) {
            props.toggleToast(t("Upload failed"), true);
            patchSettingState({ uploadLoading: false });
        }
    }

    // ===== 产品多图（Media）相关处理 =====
    // 读取文件为 base64
    const readFileAsDataURL = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    // 上传产品图片（支持多张，单次最多 PRODUCT_MEDIA_MAX 张）
    const handleProductMediaUpload = async (fileList) => {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        // 单次上传数量上限：超出只取前 PRODUCT_MEDIA_MAX 张并提示
        let picked = Array.from(fileList);
        if (picked.length > PRODUCT_MEDIA_MAX) {
            props.toggleToast(t("Max {{v1}} images", PRODUCT_MEDIA_MAX), true);
            picked = picked.slice(0, PRODUCT_MEDIA_MAX);
        }
        let accepted = picked.filter((f) => {
            if (f.size > 3 * 1024 * 1024) {
                props.toggleToast(t("Cannot exceed 3MB"), true);
                return false;
            }
            if (!validTypes.includes(f.type)) {
                props.toggleToast(t("Accepts .jpg, and .png"), true);
                return false;
            }
            return true;
        });
        if (accepted.length === 0) return;

        patchSettingState({ uploadLoading: true });
        try {
            const dataUrls = await Promise.all(accepted.map((f) => readFileAsDataURL(f)));
            // reqUploadMedia 传参格式
            const uploadImages = accepted.map((f, i) => ({
                data: dataUrls[i],
                mimeType: f.type,
                filename: f.name,
                altText: '',
            }));

            // 上传到后端，换取 CDN 地址
            const res = await reqUploadMedia({
                sourceType: getSourceType(pagetypeRef.current || pagetype),
                id: getCurrentEntityId(),
                images: uploadImages,
            });

            if (String(res.code) === "200" || res.ack === 1) {
                // 兼容多种返回结构，取出上传后的图片列表
                const payload = res.data?.images || [];
                const uploaded = Array.isArray(payload) ? payload : [];
                const appended = uploaded.map((img, i) => ({
                    id: img.id ?? '',
                    src: img.src || img.url || img.image || '',
                    alt: img.alt ?? img.altText ?? uploadImages[i]?.altText ?? '',
                }));
                if (appended.length === 0) {
                    props.toggleToast(t("Upload failed"), true);
                    patchSettingState({ uploadLoading: false });
                    return;
                }
                patchSettingState({
                    featureImages: [...(featureImages || []), ...appended],
                    isHasImage: true,
                    uploadLoading: false,
                });
                markMediaChanged();
            } else {
                props.toggleToast(res.msg || t("Upload failed"), true);
                patchSettingState({ uploadLoading: false });
            }
        } catch (err) {
            props.toggleToast(t("Upload failed"), true);
            patchSettingState({ uploadLoading: false });
        }
    };

    // 删除产品图片（按索引，支持多选）
    const handleProductMediaRemove = (indexes = []) => {
        const idxSet = new Set(indexes);
        const next = (featureImages || []).filter((_, i) => !idxSet.has(i));
        patchSettingState({ featureImages: next });
        markMediaChanged();
    };

    // 拖拽排序后更新
    const handleProductMediaReorder = (nextImages) => {
        patchSettingState({ featureImages: nextImages });
        markMediaChanged();
    };

    // 编辑选中图片的 alt
    const handleProductMediaEditAlt = (indexes = []) => {
        const list = indexes.length > 0
            ? indexes.map((i) => (featureImages || [])[i]).filter(Boolean)
            : (featureImages || []);
        if (list.length === 0) return;
        fixImageRef.current = 'FeatureImage';
        setEditImageAltData({
            isCustomize: true,
            ...(initPageData?.data || initPageData),
            all_images: JSON.stringify(list.map((img) => ({
                alt: img?.alt || img?.altText || '',
                collectionType: collectionType,
                blog_id: blogId,
                id: getCurrentEntityId(),
                src: img?.src || img?.data || '',
            }))),
        });
    };

    // 标记媒体有改动 -> 显示保存栏
    const markMediaChanged = () => {
        isShowSaveBarRef.current = true;
        patchPagePublicState({ isShowSaveBar: true });
    };

    // 切换meta编辑状态
    const handleToggleMetaCol = () => {
        setMetaCollStatus(!metaCollStatus);
    }

    // 更新链接
    const InsertLinkUpdate = async (data) => {
        patchSettingState({
            insertLoading: true,
            activeKeyword: '',
            activeKeyStatus: false,
        });
        let params = {
            article_id: articleId,
            links: data
        }
        const res = await reqInsertLinks(params);
        if (res.ack === 1) {
            setSelectPageIdArr({
                product: [],
                blog: [],
                collections: [],
                homepage: [],
                otherpage: [],
            });
            // 获取优化结果
            const _t = res.data;
            handleGetAiOptimizeResult(_t.task_id, 'insert-link');
        } else {
            patchSettingState({ insertLoading: false });
            setErrorBanner(t(res.msg));
        }
    }

    // 获取页面选择
    const handleGetSelectId = (data) => {
        setSelectPageIdArr(data);
        InsertLinkUpdate(data);
    }

    // // 打开alt弹窗
    // const openAltOperaData = (data) => {
    //     setEditImageAltData(data);
    // }

    // 解码标题
    const decodingTitle = (title) => {
        if (Boolean(title)) {
            if (title.indexOf("giraffly_") !== -1) {
                title = title.replace("giraffly_", "");
                if (btoa(atob(title)) === title) {
                    return atob(title);
                }
            }
        }
        return title;
    }

    // 更新列表
    const updateDataList = (state = {}) => {
        const selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, true, selState);
        setEditImageAltData(null);

        // 更新内部对应的图
        if (state?.targetId) {
            let alt = JSON.parse(state?.altValue);
            let currentId = getCurrentEntityId();
            if (alt?.length > 0 && Number(currentId) === Number(state?.targetId) && imageInfo?.src) {
                let newInfo = cloneDeep(imageInfo);
                newInfo.alt = alt[0];
                patchSettingState({
                    imageInfo: newInfo,
                });
            }
        }
    }

    // 刷新列表
    const callBackRefresh = (msg) => {
        setErrorBanner(msg);
        const selState = Boolean(isEditObjState && curLanguageSel) ? curLanguageSel : null;
        getPageList(null, issueValueSel, true, true, selState);
        setEditImageAltData(null);
    }

    // 关闭alt弹窗
    const closeAltEditModal = () => {
        setEditImageAltData(null);
    }

    // 聚焦搜索
    const handleFocusSearch = () => {
        if (Boolean(targetKeywordPreviewValue) && keywordSugData.length > 1) {
            patchSettingState({ isShowKeywordSugPop: true })
        }
    }

    // 输入框变化
    const handleInputChange = useCallback((value, id) => {
        keywordCoverageMouseTypeRef.current = '';
        const formFieldSet = new Set([
            'titleValue',
            'targetKeywordValue',
            'targetKeywordPreviewValue',
            'targetKeywordSelectValue',
            'targetKeywordSuggestionValue',
            'countryValue',
            'metaTitleValue',
            'metaDescriptionValue',
            'urlValue',
        ]);
        if (formFieldSet.has(id)) {
            if (id === 'targetKeywordSelectValue' || id === 'targetKeywordSuggestionValue') {
                patchSettingState({ targetKeywordPreviewValue: value });
            } else {
                patchSettingState({ [id]: value });
            }
        }
        if (id === 'countryValue') {
            changeCountryData(value);
        }
        if (id === 'targetKeywordPreviewValue') {
            patchSettingState({
                customeSetState: Boolean(value),
                isShowKeywordSugPop: Boolean(value),
                keywordSearchLoading: Boolean(value),
            });
            // 请求关键词推荐
            if (value) {
                debouncedKeywordSearch(value);
            }
        }
        if (id === 'targetKeywordSelectValue') {
            patchSettingState({
                isShowKeywordSugPop: false,
                keywordSearchLoading: false,
            });
        }
    }, [])

    // 选择自定义关键词
    const handleSelectCustomValue = (id) => {
        patchSettingState({
            customeSetState: false,
            [id]: targetKeywordPreviewValue
        });
    }

    // 删除图片
    const handleRemoveImage = () => {
        setFiles([]);
        setIsShowEditImg(false);
        patchSettingState({
            featureImages: [],
            imageInfo: {},
        });
    }

    const escapeHtmlAttr = (value = '') => String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const updateContentImageAlts = (html = '', images = []) => {
        if (!html || !Array.isArray(images) || images.length === 0) return html;

        const altQueueMap = new Map();
        images.forEach((item = {}) => {
            if (item?.src) {
                if (!altQueueMap.has(item.src)) {
                    altQueueMap.set(item.src, []);
                }
                altQueueMap.get(item.src).push(item?.alt ?? '');
            }
        });
        if (altQueueMap.size === 0) return html;

        return html.replace(/<img\b[^>]*>/gi, (imgTag) => {
            const srcMatch = imgTag.match(/\ssrc=(['"])(.*?)\1/i);
            if (!srcMatch) return imgTag;

            const altQueue = altQueueMap.get(srcMatch[2]);
            if (!Array.isArray(altQueue) || altQueue.length === 0) return imgTag;

            const nextAlt = altQueue.shift();

            const altAttr = ` alt="${escapeHtmlAttr(nextAlt)}"`;
            if (/\salt=(['"])(?:[\s\S]*?)\1/i.test(imgTag)) {
                return imgTag.replace(/\salt=(['"])(?:[\s\S]*?)\1/i, altAttr);
            }

            return imgTag.replace(/\s*\/?>$/, (endTag) => `${altAttr}${endTag}`);
        });
    };

    // 更新自定义alt
    const updateCustomizeAlt = (data) => {
        // 判断是FeatureImage 还是 ContentImage
        setEditImageAltData({});
        if (fixImageRef.current === 'FeatureImage') {
            // 产品多图：按 src/id 把新 alt 回写到 featureImages 数组
            if ((pagetypeRef.current || pagetype) === 'product') {
                const altBySrc = new Map();
                const altById = new Map();
                (Array.isArray(data) ? data : []).forEach((it) => {
                    if (it?.src) altBySrc.set(it.src, it?.alt ?? '');
                    if (it?.id) altById.set(String(it.id), it?.alt ?? '');
                });
                const nextImages = (featureImages || []).map((img) => {
                    const key = img.src || img.data || '';
                    if (altBySrc.has(key)) return { ...img, alt: altBySrc.get(key) };
                    if (img.id && altById.has(String(img.id))) return { ...img, alt: altById.get(String(img.id)) };
                    return img;
                });
                patchSettingState({ featureImages: nextImages });
                isShowSaveBarRef.current = true;
                patchPagePublicState({ isShowSaveBar: true });
            } else {
                let c_img = data.length > 0 ? data[0] : imageInfo;
                patchSettingState({
                    imageInfo: c_img,
                })
                if (imageInfo?.alt !== data[0]?.alt) {
                    isShowSaveBarRef.current = true;
                    patchPagePublicState({
                        isShowSaveBar: true,
                    });
                    // imageInfo 已在上方更新，评分交由统一的 scoreInput effect 处理
                }
            }
        } else if ((pagetypeRef.current || pagetype) === 'product') {
            // 产品多图：把返回数据按 featureImages 的 src 拆成「产品媒体图」与「内容图」
            const init = initPageData?.data || initPageData;
            const content = typeof descValue === 'string' ? descValue : (init?.body_html || '');
            const list = Array.isArray(data) ? data : [];
            const featSrcSet = new Set((featureImages || []).map((i) => i.src || i.data || ''));
            const altBySrc = new Map();
            const altById = new Map();
            const contentImgs = [];
            list.forEach((it) => {
                const key = it?.src || '';
                if (it?.isFeature || featSrcSet.has(key)) {
                    if (key) altBySrc.set(key, it?.alt ?? '');
                    if (it?.id) altById.set(String(it.id), it?.alt ?? '');
                } else {
                    contentImgs.push(it);
                }
            });
            // 回写产品媒体图 alt
            const nextImages = (featureImages || []).map((img) => {
                const key = img.src || img.data || '';
                if (altBySrc.has(key)) return { ...img, alt: altBySrc.get(key) };
                if (img.id && altById.has(String(img.id))) return { ...img, alt: altById.get(String(img.id)) };
                return img;
            });
            // 回写内容图 alt
            const newContent = updateContentImageAlts(content, contentImgs);
            patchSettingState({
                featureImages: nextImages,
                descValue: newContent,
                descSetNum: descSetNum > 1 ? descSetNum + 1 : 2,
            });
            isShowSaveBarRef.current = true;
            patchPagePublicState({ isShowSaveBar: true });
        } else {
            const init = initPageData?.data || initPageData;
            const content = typeof descValue === 'string' ? descValue : (init?.body_html || '');
            let main_img = data[0]?.isMain ? data[0] : imageInfo;
            let desc_img = data[0]?.isMain ? data.slice(1) : data;
            let upd_img = cloneDeep(imageInfo) || {};
            upd_img.alt = main_img?.alt || '';
            const newContent = updateContentImageAlts(content, desc_img);
            patchSettingState({
                descValue: newContent,
                descSetNum: descSetNum > 1 ? descSetNum + 1 : 2,
                imageInfo: upd_img,
            });
        }

        // 重置fixImageRef
        fixImageRef.current = '';
    }

    // 更新页面详情数据
    const updPageDetailData = (data, t_id) => {
        let s_id = getCurrentEntityId();
        if (Number(s_id) === Number(t_id)) {
            getPageDetailData(data, false, false, null, false, {
                productId: productId,
                collectionId: collectionId,
                collectionType: collectionType,
                blogId: blogId,
                articleId: articleId,
                pageId: pageId
            })
        }
    }

    // 打开编辑图片alt弹窗
    const handleOpenEditImgAlt = () => {
        fixImageRef.current = 'FeatureImage';
        setEditImageAltData({
            isCustomize: true,
            ...(initPageData?.data || initPageData),
            all_images: JSON.stringify([{
                alt: imageInfo?.alt || '',
                collectionType: collectionType,
                blog_id: blogId,
                id: getCurrentEntityId(),
                src: imageInfo?.src || '',
            }]),
        })
    }

    // 更新列表分数
    const handleUpdListScore = (id, score = 0) => {
        if (tableList.length === 0 || id === -1) return;
        let list = cloneDeep(tableList);
        list.forEach(item => {
            // blog 行用 article_id，其它类型用 id
            const rowId = item.article_id ?? item.id;
            if (rowId === id && item.seo_score !== score) {
                item.seo_score = Math.ceil(score);
            }
        });
        patchPageListState({
            tableList: list,
        });
    }

    // 刷新更新时间
    const handleToggleUpdOpt = (state) => {
        setIsShowUpdOpt(state)
    }

    // 预览链接：确保打开绝对 URL，避免 previewUrl 为空/相对路径时继承当前页面域名导致 404
    const resolvePreviewAbsoluteUrl = (base, handle) => {
        const host = (domain || '').replace(/^https?:\/\//i, '').replace(/\/$/, '');
        let pathOrUrl = '';
        if (base) {
            pathOrUrl = Boolean(curLanguageSel && isEditObjState)
                ? formatOutUrl(base, curLanguageSel, handle || '')
                : `${base}${handle || ''}`;
        } else if (host) {
            // API 未返回 preview_url 时，用店铺域名 + 实体路径兜底
            const origin = `https://${host}`;
            const entityPath = buildEntityUrl(pagetype, { blog_handle, handle: handle || '' });
            pathOrUrl = Boolean(curLanguageSel && isEditObjState)
                ? formatOutUrl(`${origin}/`, curLanguageSel, entityPath.replace(/^\//, ''))
                : `${origin}${entityPath}`;
        }
        if (!pathOrUrl) return '';
        if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
        if (!host) return '';
        const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
        return `https://${host}${path}`;
    };

    const handlePreviewUrl = () => {
        if (!pageLoading && !tableListLoading) {
            const url = resolvePreviewAbsoluteUrl(previewUrl, urlValue);
            if (!url) return;
            window.open(url, '_blank');
        }
    }

    // 更新JSON-LD状态
    const updOpenJsonldStatus = () => {
        setUpdOpenJSONLD(false);
    }

    // 发布 - 博客独有
    const handlePublishData = async () => {
        patchPagePublicState({ publishLoading: true });
        let params = {
            article_id: articleId,
        }
        const res = await reqPublishAiBlogArticle(params);
        if (res.ack === 1) {
            props.toggleToast(res.msg);
            patchPagePublicState({
                publishLoading: false,
                isPublishState: true,
            });
        } else {
            setErrorBanner(res.msg);
            patchPagePublicState({ publishLoading: false });
        }
    }

    // 接入预览数据后在此加载对应版本内容
    // 解析历史记录中的 tags（upd_logs 中 tags 为逗号分隔字符串，也兼容数组格式）
    const parseHistoryVersionTags = (tags) => {
        if (Array.isArray(tags)) {
            return tags.map((tag) => String(tag).trim()).filter(Boolean);
        }
        if (typeof tags === 'string') {
            return tags.split(',').map((tag) => tag.trim()).filter(Boolean);
        }
        return [];
    };

    const handleHistoryVersionPreview = (res) => {
        setSelectedHistoryVersionId(res.id);
        setHistoryRecordModalOpen(false);
        // 设置数据
        const _t = res.data;
        patchSettingState({
            descSetNum: 2,
            titleValue: _t.title || '',
            descValue: _t.content || '',
            metaTitleValue: _t.meta_title || '',
            metaDescriptionValue: _t.meta_desc || '',
            urlValue: _t.handle || '',
            productTags: parseHistoryVersionTags(_t.tags ?? _t.product_tags),
        });
    };

    // 富文本输入
    const onTransChange = (value) => {
        let count = keywordCoverageMouseTypeRef.current ? descSetNum : descSetNum + 1;
        patchSettingState({
            descValue: value,
            descSetNum: count,
        })
    }

    // 富文本聚焦
    const onTransFocus = () => {
        keywordCoverageMouseTypeRef.current = '';
        let s_num = isShowSaveBarRef.current ? descSetNum : 1;
        patchSettingState({
            descSetNum: s_num,
        })
    }

    // 取消自动优化
    const handleAutoOptCancel = () => {
        if (autoOptimizeLoading) {
            handleDiscardAction();
            clearTypeInterval('aiTimerArr');
            handleChangeAutoOptimizeState(false, '')
            patchSettingState({
                autoOptimizeLoading: false,
                panelState: '2', // 切换到内容审核面板
            });
        } else {
            handleAutoOptimizeCancelConfirm(autoOptimizeNextStepType);
        }
    }

    // 取消自动优化提示弹窗
    const handleCancelAutoOptTip = () => {
        if (autoOptimizeLoading) {
            patchSettingState({ cancelAutoOptModalOpen: true });
        } else {
            // 展示未保存弹窗
            handleChangeSavebarState(true, 'handleCancelAutoOptimize');
        }
    }

    // 回退数据
    const handleRollbackData = (type) => {
        // 判断是否正在回退
        if (rollbackLoading) {
            return;
        }
        // 设置回退加载
        setRollbackLoading(type);
        const compareObj = {
            'title': 'titleValue',
            'desc': 'descValue',
            'meta_tag': ['metaTitleValue', 'metaDescriptionValue', 'urlValue'],
            'tags': 'productTags',
        }
        // 判断是undo还是redo
        const editObj = compareObj[type];
        const isUndo = Array.isArray(editObj) ? ['metaTitleValue', 'metaDescriptionValue', 'urlValue'].some(key => optPurpleArray.includes(key)) : optPurpleArray.includes(editObj);

        // 设置高亮对象
        let newPurpleArray = cloneDeep(optPurpleArray);
        if (isUndo) {
            if (Array.isArray(editObj)) {
                editObj.forEach(item => {
                    if (newPurpleArray.includes(item)) {
                        newPurpleArray.splice(newPurpleArray.indexOf(item), 1);
                    }
                });
            } else {
                newPurpleArray.splice(newPurpleArray.indexOf(editObj), 1);
            }
        } else {
            if (Array.isArray(editObj)) {
                editObj.forEach(item => {
                    if ((item === 'metaTitleValue' && autoOptimizeData?.meta_title) || (item === 'metaDescriptionValue' && autoOptimizeData?.meta_description) || (item === 'urlValue' && autoOptimizeData?.url_slug)) {
                        newPurpleArray.push(item);
                    }
                })
            } else {
                newPurpleArray.push(editObj);
            }
        }
        setOptPurpleArray(newPurpleArray);

        switch (type) {
            case 'title':
                patchSettingState({
                    titleValue: isUndo ? (originalOptimizeData?.titleValue || titleValue) : autoOptimizeData?.title,
                });
                break;
            case 'desc':
                patchSettingState({
                    descValue: isUndo ? (originalOptimizeData?.descValue || descValue) : diffEditorContent(descValue, autoOptimizeData?.description),
                });
                break;
            case 'meta_tag':
                patchSettingState({
                    metaTitleValue: isUndo ? (originalOptimizeData?.metaTitleValue) : (autoOptimizeData?.meta_title || metaTitleValue),
                    metaDescriptionValue: isUndo ? (originalOptimizeData?.metaDescriptionValue) : (autoOptimizeData?.meta_description || metaDescriptionValue),
                    urlValue: isUndo ? (originalOptimizeData?.urlValue) : (autoOptimizeData?.url_slug || urlValue),
                });
                break;
            case 'tags':
                patchSettingState({
                    productTags: isUndo ? (originalOptimizeData?.productTags || productTags) : (autoOptimizeData?.product_tags || productTags),
                });
                break;
            default:
                break;
        }

        setTimeout(() => {
            setRollbackLoading('');
            props.toggleToast(isUndo ? t("Revert successful.") : t("Optimization successful."));
        }, 500);
    }

    // 设置错误banner
    const setErrorBanner = (tip) => {
        scrollToSite('top'); // 返回顶部
        patchPageListState({
            isShowErrorTip: tip,
        })
    }

    // 保存语种切换数据
    const LangChangeDataSave = async () => {
        // 判断空
        if (!titleValue) {
            setErrorBanner(t("Please fill in the required items"));
            return false;
        } else {
            if (uploadLoading) return;
            patchPagePublicState({ setSaveLoading: true });
            let listData = [];
            if (editableObj.length > 0) {
                editableObj.forEach(item => {
                    if (item.key === 'title' && Boolean(titleValue)) {
                        listData.push({ "key": "title", "digest": item.digest, "value": titleValue })
                    }
                    if (item.key === 'body_html' && Boolean(descValue)) {
                        listData.push({ "key": "body_html", "digest": item.digest, "value": descValue })
                    }
                    if (item.key === 'meta_title' && Boolean(metaTitleValue)) {
                        listData.push({ "key": "meta_title", "digest": item.digest, "value": metaTitleValue })
                    }
                    if (item.key === 'meta_description' && Boolean(metaDescriptionValue)) {
                        listData.push({ "key": "meta_description", "digest": item.digest, "value": metaDescriptionValue })
                    }
                })
            }
            let types = pagetype;
            let params = {
                "lists": listData,
                "seo_score": Math.ceil(seo_score),
                "keyword": targetKeywordValue,
                "language": curLanguageSel,
            }
            if (types === 'product') {
                params['data_id'] = productId;
                params['page_type'] = 'product';
            } else if (types === 'collections') {
                params['data_id'] = collectionId;
                params['page_type'] = 'collection';
            } else if (types === 'blog') {
                params['data_id'] = articleId;
                params['page_type'] = 'blog';
            } else if (types === 'otherpage') {
                params['data_id'] = pageId;
                params['page_type'] = 'page';
            } else { }
            const res = await reqUpdTranslationsRegister(params);
            if (res.ack === 1) {
                props.toggleToast(t("Success"), false);
                isShowSaveBarRef.current = false;
                patchPagePublicState({
                    isShowSaveBar: false
                });
            } else {
                setErrorBanner(res.msg);
            }
            if (res) {
                patchPagePublicState({ setSaveLoading: false });
                if (res.code !== '501') {
                    getPageList(null, -1, true, true, curLanguageSel);
                }
            }
        }
    }

    // 取消自动优化
    const handleCancelAutoOptimize = () => {
        patchSettingState({
            panelState: '2',
            autoOptimizeLoading: false,
        })
    }

    // 保存
    const handleSaveAction = async () => {
        // 判断是否小语种保存
        if (Boolean(isEditObjState && curLanguageSel)) {
            LangChangeDataSave();
        } else {
            // 判断内容是否符合保存条件
            if ((urlValue.length > 255 || !urlValue) || (!titleValue || titleValue.length > 255)) {
                setErrorBanner(t("Please fill in the required items"));
                return;
            }
            if (uploadLoading) return;
            patchPagePublicState({ setSaveLoading: true });
            const stripKeywordHighlightSpans = (html) =>
                html.replace(/<span class="match_(?:green|yellow|red|purple)">([\s\S]*?)<\/span>/gi, '$1');
            let _descValue = stripKeywordHighlightSpans(descValue);
            // 去除高亮状态
            patchSettingState({
                activeKeyword: '',
                activeKeyStatus: 0,
                descValue: _descValue,
            })
            let p_type = pagetypeRef.current || pagetype;
            let params = {
                sourceType: getSourceType(p_type),
                id: getCurrentEntityId(),

                action: "allToSave",
                title: titleValue,
                content: _descValue,
                metaTitle: metaTitleValue,
                metaDesc: metaDescriptionValue,
                handleUrl: urlValue,
                primary_keywords: targetKeywordValue,
            }

            // 对应类型单独处理
            // 产品：多图上传/排序/alt 统一走 images 数组（按当前顺序）
            // 结构：{ id, src, alt }；新图 id 为空，后端据 id/src/alt 与顺序做增删改
            if (p_type === 'product') {
                params.productTags = JSON.stringify(productTags);
                params.images = (featureImages || []).map((img) => ({
                    id: img.id ?? '',
                    src: img.src || img.data || '',
                    alt: img.alt ?? img.altText ?? '',
                }));
            } else if (p_type !== 'otherpage') {
                // 其它类型（blog/collections）保持单主图逻辑
                if (imageInfo?.src) {
                    params.image = {
                        id: imageInfo.id ?? '',
                        src: imageInfo.src || imageInfo.data || '',
                        alt: imageInfo.alt ?? imageInfo.altText ?? '',
                    };
                } else {
                    if (isHasImage) {
                        params.image = null;
                    }
                }
            }
            const res = await reqSaveContentAudit(params);
            if (res.code === "200") {
                // 优化的需要判断是否需要执行jsonld
                const willOpenJsonLd = panelState === '3' && autoOptStructureSel && level !== 1;
                if (willOpenJsonLd) {
                    setUpdOpenJSONLD(true);
                }
                let init = cloneDeep(initPageData?.data ? initPageData.data : initPageData);
                init.title = titleValue;
                init.body_html = _descValue;
                init.seo_title = metaTitleValue;
                init.seo_desc = metaDescriptionValue;
                init.handle = urlValue;
                patchPageListState({
                    initPageData: init,
                });
                patchSettingState({
                    panelState: panelState === '3' ? '2' : panelState,
                })
                // 去掉紫色状态
                setOptPurpleArray([]);
                // 获取列表数据
                getPageList(null, issueValueSel, true, true);
                // 重新请求详情数据
                getPageDetailData(null, true, false, null, false, { productId, collectionId, collectionType, blogId, articleId, pageId });
                setErrorBanner('');
                setIsShowEditImg(false);
                setFiles([]);
                setAutoOptCompareKey(null);
                props.toggleToast(t(res.msg));

                // 把分数更新到左侧列表对应项
                // handleUpdListScore(articleId, seo_score);

                // 关闭保存栏
                isShowSaveBarRef.current = false;
                patchPagePublicState({
                    isShowSaveBar: false
                });

                handleChangeSavebarState(false, '');    // 清空弹窗｜状态
                if (res.data?.reviewPopup?.shouldShow === true && !willOpenJsonLd) {
                    setReviewPopupOpen(true);
                }
            } else {
                if (res.code === '501') {
                    setFulfillmentTip(true);
                } else {
                    setErrorBanner(res.msg);
                }
                scrollToSite('top');
            }

            patchPagePublicState({
                setSaveLoading: false,
            });
        }
    }

    // 舍弃
    const handleDiscardAction = () => {
        // 优先提示是否舍弃
        if (isShowSaveBarRef.current) {
            handleChangeSavebarState(true, 'handleDiscardAction');
        } else {
            setSelectedHistoryVersionId(-1);
            isShowSaveBarRef.current = false;
            patchPagePublicState({ isShowSaveBar: false });
            // 去除高亮状态
            const stripKeywordHighlightSpans = (html) =>
                html.replace(/<span class="match_(?:green|yellow|red|purple)">([\s\S]*?)<\/span>/gi, '$1');
            let init = initPageData?.data || initPageData;
            setFiles([]);
            setIsShowEditImg(false);
            patchSettingState({
                activeKeyword: '',
                activeKeyStatus: 0,
                descSetNum: 0,
                titleValue: init.title ?? '',
                descValue: stripKeywordHighlightSpans(init.body_html) ?? '',
                targetKeywordValue: init.primaryKeywords ?? '',
                targetKeywordPreviewValue: init.primaryKeywords ?? '',
                metaTitleValue: init.seo_title ?? '',
                metaDescriptionValue: init.seo_desc ?? '',
                urlValue: init.handle ?? '',
                featureImages: init.images ?? [],
                imageInfo: init?.images?.[0] || {},
                panelState: panelState === '3' ? '2' : panelState,
                productTags: init.product_tags ?? [],
                recommendTags: [],
                showRecommendTags: false,
            });
            setErrorBanner('');
            // 去掉紫色状态
            setOptPurpleArray([]);
        }

    }

    // 未保存弹窗确认
    const handleNotSaveModalConfirm = (type = '') => {
        if (!type) return;
        setUnsaveConfirmLoading(true);
        isShowSaveBarRef.current = false;
        patchPagePublicState({ isShowSaveBar: false });
        handleDiscardAction();
        // 根据目的执行对应事件
        switch (type) {
            case 'handleChangeItemObj':
                // 切换产品
                setTimeout(() => {
                    handleChangeItemObj(changeItemObjData);
                }, 600);
                break;
            case 'handleAutoOptimize':
                // 自动优化
                patchSettingState({ autoOptimizeLoading: true });
                setTimeout(() => {
                    handleAutoOptimize(false);
                }, 600);
                break;
            case 'handleCancelAutoOptimize':
                setTimeout(() => {
                    handleCancelAutoOptimize();
                }, 600);
                break;
            case 'handleOpenInsertModal':
                // 打开插入链接弹窗
                setTimeout(() => {
                    handleOpenInsertModal();
                }, 600);
                break;
            case 'handlePageItemChange':
                // 上下页
                setTimeout(() => {
                    handlePageItemChange(changeItemObjType);
                }, 600);
                break;
            case 'changeSelectLanguage':
                // 语种切换
                setTimeout(() => {
                    changeSelectLanguage(false, '', LanguageList);
                }, 600);
                break;
            case 'handleRedirectProductSchema':
                setTimeout(() => {
                    handleRedirectProductSchema();
                }, 600);
                break;
            case 'handleRedirectOriganizationSchema':
                setTimeout(() => {
                    handleRedirectOriganizationSchema();
                }, 600);
                break;
            case 'goBack':
                setTimeout(() => {
                    goBack(true);
                }, 600);
                break;
            default:
                break;
        }

        // 延迟关闭保存栏
        setTimeout(() => {
            handleChangeSavebarState(false, '');
        }, 300);
    }

    // 取消插入确认
    const handleInsertCancelConfirm = (type = '') => {
        if (!type) return;
        setInsertConfirmLoading(true);
        clearTypeInterval('aiTimerArr');
        // patchSettingState({
        //     cancelInsertOpen: false,
        //     insertLoading: false,
        // });
        switch (type) {
            case 'goBack':
                setTimeout(() => {
                    goBack(true);
                }, 500);
                break;
            default:
                break;
        }

        // 延迟关闭弹窗
        setTimeout(() => {
            handleChangeInsertLinkState(false, '');
        }, 200);
    }

    // 取消自动优化确认
    const handleAutoOptimizeCancelConfirm = (type = '') => {
        if (!type) return;
        setAutoOptimizeConfirmLoading(true);
        handleDiscardAction();
        clearTypeInterval('aiTimerArr');
        switch (type) {
            case 'goBack':
                setTimeout(() => {
                    goBack(true);
                }, 500);
                break;
            default:
                break;
        }

        // 延迟关闭弹窗
        setTimeout(() => {
            handleChangeAutoOptimizeState(false, '');
        }, 200);
    }

    // 返回
    const goBack = (isBack = true) => {
        // 判断返回路径
        let path = {
            pathname: fromPage === 2 ? '/content-seo/ai-blog-generator' : fromPage === 3 ? '/content-seo/keyword-content-planner' : '/on-page-seo/list',
        }
        // 返回 On-Page SEO 列表页时带上当前类型，便于列表页定位对应 tab
        if (path.pathname === '/on-page-seo/list') {
            const LIST_TAB_TYPE_MAP = {
                product: 'product',
                blog: 'blog',
                collections: 'collection',
                otherpage: 'page',
            };
            const _pagetype = pagetypeRef.current || pagetype;
            path.query = {
                back_tabType: LIST_TAB_TYPE_MAP[_pagetype] || 'product',
            };
        }
        // 判断是否返回
        if (isBack) {
            props.history.push(path);
        } else {
            // 需要判断是否存在任务
            if (isShowSaveBarRef.current) {
                handleChangeSavebarState(true, 'goBack');
            } else if (insertLoading) {
                handleChangeInsertLinkState(true, 'goBack');
            } else if (autoOptimizeLoading) {
                handleCancelAutoOptTip();
            } else {
                props.history.push(path);
            }
        }
    }

    // 关闭视频审核
    const handleCloseVideoAudit = () => {
        setIsShowVideoAudit(false);
        props.requestStateSet('videoAudit', 0);
    }

    // 联系客服
    const handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            props.toggleToast(t("Try again later"), true);
        }
    }

    // 重新获取分析数据
    const updateDataAnalysis = () => {
        getBlogAnalysisData({ id: getCurrentEntityId() }, 're-intent');
    }

    // 复制链接
    const copyUrlRes = (url) => {
        props.toggleToast(t("Copy successfully!"), false);
        utils.CopyText(url);
    }

    // 复制所有关键词
    const handleCopyAllKeywords = (data) => {
        props.toggleToast(t("Copy successfully!"), false);
        const keywords = data.map(item => item.keyword).join('\n');
        utils.CopyText(keywords);
    }

    // 设置活动关键词
    const handleSetActiveKeyword = (keyword, status) => {
        // isActivePreviewRef.current = Boolean(activeKeyword === keyword ? '' : keyword);
        patchSettingState({
            activeKeyword: activeKeyword === keyword ? '' : keyword,
            activeKeyStatus: status || 0,
        });
    }

    // 关键词覆盖容器监听
    const handleMouseEventKC = (type, col, list) => {
        if (!col && list.length === 0) return;
        keywordCoverageMouseTypeRef.current = type;
    }

    // 设置悬停关键词
    const handleSetHoverKeyword = (keyword, status) => {
        // isHoverPreviewRef.current = Boolean(keyword);
        patchSettingState({
            hoverKeyword: hoverKeyword === keyword ? '' : keyword,
            hoverKeyStatus: status || 0,
        });
    }

    // 设置路由参数
    const handleSetRouteParams = (type = 'blog', data) => {
        // 按类型取实体 id（state 参数已是最新，避免闭包旧值）
        const Rid = data?.from === 'Sidekick' ? data.id :
            type === 'product' ? data.productId :
                type === 'collections' ? data.collectionId :
                    type === 'blog' ? data.articleId :
                        type === 'otherpage' ? data.pageId : data.productId;

        // 判断是否退出详情
        const is_current_url = props.history.location.pathname.includes('/on-page-seo/content-edit');
        if (is_current_url) {
            let id = Rid;
            let _from = data?.from || '';
            let from = _from.includes('ContentAudit') ? 1 : _from.includes('AiBlogGenerator') ? 2 : _from.includes('KeywordContentPlanner') ? 3 : 1;
            patchPagePublicState({ fromPage: from })
            if (id) {
                window.history.replaceState(null, "", `/on-page-seo/content-edit?id=${id}&from=${from}&type=${type}`);
            }
        }
    }

    // 重新分析
    const handleRefreshAnalysis = () => {
        getBlogAnalysisData({ id: getCurrentEntityId() }, 'refresh');
    }

    // 自动优化弹窗数据输入
    const handleInputOptModalData = (v, e) => {
        const compare = {
            "optTitleValue": "title",
            // "optDescValue": "description",
            "optMetaTitleValue": "meta_title",
            "optMetaDescriptionValue": "meta_description",
            "optUrlValue": "url_slug",
        }
        let newData = cloneDeep(autoOptimizeModalData);
        newData[compare[e]] = v;
        setAutoOptimizeModalData(newData);
    }

    // 富文本内容输入
    const handleTransOptModalData = (e) => {
        let newOpt = cloneDeep(autoOptimizeModalData);
        newOpt.description = e;
        setAutoOptimizeModalData(newOpt);
        setDescSetNumModal(descSetNumModal + 1);
    }

    // 产品标签输入（优化对比弹窗内）
    const handleTagsOptModalData = (data) => {
        let newOpt = cloneDeep(autoOptimizeModalData);
        newOpt.product_tags = data.map(item => item.value);
        setAutoOptimizeModalData(newOpt);
    }

    // 汇总图片数组
    const handleSummaryImgs = (data = {}) => {
        let _html = descValue || data?.body_html || '';
        if (_html) {
            // 在富文本内容提取所有图片
            const imgReg = /<img[^>]+src="([^"]+)"[^>]*>/gi;
            const imgMatches = _html.match(imgReg);
            let imgArr = [];
            if (imgMatches) {
                imgMatches.forEach(match => {
                    const imgSrc = match.match(/src="([^"]+)"/i)[1];
                    const imgAlt = match.match(/alt="([^"]+)"/i)?.[1] || '';
                    imgArr.push({
                        src: imgSrc,
                        alt: imgAlt || '',
                        collectionType: collectionType,
                        blog_id: data?.blog_id || blogId,
                        id: getCurrentEntityId(),
                    });
                });
            }
            return imgArr;
        } else {
            return [];
        }
    }

    // 跳转产品结构化设置页
    const handleRedirectProductSchema = () => {
        // 判断是否保存
        if (isShowSaveBarRef.current) {
            handleChangeSavebarState(true, 'handleRedirectProductSchema');
            return;
        } else {
            // 跳转组织设置页
            const _search = new URLSearchParams(window.location.search);
            const id = _search.get('id');
            const from = _search.get('from');
            const _type = _search.get('type');
            const path = `/technicalSEO/structured-data/product`;
            props.history.push(path, {
                id,
                from,
                type: _type,
            });
        }
    }

    // 跳转组织结构化设置页
    const handleRedirectOriganizationSchema = () => {
        // 判断是否保存
        if (isShowSaveBarRef.current) {
            handleChangeSavebarState(true, 'handleRedirectOriganizationSchema');
            return;
        } else {
            // 跳转组织设置页
            const _search = new URLSearchParams(window.location.search);
            const id = _search.get('id');
            const from = _search.get('from');
            const _type = _search.get('type');
            const path = `/technicalSEO/structured-data/organization`;
            props.history.push(path, {
                id,
                from,
                type: _type,
            });
        }
    }

    // 跳转帮助中心
    const handleRedirectHelpCenter = () => {
        // 跳转帮助中心页
        const path = `${process.env.PUBLIC_HELP_CENTER_ADMIN}/content-optimization/troubleshooting/content-audit/c9/`;
        window.open(path, '_blank');
    }

    // 修复对应事件
    const handleFixItem = (type) => {
        if (isEditObjState || insertLoading || autoOptimizeLoading || fixLoadingType) return;
        switch (type) {
            case 'keyword_type_match':
                handleToggleSettingSearch(true);
                break;
            case 'product_tags':
                setFixLoadingType(type);
                handleGenerateTags();
                props.toggleToast(t("Generating product tags") + '...');
                break;
            case 'return_schema':
            case 'shipping_schema':
                // 跳转组织结构化设置页
                handleRedirectOriganizationSchema();
                break;
            case 'review_schema':
                // 跳转产品结构化设置页
                handleRedirectProductSchema();
                break;
            case 'h1_single':
                handleRedirectHelpCenter();
                break;
            case 'product_schema':
            case 'breadcrumb_schema':
            case 'article_schema':
                setFixLoadingType(type);
                setStructureModalType(type);
                break;
            case 'faq_schema':
                setStructureModalType(type);
                setTimeout(() => {
                    if (windowWidth > 1200) {
                        scrollToSite('bottom');
                    }
                    setStructureModalType('');
                }, 100);
                break;
            case 'images':
                fixImageRef.current = 'ContentImage';
                let init = initPageData?.data || initPageData;
                let allImgs = handleSummaryImgs(init);
                const _fixPtype = pagetypeRef.current || pagetype;
                if (_fixPtype === 'product') {
                    // 产品多图：把所有产品媒体图加进去（标记 isFeature，便于回写区分）
                    const prodImgs = (featureImages || [])
                        .filter((img) => img?.src || img?.data)
                        .map((img) => ({
                            id: img.id ?? '',
                            src: img.src || img.data || '',
                            alt: img.alt ?? img.altText ?? '',
                            collectionType: collectionType,
                            blog_id: blogId,
                            isFeature: true,
                        }));
                    allImgs = [...prodImgs, ...allImgs];
                } else {
                    let m_img = cloneDeep(imageInfo);
                    // 把主图也加进去
                    if (m_img?.src) {
                        m_img.isMain = true;
                        allImgs.unshift(m_img);
                    }
                }
                if (allImgs.length > 0) {
                    let data = {
                        isCustomize: true,
                        ...init,
                        all_images: JSON.stringify(allImgs),
                    }
                    setEditImageAltData(data);
                } else {
                    props.toggleToast(t("No images found"), true);
                }
                break;
            default:
                break;
        }
    }

    // 结构化数据开关修复完成（清除 FIX loading，并重置类型以便再次触发）
    const handleFixSchemaDone = (isTip = false) => {
        setFixLoadingType('');
        setStructureModalType('');
        if (isTip) {
            props.toggleToast(t("Schema enabled."));
        }
    }

    // 元描述全部文字版
    const DrimAll = (str) => {
        //换行处理
        if (typeof str !== 'string') str = String(str || '');
        str = str.replace(/<script.*>.*<\/script>/gs, '');
        str = str.replace(/<style.*>.*<\/style>/gs, '');
        str = str.replace(/<\/?.+?>/g, "");
        str = str.replace(/\s[\r\n]/g, " ");
        //空格处理
        str = str.replace(/\s+/g, ' ');
        //转意符换成普通字符
        var arrEntities = { 'lt': '<', 'gt': '>', 'amp': '&', 'quot': '"' };
        str = str.replace(/&(lt|gt|amp|quot);/ig, function (all, t) { return arrEntities[t]; });
        return str;
    }

    // 限制文字长度
    const limitDescNums = (str) => {
        if (str.length > 240) {
            if (str.replace(/\s+/g, "") === str) {
                str = str.substring(0, 240) + '...';
            } else {
                let i = 240 + 1;
                let char = str.substring(i - 1, i);
                while (char.replace(/\s+/g, "").length !== 0) {
                    i--;
                    char = str.substring(i - 1, i);
                }
                str = str.substring(0, i - 1) + '...';
            }
        }
        return str;
    }

    // 应用自动优化更改
    const handleApplyAutoOptChanges = (key, data) => {
        // 需要加purple
        const compare = {
            'title': 'titleValue',
            'content': 'descValue',
            'meta': ['metaTitleValue', 'metaDescriptionValue', 'urlValue'],
            'tags': 'productTags',
        }
        let purpleArray = cloneDeep(optPurpleArray);
        if (Array.isArray(compare[key])) {
            compare[key].forEach(item => {
                if (!purpleArray.includes(item)) {
                    if ((item === 'metaTitleValue' && autoOptimizeData?.meta_title) || (item === 'metaDescriptionValue' && autoOptimizeData?.meta_description) || (item === 'urlValue' && autoOptimizeData?.url_slug)) {
                        purpleArray.push(item);
                    }
                }
            })
        } else {
            if (!purpleArray.includes(compare[key])) {
                purpleArray.push(compare[key]);
            }
        }

        setOptPurpleArray(purpleArray);
        setAutoOptCompareKey(null);
        switch (key) {
            case 'title':
                patchSettingState({ titleValue: data.title });
                break;
            case 'content':
                patchSettingState({ descValue: data.description });
                break;
            case 'meta':
                patchSettingState({
                    metaTitleValue: (data?.meta_title === '' ? '' : (data?.meta_title || metaTitleValue)),
                    metaDescriptionValue: (data?.meta_description === '' ? '' : (data?.meta_description || metaDescriptionValue)),
                    urlValue: (data?.url_slug === '' ? '' : (data?.url_slug || urlValue)),
                });
                break;
            case 'tags':
                patchSettingState({ productTags: data?.product_tags || productTags });
                break;
            default:
                break;
        }

        props.toggleToast(t("Apply Changes successful."));
    }

    // 改变保存栏状态
    const handleChangeSavebarState = (state, type = '') => {
        setNotSaveModalOpen(state);
        setNextStepType(type);
        // 关闭并清除状态
        if (!state) {
            setUnsaveConfirmLoading(false);
        }
    }

    // 改变插入内链状态
    const handleChangeInsertLinkState = (state, type = '') => {
        patchSettingState({
            cancelInsertOpen: state,
        });
        setInsertNextStepType(type);
        // 关闭并清除状态
        if (!state) {
            setInsertConfirmLoading(false);
        }
    }

    // 改变自动优化状态
    const handleChangeAutoOptimizeState = (state, type = '') => {
        patchSettingState({
            cancelAutoOptModalOpen: state,
        });
        setAutoOptimizeNextStepType(type);
        // 关闭并清除状态
        if (!state) {
            setAutoOptimizeConfirmLoading(false);
        }
    }

    // 未保存提示
    useEffect(() => {
        if (notSaveModalOpen) {
            const isShopify = window.shopify;
            if (isShopify) {
                isShopify.saveBar.leaveConfirmation();
            } else {
                props.toggleToast(t("Data not saved"));
            }
        }
    }, [notSaveModalOpen])

    // 设置国家信息
    useEffect(() => {
        patchCountryState({
            currents: Countrys[0],
            countryView: Countrys.slice((cpage - 1) * csize, (cpage * csize)),
            countryLens: Countrys.length,
            locationId: Countrys[0].id,
        });
    }, [Countrys])

    // 刷新 / 关闭页面
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if ((insertLoading || autoOptimizeLoading) && e) {
                e.preventDefault();
                e.returnValue = ''; // 必须设置，浏览器才会弹提示
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [insertLoading, autoOptimizeLoading]);

    // 监听选择项
    useEffect(() => {
        handleDisabledPageChange();
        // 判断id还在不在当前列表
        const currentId = Array.isArray(selectItem) ? selectItem[0] : selectItem;
        const idx = tableList.findIndex((row) => getListRowKey(row) === currentId);
        if (idx !== -1) {
            patchPageInfoState({
                // c_id: currentId,
                c_page: page,
                c_size: size,
            });
        }
    }, [tableList, selectItem])

    // 判断内容是否修改，显示保存栏
    useEffect(() => {
        // 更新提示
        patchSettingState({
            metaTitleTip: titleValue,
            metaDescriptionTip: limitDescNums(DrimAll(descValue)),
        })

        if (initState) {
            let isChange = false;
            let init = initPageData?.data ? initPageData.data : initPageData;
            let isMoreLang = Boolean(isEditObjState && curLanguageSel);
            // 是否多语言
            if (!isMoreLang) {
                // 评分由统一的 scoreInput effect 处理，这里只负责判断是否显示保存栏
                // 如果鼠标进入关键词覆盖容器，则不判断是否修改  || keywordCoverageMouseTypeRef.current === 'leave'
                if (keywordCoverageMouseTypeRef.current === 'enter') {
                    return;
                }
                // 判断是否修改
                // console.log('CHANGE:', descSetNum, init.title !== titleValue, (init.body_html !== descValue && descSetNum > 1), (init?.images && init?.images?.length !== featureImages?.length), (featureImages?.length > 0 && featureImages[0]?.alt !== imageInfo?.alt), init.seo_title !== metaTitleValue, init.seo_desc !== metaDescriptionValue, init.handle !== urlValue, (files.length > 0));
                // 产品多图：比对顺序 + 内容(src/alt)，覆盖 拖拽排序/新增/删除/改alt 场景
                const normProductImgs = (arr = []) => JSON.stringify(
                    (arr || []).map((i) => ({ id: i?.id ?? '', src: i?.src || i?.data || '', alt: i?.alt ?? i?.altText ?? '' }))
                );
                const isProductImagesChanged = pagetype === 'product'
                    && normProductImgs(init?.images) !== normProductImgs(featureImages);

                if (
                    (init.title !== titleValue) ||
                    (init.body_html !== descValue && descSetNum > 1) ||
                    (init?.images && init?.images?.length !== featureImages?.length) ||
                    (featureImages?.length > 0 && featureImages[0]?.alt !== imageInfo?.alt) ||
                    isProductImagesChanged ||
                    (init.seo_title !== metaTitleValue) ||
                    (init.seo_desc !== metaDescriptionValue) ||
                    (init.handle !== urlValue) ||
                    (files.length > 0) ||
                    (pagetype === 'product' && JSON.stringify(init.product_tags ?? []) !== JSON.stringify(productTags ?? []))
                ) {
                    isChange = true;
                }
                isShowSaveBarRef.current = isChange;
                patchPagePublicState({
                    isShowSaveBar: isChange
                });
            } else {
                // 判断是否修改
                if (
                    (init.title !== titleValue) ||
                    (init.body_html !== descValue && descSetNum > 1) ||
                    (init.seo_title !== metaTitleValue) ||
                    (init.seo_desc !== metaDescriptionValue)
                ) {
                    isChange = true;
                }
                isShowSaveBarRef.current = isChange;
                patchPagePublicState({
                    isShowSaveBar: isChange
                });
            }
        }
    }, [initPageData, descSetNum, titleValue, descValue, featureImages, metaTitleValue, metaDescriptionValue, urlValue, files, productTags])

    useEffect(() => {
        let isChange = false;
        if (originSearchSettings.keyword !== targetKeywordPreviewValue || originSearchSettings.language !== aiLang || originSearchSettings.location !== currents?.abb) {
            isChange = true;
        }
        patchSettingState({
            settingChangeState: isChange,
        });
    }, [originSearchSettings, targetKeywordPreviewValue, currents, aiLang])

    // 切换覆盖率标签
    const handleChangeCoverageTab = (tab) => {
        setCoverageTab(tab);
        patchSettingState({
            activeKeyword: '',
            activeKeyStatus: 0,
        })
    }

    const stripKeywordHighlightSpans = (html = '', type = 'active') => {
        const classPrefix = type === 'hover' ? 'hover_match_' : 'match_';
        return html.replace(new RegExp(`<span class="${classPrefix}(?:green|yellow|red)">([\\s\\S]*?)<\\/span>`, 'gi'), '$1');
    };

    const applyKeywordHighlight = (html = '', keyword = '', highlightClass = '', tab = 'all') => {
        if (!keyword || !highlightClass) return html;

        const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const keywordRe = new RegExp(escaped, 'gi');
        const startsWithWordChar = /^[A-Za-z0-9_]/.test(keyword);
        const endsWithWordChar = /[A-Za-z0-9_]$/.test(keyword);
        const isWordChar = (char = '') => /[A-Za-z0-9_]/.test(char);
        const replaceMatch = (content = '') =>
            content.replace(keywordRe, (match, offset, source = '') => {
                const prevChar = source[offset - 1] || '';
                const nextChar = source[offset + match.length] || '';
                const hasLeadingBoundary = !startsWithWordChar || !isWordChar(prevChar);
                const hasTrailingBoundary = !endsWithWordChar || !isWordChar(nextChar);

                return hasLeadingBoundary && hasTrailingBoundary
                    ? `<span class="${highlightClass}">${match}</span>`
                    : match;
            });

        if (tab === 'headings') {
            return html.replace(/<(h[1-6])(\b[^>]*)>([\s\S]*?)<\/\1>/gi, (fullMatch, tagName, attrs = '', innerHtml = '') => {
                return `<${tagName}${attrs}>${replaceMatch(innerHtml)}</${tagName}>`;
            });
        }

        return replaceMatch(html);
    };

    // 生成tags（点击 Get Suggestions）：AI 生成推荐 Tags，不修改原有输入框内容
    const handleGenerateTags = async () => {
        if (insertLoading || autoOptimizeLoading || isEditObjState || autoGenerateTagsLoading) {
            return;
        }
        patchSettingState({
            autoGenerateTagsLoading: true,
        })
        let params = {
            id: productId,
        }
        const res = await reqGetAiProductTags(params);
        if (res.ack === 1) {
            let result = res?.data?.product_tags || [];
            // 直接展示接口返回的全部推荐项，交给用户选择，不做任何过滤
            patchSettingState({
                recommendTags: result,
                showRecommendTags: true,
            })
            setFixLoadingType('');
        } else {
            setErrorBanner(res.msg);
        }

        patchSettingState({
            autoGenerateTagsLoading: false,
        })
    }

    // 点击单个推荐 Tag：直接添加到输入框，被点击的推荐项自动消失
    const handleAddRecommendTag = (tag, index) => {
        if (globalLoading || isEditObjState) {
            return;
        }
        // 从推荐列表移除被点击的这一项（按下标移除，避免误删同名项）
        const nextRecommend = (recommendTags || []).filter((_, i) => i !== index);
        // 已存在于输入框则不重复添加；受 TagTextInput 的 maxTags 限制
        const exist = (productTags || []).some(item => item === tag);
        const canAdd = !exist && (productTags || []).length < PRODUCT_TAGS_MAX;
        const nextProductTags = canAdd ? [...(productTags || []), tag] : (productTags || []);
        patchSettingState({
            productTags: nextProductTags,
            recommendTags: nextRecommend,
            // 推荐项被取完后自动关闭推荐区域
            showRecommendTags: nextRecommend.length > 0,
        })
    }

    // Replace all：用全部推荐 Tags 覆盖输入框原有内容
    const handleReplaceAllTags = () => {
        if (globalLoading || isEditObjState) {
            return;
        }
        patchSettingState({
            productTags: (recommendTags || []).slice(0, PRODUCT_TAGS_MAX),
            recommendTags: [],
            showRecommendTags: false,
        })
    }

    // 推荐框的 ×：关闭推荐区域，不影响已有 Tags
    const handleCloseRecommendTags = () => {
        patchSettingState({
            recommendTags: [],
            showRecommendTags: false,
        })
    }

    // 设置主要产品
    const setChangeTagsData = (data, type) => {
        let value = data.map(item => item.value);
        patchSettingState({
            productTags: value,
        })
    }

    // 开启超额
    const handleEnableOverage = async () => {
        setEnableOverageLoading(true);
        const res = await reqUpdEnableOverage();
        if (res.ack === 1) {
            setIsShowOverExcessModal(false);
            getUserComboByCard();
        } else {
            props.toggleToast(t(res.msg), true);
        }

        if (res) {
            setEnableOverageLoading(false);
        }
    }

    // 替换关键词
    const handleReplaceKeyword = (keyword) => {
        let newRecord = cloneDeep(recordData);
        if (newRecord) {
            newRecord.keyword = keyword;
        }
        patchSettingState({
            targetKeywordValue: keyword,
            targetKeywordPreviewValue: keyword,
            recordData: newRecord,
            searchSettingsModalState: true,
            isShowKeywordBannerTip: false,
        });
    }

    // 判断是否符合类型
    const judgeAccordType = () => {
        const accordType = {
            "Product": 'product',
            "Collection": 'collections',
            "Blog Post": 'blog',
            "Other Page": 'otherpage',
        }
        const c_d_pagetype = currentSelectedIntent?.dominant_page_type || '';
        const isAccordType = c_d_pagetype ? Boolean(accordType[c_d_pagetype] === (pagetypeRef.current || pagetype)) : true;

        return isAccordType;
    }

    // 更新类型id
    const updTypeId = (type, id) => {
        const _type = type === 'product' ? 'productId' : type === 'collections' ? 'collectionId' : type === 'blog' ? 'articleId' : type === 'otherpage' ? 'pageId' : '';
        patchPageListState({
            [_type]: id,
        })
    }

    // 关闭替换关键词提示：把当前类型的实体 id 存入 sessionStorage 数组，保证刷新后不再出现
    const handleCloseReplaceTip = (pagetype, entityId) => {
        let newKey = cloneDeep(closedReplaceTipIds) || {};
        newKey[pagetype] = newKey[pagetype] || [];
        newKey[pagetype].push(entityId);
        setClosedReplaceTipIds(newKey);
        try {
            sessionStorage.setItem(REPLACE_TIP_CLOSED_STORAGE_KEY, JSON.stringify(newKey));
        } catch (e) { }
    }

    /*
    ** 监听富文本关键词高亮
    ** 不区分大小写匹配，保留原文大小写；切换关键词时先去掉上一轮高亮再匹配
    */
    useEffect(() => {
        let descContent = cloneDeep(descValue);
        // 判断是否显示
        if (activeKeyword) {
            descContent = stripKeywordHighlightSpans(descContent, 'active');
            const highlightClass = activeKeyStatus === 1 ? 'match_green' : activeKeyStatus === 2 ? 'match_yellow' : 'match_red';
            descContent = applyKeywordHighlight(descContent, activeKeyword, highlightClass, coverageTab);
        } else {
            descContent = stripKeywordHighlightSpans(descContent, 'active');
        }
        patchSettingState({
            descValue: descContent
        })
    }, [activeKeyword, activeKeyStatus, coverageTab, descValue])

    /*
    ** 监听富文本关键词高亮
    ** 不区分大小写匹配，保留原文大小写；切换关键词时先去掉上一轮高亮再匹配
    */
    useEffect(() => {
        let descContent = cloneDeep(descValue);
        // 判断是否显示
        if (hoverKeyword) {
            descContent = stripKeywordHighlightSpans(descContent, 'hover');
            const highlightClass = hoverKeyStatus === 1 ? 'hover_match_green' : hoverKeyStatus === 2 ? 'hover_match_yellow' : 'hover_match_red';
            descContent = applyKeywordHighlight(descContent, hoverKeyword, highlightClass, coverageTab);
        } else {
            descContent = stripKeywordHighlightSpans(descContent, 'hover');
        }
        patchSettingState({
            descValue: descContent
        })
    }, [hoverKeyword, hoverKeyStatus])

    useEffect(() => {
        const _search = new URLSearchParams(props.location.search);

        // 优先Sidekick跳转
        // resource_id格式举例："gid://shopify/Product/{{id}}"
        const resource_id = _search.get('resource_id');
        // 应用内
        const search_id = _search.get('id');
        const search_type = _search.get('type');
        const search_action = _search.get('action');
        const _query = props.location?.query;
        const _pagetype = search_type || _query?.pagetype || 'product';
        pagetypeRef.current = _pagetype; // 同步保存，供后续同步流程立即读取
        patchPagePublicState({ pagetype: _pagetype });

        // 判断参数
        if (resource_id) {
            let rid = resource_id.split('/').pop() || -1;
            let rtype = SIDEKICK_RESOURCE_TYPE_MAP[resource_id.split('/')[1] || 'Product'];
            if (rid === -1) return;

            // 获取列表数据
            getPageList(null, -1, true, true);
            let _state = {
                id: rid,
            }
            getPageDetailData(null, true, false, null, true, _state);
            updTypeId(rtype, rid);
            handleSetRouteParams(rtype, {
                id: rid,
                type: rtype,
                from: 'Sidekick'
            });
        } else if (_query) {
            handleSetPageData(_query);

            // 设置id
            if (!Boolean(search_id)) {
                // 只更新路由不跳转
                handleSetRouteParams(pagetypeRef.current || pagetype, _query);
            }
        } else if (search_action) {
            handleSetPageData(null);
        } else {
            // 判断是否存在id
            if (Boolean(search_id)) {
                // 获取列表数据
                getPageList(null, -1, true, true);
                let _state = {
                    id: search_id,
                }
                getPageDetailData(null, true, false, null, true, _state);
                updTypeId(search_type, search_id);
            } else {
                props.toggleToast(t("Try again later"), true);
                setTimeout(() => {
                    goBack(true);
                }, 1500)
                return;
            }
        }
        // 更新域名
        const _store = store.getState().public;
        patchPagePublicState({
            domain: _store.domain,
        });
        // 获取开关状态
        const _switch = _store.publicInit?.head_data?.switch_data || {};
        setIsShowVideoAudit(_switch?.videoAudit ? false : true);

        // 获取关闭过的替换关键词提示
        try {
            const cache = sessionStorage.getItem(REPLACE_TIP_CLOSED_STORAGE_KEY);
            const parsed = cache ? JSON.parse(cache) : {};
            setClosedReplaceTipIds(parsed);
        } catch (e) { }

        return () => {
            clearTypeInterval('timerArr');
            clearTypeInterval('aiTimerArr');
        }
    }, []);

    // 特殊任务加载状态
    const globalLoading = insertLoading || autoOptimizeLoading;
    const specialTaskLoading = isEditObjState || globalLoading;

    // empty icon
    const emptySearchIcon = <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_16054_42093)">
            <rect x="36.3101" y="40.3711" width="3.7166" height="5.23736" transform="rotate(-47.1295 36.3101 40.3711)" fill="#DADADA" />
            <rect x="38.0854" y="46.082" width="9.29151" height="2.32288" transform="rotate(-47.1295 38.0854 46.082)" fill="#E6E6E6" />
            <path d="M39.7881 47.6602L46.1095 40.8505L55.5535 49.6173C57.4339 51.3629 57.5432 54.3024 55.7976 56.1829C54.052 58.0633 51.1125 58.1726 49.2321 56.427L39.7881 47.6602Z" fill="#838383" />
            <circle cx="23.6474" cy="25.41" r="17.3667" transform="rotate(-10.9199 23.6474 25.41)" stroke="#E6E6E6" strokeWidth="5.64706" />
        </g>
        <defs>
            <clipPath id="clip0_16054_42093">
                <rect width="60" height="60" fill="white" />
            </clipPath>
        </defs>
    </svg>


    // 分页
    const footerContentMsg = <FooterPageSelect
        page={page}
        current_PageSize={current_PageSize}
        total={total}
        isShort={true}
        changePageSize={changePageSize}
        handlePageBlur={handlePageBlur}
    />

    // 重复分析提示banner
    const repeatAnalysisBanner = isShowRepeatAnalysisBanner && <Banner
        title={""}
        tone="warning"
        onDismiss={() => {
            setIsShowRepeatAnalysisBanner(false);
        }}
    >
        <Text variant='bodyMd' as='p'>{t("Selected pages have already been analyzed.")}</Text>
    </Banner>

    // 月限制次数提示banner
    const monthlyLimitBanner = isShowMonthlyLimitBanner && <Banner
        title={t("Monthly SEO Audit limit reached")}
        tone="critical"
        action={{
            content: t("Contact us"),
            onAction: handleContactService
        }}
        onDismiss={() => {
            setIsShowMonthlyLimitBanner(false);
        }}
    >
        <Text variant='bodyMd' as='p'>{t("You've used all {{v1}} SEO Audit analyses available this month. Please contact us if you need additional analyses.", 10)}</Text>
    </Banner>

    // 满足度提示banner
    const fulfillmentTipBanner = Boolean(fulfillmentTip) && <Banner
        tone='critical'
        onDismiss={() => {
            setFulfillmentTip(false)
        }}
    >
        <p>{t("Fulfillment service is not defined for your shop.")}&nbsp;<span className='jump_text' onClick={() => {
            window.open(`${process.env.PUBLIC_HELP_CENTER_ADMIN}/content-optimization/troubleshooting/content-audit/c10/`, "_blank")
        }}>{t("Learn more")}</span></p>
    </Banner>



    // GSC 链接失败提示弹窗
    const gscFailModal = <Modal
        size='small'
        open={gscFailModalOpen}
        onClose={() => setGscFailModalOpen(false)}
        title={t("Unable to connect to Google Search Console")}
        primaryAction={{
            content: t("Authorize again"),
            onAction: () => {
                setGscFailModalOpen(false);
                handleConnectGsc();
            },
            loading: gscConnecting,
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => setGscFailModalOpen(false),
                disabled: gscConnecting,
            },
        ]}
    >
        <Modal.Section>
            <div className='gsc_bind_modal'>
                <div className='gsc_bind_modal_icon'>
                    <img src="/imgs/gsc/connect_fail.png" alt="" />
                </div>
                <p className='gsc_bind_modal_desc'>{t("We couldn't connect to Google Search Console right now due to a temporary network issue or API rate limiting. Please try again in a few minutes.")}</p>
            </div>
        </Modal.Section>
    </Modal>

    // GSC 授权权限不足提示弹窗
    const gscPermissionModal = <Modal
        size='small'
        open={gscPermissionModalOpen}
        onClose={() => setGscPermissionModalOpen(false)}
        title={t("Additional Permission Required")}
        primaryAction={{
            content: t("Authorize again"),
            onAction: () => {
                setGscPermissionModalOpen(false);
                handleConnectGsc();
            },
            loading: gscConnecting,
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => setGscPermissionModalOpen(false),
                disabled: gscConnecting,
            },
        ]}
    >
        <Modal.Section>
            <div className='gsc_bind_modal'>
                <div className='gsc_bind_modal_icon'>
                    <img src="/imgs/gsc/connect_permission.png" alt="" />
                </div>
                <p className='gsc_bind_modal_desc'>{t("We need read-only access to Google Search Console to load your data. Please authorize again and grant all requested permissions on the Google consent screen.")}</p>
            </div>
        </Modal.Section>
    </Modal>

    // 超额弹窗
    const OverExcessModal = <Modal
        open={isShowOverExcessModal}
        title={t("Enable overage to keep analyzing pages")}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => {
                    setIsShowOverExcessModal(false);
                },
                disabled: enableOverageLoading,
            }
        ]}
        primaryAction={{
            content: t("Enable overage"),
            onAction: handleEnableOverage,
            loading: enableOverageLoading,
        }}
        onClose={() => setIsShowOverExcessModal(false)}
    >
        <Modal.Section>
            <BlockStack gap={300}>
                <Text variant='bodyMd' as='p'>{t("You've used all AI Credits this month. Enable overage to keep analyzing pages automatically — billed at $9.90 per 100 credits as needed.")}</Text>
                {(() => {
                    // 根据开关状态展示: 开启的模块才显示对应需要分析的数据和积分; 都未开启则不展示此模块
                    const faqEnabled = Boolean(structuredOptimize?.faq?.pending > 0);
                    const howtoEnabled = Boolean(structuredOptimize?.howto?.pending > 0);
                    if (!faqEnabled && !howtoEnabled) return null;
                    const faqCredits = Math.ceil(structuredOptimize?.faq?.credits_needed);
                    const howtoCredits = Math.ceil(structuredOptimize?.howto?.credits_needed);
                    return (
                        <BlockStack gap={200}>
                            <Text variant='bodyMd' as='p'>{t("The following pages are waiting for analysis")}:</Text>
                            <BlockStack gap={100}>
                                {faqEnabled && (
                                    <Text variant='bodyMd' as='p'>• {t("FAQ Schema: {{v1}} pages (~{{v2}} credits)", structuredOptimize?.faq?.pending, faqCredits)}</Text>
                                )}
                                {howtoEnabled && (
                                    <Text variant='bodyMd' as='p'>• {t("How-to Schema: {{v1}} pages (~{{v2}} credits)", structuredOptimize?.howto?.pending, howtoCredits)}</Text>
                                )}
                            </BlockStack>
                        </BlockStack>
                    );
                })()}
            </BlockStack>
        </Modal.Section>
    </Modal>

    // 开启状态
    const schemaIconStatus = (status = 0) => {
        return status === 0 ? <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="5.25" stroke="#CCCCCC" strokeWidth="1.5" />
        </svg> : status === 1 ? <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6242 7.22465C10.8585 6.99034 10.8585 6.61044 10.6242 6.37613C10.3899 6.14181 10.01 6.14181 9.77564 6.37613L7.3999 8.75186L6.42417 7.77613C6.18985 7.54181 5.80995 7.54181 5.57564 7.77613C5.34132 8.01044 5.34132 8.39034 5.57564 8.62465L6.97564 10.0247C7.20995 10.259 7.58985 10.259 7.82417 10.0247L10.6242 7.22465Z" fill="#27AE60" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.5999 8.00039C13.5999 11.0932 11.0927 13.6004 7.9999 13.6004C4.90711 13.6004 2.3999 11.0932 2.3999 8.00039C2.3999 4.9076 4.90711 2.40039 7.9999 2.40039C11.0927 2.40039 13.5999 4.9076 13.5999 8.00039ZM12.3999 8.00039C12.3999 10.4304 10.43 12.4004 7.9999 12.4004C5.56985 12.4004 3.5999 10.4304 3.5999 8.00039C3.5999 5.57034 5.56985 3.60039 7.9999 3.60039C10.43 3.60039 12.3999 5.57034 12.3999 8.00039Z" fill="#27AE60" />
        </svg> : <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99992 4.80039C8.33129 4.8004 8.59991 5.06903 8.59991 5.4004L8.59986 8.2004C8.59985 8.53177 8.33122 8.8004 7.99985 8.80039C7.66848 8.80038 7.39985 8.53175 7.39986 8.20038L7.39991 5.40038C7.39991 5.06901 7.66854 4.80038 7.99992 4.80039Z" fill="#F1930F" />
            <path d="M8.7999 10.4004C8.7999 10.8422 8.44173 11.2004 7.9999 11.2004C7.55807 11.2004 7.1999 10.8422 7.1999 10.4004C7.1999 9.95856 7.55807 9.60039 7.9999 9.60039C8.44173 9.60039 8.7999 9.95856 8.7999 10.4004Z" fill="#F1930F" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.5999 8.00039C13.5999 11.0932 11.0927 13.6004 7.9999 13.6004C4.90711 13.6004 2.3999 11.0932 2.3999 8.00039C2.3999 4.9076 4.90711 2.40039 7.9999 2.40039C11.0927 2.40039 13.5999 4.9076 13.5999 8.00039ZM12.3999 8.00039C12.3999 10.4304 10.43 12.4004 7.9999 12.4004C5.56985 12.4004 3.5999 10.4304 3.5999 8.00039C3.5999 5.57034 5.56985 3.60039 7.9999 3.60039C10.43 3.60039 12.3999 5.57034 12.3999 8.00039Z" fill="#F1930F" />
        </svg>
    }

    // 上传图片组成
    const validImageTypes = ['image/jpeg', 'image/png'];
    const fileUpload = !files.length && (
        <DropZone.FileUpload actionHint={t("Accepts .jpg, and .png")} />
    );

    // 伸缩列表图标
    const toggleListIcon = <span className={`toggle_list_icon flex_layout ${sidePanel === 'left' ? 'left_icon' : 'right_icon'}`}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5C6.41421 5 6.75 5.33579 6.75 5.75V14.25C6.75 14.6642 6.41421 15 6 15C5.58579 15 5.25 14.6642 5.25 14.25V5.75C5.25 5.33579 5.58579 5 6 5ZM13.4541 5.23633C13.738 4.93472 14.212 4.92027 14.5137 5.2041C14.8153 5.48797 14.8297 5.96204 14.5459 6.26367L11.0303 10L14.5459 13.7363C14.8297 14.038 14.8153 14.512 14.5137 14.7959C14.212 15.0797 13.738 15.0653 13.4541 14.7637L9.4541 10.5137C9.18238 10.2249 9.18238 9.7751 9.4541 9.48633L13.4541 5.23633Z" fill="#4A4A4A" />
        </svg>
    </span>

    // 空模块
    const emptyModule = (text = "") => {
        return <div className='audit_empty_module'>
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_11100_18524)">
                    <rect width="60" height="60" fill="white" />
                    <rect x="36.3108" y="40.373" width="3.7166" height="5.23736" transform="rotate(-47.1295 36.3108 40.373)" fill="#8c9196" />
                    <rect x="38.0867" y="46.082" width="9.29151" height="2.32288" transform="rotate(-47.1295 38.0867 46.082)" fill="#8c9196" />
                    <path d="M39.7893 47.6602L46.1107 40.8505L55.5547 49.6173C57.4352 51.3629 57.5445 54.3024 55.7988 56.1829C54.0532 58.0633 51.1137 58.1726 49.2333 56.427L39.7893 47.6602Z" fill="#8c9196" />
                    <circle cx="23.6486" cy="25.41" r="17.3667" transform="rotate(-10.9199 23.6486 25.41)" stroke="#8c9196" strokeWidth="5.64706" />
                </g>
                <defs>
                    <clipPath id="clip0_11100_18524">
                        <rect width="60" height="60" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <Text as='p' variant='bodyMd' tone='subdued'>{text ? t(text) : t("No data to show here")}</Text>
        </div>
    }

    // 错误banner
    const errorBanner = isShowErrorTip && <Banner
        title={t(isShowErrorTip)}
        tone="critical"
        onDismiss={() => {
            patchPageListState({ isShowErrorTip: '', })
        }}
        action={{
            content: t("Contact us"),
            onAction: handleContactService
        }}
    ></Banner>

    // // 审计教学视频
    // const contentAuditVM = <Modal title={t("Shopify SEO Made Easy: Shopify Speed for Beginners | Ep.2")}
    //     size="large"
    //     open={contentAuditVMState}
    //     onClose={() => setContentAuditVMState(false)}>
    //     <div className={'youtube-video-box'}>
    //         <iframe width="560" height="315" src="https://www.youtube.com/embed/esikd7t5HZE?si=xs1bgNgq7i9T97mk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    //     </div>
    // </Modal>

    // 未保存弹窗
    const notSaveModal = <Modal
        size='small'
        title={t("Unsaved changes")}
        open={notSaveModalOpen}
        onClose={() => handleChangeSavebarState(false, '')}
        secondaryActions={[
            {
                content: t("Go Back"),
                onAction: () => handleChangeSavebarState(false, ''),
                disabled: unsaveConfirmLoading
            }
        ]}
        primaryAction={{
            content: t("Continue Anyway"),
            onAction: () => handleNotSaveModalConfirm(nextStepType),
            loading: unsaveConfirmLoading,
        }}
    >
        <Modal.Section>
            <Text as='p' variant='bodyMd'>{t("You have unsaved changes. If you continue, your edits may be lost.")}</Text>
        </Modal.Section>
    </Modal>

    // 历史记录弹窗
    const historyRecordModal = (
        <Modal
            size="small"
            title={t('Version History')}
            open={historyRecordModalOpen}
            onClose={() => setHistoryRecordModalOpen(false)}
        >
            <Modal.Section>
                {
                    versionHistoryRecords.length > 0 ? (<BlockStack gap="300">
                        {versionHistoryRecords.map((item) => {
                            const selected = selectedHistoryVersionId === item.id;
                            return (
                                <Tooltip
                                    key={item.id}
                                    content={t('Click to preview. Use the Save bar to apply this version.')}
                                >
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => handleHistoryVersionPreview(item)}
                                        style={{ cursor: 'pointer' }}
                                        className='history_record_item'
                                    >
                                        <InlineStack align="space-between" blockAlign="start" gap="400" wrap={false}>
                                            <BlockStack gap={200}>
                                                <BlockStack gap={100}>
                                                    <div className='flex_layout'>
                                                        <Text as="h3" variant="headingMd" fontWeight="semibold">
                                                            {t(item.title)}
                                                        </Text>
                                                        {
                                                            selected && <Badge tone="success">{t("Current")}</Badge>
                                                        }
                                                    </div>
                                                    <Text as="p" variant="bodySm" tone="subdued">
                                                        {t(item.description)}
                                                    </Text>
                                                </BlockStack>
                                                <div className='record_timeline'>
                                                    <span className='flex_layout'><Icon source={ClockIcon} tone="subdued" /></span>
                                                    <Text as="span" variant="bodySm" tone="subdued">
                                                        {t(item.timeLabel)}
                                                    </Text>
                                                </div>
                                            </BlockStack>
                                            <div className='history_record_item_actions'>
                                                <Button
                                                    variant="plain"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleHistoryVersionPreview(item);
                                                    }}
                                                >
                                                    {t('Preview')}
                                                </Button>
                                            </div>
                                        </InlineStack>
                                    </div>
                                </Tooltip>
                            );
                        })}
                    </BlockStack>) : emptyModule(t("No record"))
                }

            </Modal.Section>
        </Modal>
    );

    // 取消插入内链弹窗
    const cancelInsertModal = <Modal
        size='small'
        title={t("Cancel internal link insertion?")}
        open={cancelInsertOpen}
        secondaryActions={[
            {
                content: t("Go Back"),
                onAction: () => patchSettingState({ cancelInsertOpen: false }),
                disabled: insertConfirmLoading,
            }
        ]}
        primaryAction={{
            content: t("Confirm"),
            onAction: () => handleInsertCancelConfirm(insertNextStepType),
            loading: insertConfirmLoading,
        }}
        onClose={() => patchSettingState({ cancelInsertOpen: false })}
    >
        <Modal.Section>
            <Text as='p' variant='bodyMd'>{t("The internal linking process will be stopped.")}</Text>
            <Text as='p' variant='bodyMd'>{t("{{v1}} credits have already been deducted.", 2)}</Text>
        </Modal.Section>
    </Modal>

    // 编辑图片alt弹窗
    const altState = (Boolean(editImageAltData?.all_images) ? JSON.parse(editImageAltData?.all_images || []) : []).length > 0;
    const AltEditModal = Boolean(altState) && <OptimizeImageAlt
        isCustomize={Boolean(editImageAltData?.isCustomize)}
        active={true}
        SelectType={pagetype}
        TargetId={pagetype === 'blog' ? editImageAltData.article_id : editImageAltData.id}
        editBlogId={pagetype === 'blog' ? editImageAltData.blog_id : 0}
        editCollectionType={pagetype === 'collections' ? editImageAltData.collection_type : ''}
        AllImages={JSON.parse(editImageAltData.all_images) || []}
        Title={decodingTitle(editImageAltData.title)}
        ProductType={''}
        Vendor={''}
        ShopName={shopName}
        Keyword={editImageAltData.primary_keywords}
        AltTemplate={''}
        updateDataList={updateDataList}
        callBackRefresh={callBackRefresh}
        closeAltEditModal={closeAltEditModal}
        bulkAltConfig={bulkAltConfig}
        updateCustomizeAlt={updateCustomizeAlt}
        updPageDetailData={updPageDetailData}
    />

    // 页面选择弹窗
    const pagesListModal = <PagesModal
        openState={pagesModalOpen}
        selectPageIdArr={selectPageIdArr}
        handleGetSelectId={handleGetSelectId}
        onClose={() => setPagesModalOpen(false)}
    />

    // 选择关键词提示
    const chooseTipsCase = <div className='set_keyword_tips'>
        <Text as='span' variant='bodySm'>{t("Choose a keyword that matches this page's main topic and intent.")}</Text>&nbsp;
        <Tooltip width={'wide'} content={<p className='s_tip_content'>
            <span className='s_tip_title'><span className='s_tip_sign'>{t("Product")}:</span> {t("Focus on specific product-focused keywords with clear purchase intent.")}</span>
            <span>{t("✅ black racerback sports bra")}</span>
            <span className='s_tip_title'><span className='s_tip_sign'>{t("Collection")}:</span> {t("Focus on broader category-level keywords that describe the full collection.")}</span>
            <span>{t("✅ high impact sports bras")}</span>
            <span className='s_tip_title'><span className='s_tip_sign'>{t("Blog post")}:</span> {t("Focus on informational or comparison-based topics.")}</span>
            <span>{t("✅ how to choose a high impact sports bra")}</span>
        </p>}>
            <span className='set_keyword_tips_link'>{t("Tips")}</span>
        </Tooltip>
    </div>

    // 搜索设置弹窗
    const SearchSettingsModal = <SelectTargetKeyword
        open={searchSettingsModalState}
        onClose={() => handleToggleSettingSearch(false)}
        chooseTipsCase={chooseTipsCase}
        titleValue={titleValue}
        targetKeywordPreviewValue={targetKeywordPreviewValue}
        isShowKeywordSugPop={isShowKeywordSugPop}
        onInputChange={handleInputChange}
        onFocusSearch={handleFocusSearch}
        patchSettingState={patchSettingState}
        isShowSuggestion={isShowSuggestion}
        recommendLoading={recommendLoading}
        onGetAiSuggestion={handleGetAiSuggestionData}
        keywordSearchLoading={keywordSearchLoading}
        keywordSugData={keywordSugData}
        customeSetState={customeSetState}
        onSelectCustomValue={handleSelectCustomValue}
        isGscConnected={isGscConnected}
        rankingKeywordsList={rankingKeywordsList}
        rankingLoading={rankingLoading}
        recommendKeywordsList={recommendKeywordsList}
        keywordTabSel={keywordTabSel}
        onGetSearchPerformance={getSearchPerformanceData}
        isShowGscBanner={isShowGscBanner}
        gscConnecting={gscConnecting}
        onConnectGsc={handleConnectGsc}
        isRepetitionKey={isRepetitionKey}
        isShowRepetitionKeyBanner={isShowRepetitionKeyBanner}
        isShowAccordTypeBanner={isShowAccordTypeBanner}
        pagetype={pagetype}
        judgeAccordType={judgeAccordType}
        getSourceTypeText={getSourceTypeText}
        isShowAudienceLocal={isShowAudienceLocal}
        currents={currents}
        patchCountryState={patchCountryState}
        aiLang={aiLang}
        aiLangLabel={aiLangLabel}
        nationState={nationState}
        languageState={languageState}
        togglePopSelect={togglePopSelect}
        countryValue={countryValue}
        countryView={countryView}
        countryLens={countryLens}
        onSelectCountry={selectCountryData}
        getMoreCountry={getMoreCountry}
        onSelectLanguage={selectLanguageData}
        researchLoading={researchLoading}
        settingChangeState={settingChangeState}
        onStartResearch={handleStartResearch}
    />

    // 左侧列表
    const LeftCardMain = <Card padding={0}>
        <div className={`left_page_list`}>
            <Scrollable shadow>
                <SearchFilterList
                    total={total}
                    queryVal={searchQuery}
                    pagetype={pagetype}
                    tableDataList={tableList}
                    tableListLoading={tableListLoading}
                    windowWidth={windowWidth}
                    selectItem={selectItem}
                    issueListData={issueListData}
                    selectItemTag={selectItemTag}
                    selectItemTagNums={selectItemTagNums}
                    issueValueSel={issueValueSel}
                    pageLoading={pageLoading}
                    scoreListData={scoreListData}
                    seoScoreSel={seoScoreSel}
                    focusKeywordListData={focusKeywordListData}
                    focusKeywordSel={focusKeywordSel}
                    blogVisibleData={blogVisibleData}
                    onpage_BlogVisible={onpage_BlogVisible}
                    productStatusData={productStatusData}
                    onpage_ProductStatus={onpage_ProductStatus}
                    faqSchemaSel={faqSchemaSel}
                    howtoSchemaSel={howtoSchemaSel}
                    productTagSel={productTagSel}
                    productTagListData={productTagListData}
                    clearFilterTag={clearFilterTag}
                    onFiltersClearAll={handleFiltersClearAll}
                    setIssueTypeChange={setIssueTypeChange}
                    setSearchQuery={handleSetSearchQuery}
                    handleChangeItemObj={handleChangeItemObj}
                    // openAltOperaData={openAltOperaData}
                    setSeoScoreChange={setSeoScoreChange}
                    setFocusKeywordChange={setFocusKeywordChange}
                    setOnpageProductStatusChange={setOnpageProductStatusChange}
                    setOnpageBlogVisibleChange={setOnpageBlogVisibleChange}
                    setFaqSchemaChange={setFaqSchemaChange}
                    setHowtoSchemaChange={setHowtoSchemaChange}
                    setProductTagChange={setProductTagChange}
                />
            </Scrollable>
            {
                tableList.length > 0 && <div className={`justify_center onpage_detail_pagination`}>
                    <Pagination
                        label={footerContentMsg}
                        hasPrevious={listPre && !tableListLoading}
                        onPrevious={() => changeListPage(page - 1)}
                        hasNext={listNext && !tableListLoading}
                        onNext={() => changeListPage(page + 1)}
                    />
                </div>
            }
        </div>
    </Card>

    // 中间主内容
    const CenterCardMain = <BlockStack gap={400}>
        {fulfillmentTipBanner}
        {errorBanner}
        {monthlyLimitBanner}
        <Card>
            <BlockStack gap={400}>
                <div className={`title_bar ${optPurpleArray.includes('titleValue') ? 'purple_input' : ''}`}>
                    <TextField
                        id="titleValue"
                        label={t("Title")}
                        value={titleValue}
                        onChange={handleInputChange}
                        autoComplete="off"
                        placeholder={t("Enter the title")}
                        disabled={globalLoading || (editableObj.filter(i => i['key'] === 'title').length === 0 && isEditObjState)}
                        error={!titleValue ? t("Title is required") : titleValue.length > 255 ? t("Title is too long (maximum is {{v1}} characters)", 255) : null}
                    />
                </div>

                <div className={`content_bar ${optPurpleArray.includes('descValue') ? 'purple_input' : ''}`}>
                    <BlockStack gap={100}>
                        <Text variant="bodyMd" as="p">{t("Content")}</Text>
                        <TinyMce
                            id={"content_tiny_mac"}
                            minHeight={500}
                            maxHeight={500}
                            disabled={globalLoading || (editableObj.filter(i => i['key'] === 'body_html').length === 0 && isEditObjState)}
                            isFocus={TinyMceFocus}
                            trans_content={descValue}
                            onTransChange={onTransChange}
                            onTransFocus={onTransFocus}
                            enableFind
                            findKeyword={activeKeyword}
                            onFindClose={() => handleSetActiveKeyword(activeKeyword, activeKeyStatus)}
                        />
                    </BlockStack>
                </div>

                {
                    Boolean(isEditObjState) ? null : (
                        ['product'].includes(pagetype) ? (
                            <ProductMediaGrid
                                images={featureImages || []}
                                loading={uploadLoading}
                                disabled={specialTaskLoading}
                                onUpload={handleProductMediaUpload}
                                onRemove={handleProductMediaRemove}
                                onReorder={handleProductMediaReorder}
                                onEditAlt={handleProductMediaEditAlt}
                            />
                        ) :
                            ['collections', 'blog'].includes(pagetype) ? <div className={`feature_image_container ${specialTaskLoading ? 'disabled_upload' : ''}`}>
                                <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                                    <Text variant="bodyMd" as="p">{t("Feature Image")}</Text>
                                    {
                                        isShowEditImg && <div className="flex_layout" style={{ gap: '16px' }}>
                                            <Button
                                                variant="plain"
                                                disabled={specialTaskLoading}
                                                onClick={handleOpenEditImgAlt}
                                            >
                                                {t("Edit alt text")}
                                            </Button>
                                            <Button
                                                variant="plain"
                                                tone="critical"
                                                disabled={specialTaskLoading}
                                                onClick={handleRemoveImage}
                                            >
                                                {t("Remove")}
                                            </Button>
                                        </div>
                                    }
                                </div>
                                {
                                    uploadLoading ? <div className='uploaded_files_loading'>
                                        <Spinner size="small" />
                                    </div> : !imageInfo?.src && files.length === 0 ? <div className='upload_container'>
                                        <DropZone
                                            accept="image/png,image/jpeg,image/jpg"
                                            type="image"
                                            errorOverlayText="File type must be .jpg .jpeg .png."
                                            onDrop={handleDropZoneDrop}
                                            variableHeight
                                            allowMultiple={false}
                                        >
                                            {fileUpload}
                                        </DropZone>
                                        {specialTaskLoading ? <div className='upload_shade'></div> : null}
                                    </div> : <div className='uploaded_files'>
                                        {specialTaskLoading ? <div className='upload_shade_ed'></div> : null}
                                        <div>
                                            {
                                                imageInfo?.src ? <Thumbnail
                                                    size="small"
                                                    alt={imageInfo.alt}
                                                    source={imageInfo.src || NoteIcon}
                                                /> : <Thumbnail
                                                    size="small"
                                                    alt={files[0].name}
                                                    source={
                                                        validImageTypes.includes(files[0].type)
                                                            ? window.URL.createObjectURL(files[0])
                                                            : NoteIcon
                                                    }
                                                />
                                            }
                                        </div>
                                        {
                                            !specialTaskLoading ? <div className='check_files' style={isShowEditImg ? { zIndex: 1, opacity: 1 } : {}} onClick={() => setIsShowEditImg(!isShowEditImg)}>
                                                <Checkbox id="check_files" checked={isShowEditImg} onChange={() => {
                                                    setIsShowEditImg(!isShowEditImg);
                                                }} />
                                            </div> : null
                                        }

                                    </div>
                                }
                            </div> : null
                    )
                }

                {/* 产品tag */}
                {
                    pagetype === 'product' && <div className='product_tag_container' style={{ opacity: (globalLoading || isEditObjState) ? 0.8 : 1 }}>
                        <div className='tag_title'>
                            <Text variant="bodyMd" as="p">{t("Product Tag")}</Text>
                            {
                                autoGenerateTagsLoading
                                    ? <span className='tag_ai_suggestion_loading'><Spinner size='small' /></span>
                                    : <button
                                        type='button'
                                        className='tag_ai_suggestion'
                                        onClick={handleGenerateTags}
                                        disabled={globalLoading || isEditObjState}
                                    >
                                        <span className='tag_ai_suggestion_icon'>
                                            <Icon source={MagicIcon} />
                                        </span>
                                        <span>{t("Get Suggestions")}</span>
                                    </button>
                            }
                        </div>
                        <div className={`product_tag_suggestion_wrap ${showRecommendTags ? 'has_recommend' : ''}`}>
                            <div className={`product_tag_input ${optPurpleArray.includes('productTags') ? 'purple_input' : ''}`}>
                                <TagTextInput
                                    id="productTags"
                                    SelectCurrentItem={productTags}
                                    setChangeTagsData={setChangeTagsData}
                                    disabled={globalLoading || isEditObjState}
                                />
                            </div>
                            {
                                showRecommendTags && <div className='product_tag_recommend'>
                                    <div className='product_tag_recommend_list'>
                                        {
                                            (recommendTags || []).map((tag, index) => (
                                                <button
                                                    type='button'
                                                    key={`${tag}-${index}`}
                                                    className='recommend_tag_item'
                                                    onClick={() => handleAddRecommendTag(tag, index)}
                                                    disabled={globalLoading || isEditObjState}
                                                >
                                                    <span className='recommend_tag_icon'>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8 3.5C8.34518 3.5 8.625 3.77982 8.625 4.125V7.375H11.875C12.2202 7.375 12.5 7.65482 12.5 8C12.5 8.34518 12.2202 8.625 11.875 8.625H8.625V11.875C8.625 12.2202 8.34518 12.5 8 12.5C7.65482 12.5 7.375 12.2202 7.375 11.875V8.625H4.125C3.77982 8.625 3.5 8.34518 3.5 8C3.5 7.65482 3.77982 7.375 4.125 7.375H7.375V4.125C7.375 3.77982 7.65482 3.5 8 3.5Z" fill="#5B7CFF" />
                                                        </svg>
                                                    </span>
                                                    <span className='recommend_tag_text'>{tag}</span>
                                                </button>
                                            ))
                                        }
                                    </div>
                                    <div className='product_tag_recommend_actions'>
                                        <Button
                                            size='slim'
                                            onClick={handleReplaceAllTags}
                                            disabled={globalLoading || isEditObjState || (recommendTags || []).length === 0}
                                        >{t("Replace all")}</Button>
                                        <span className='recommend_close_btn' onClick={handleCloseRecommendTags}>
                                            <Icon source={XIcon} />
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }

            </BlockStack>
        </Card>
        <Card>
            <BlockStack gap={300}>
                <div className='flex_layout edit_meta'>
                    <Text variant="headingMd" as="h2">{t("Search Engine Listing")}</Text>
                    {
                        metaCollStatus ? <Button variant='plain' onClick={handleToggleMetaCol}>{t("Done")}</Button> : <Tooltip content={t("Edit")}>
                            <Button icon={EditIcon} onClick={handleToggleMetaCol} variant='tertiary'></Button>
                        </Tooltip>
                    }
                </div>
                {
                    !metaCollStatus && <div className='view_meta'>
                        <Card>
                            <BlockStack gap={200}>
                                <div className="search_engine_item flex_layout">
                                    <span className="flex_layout">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#E2EEFF" />
                                            <path d="M21.0832 20.6437C20.8592 19.9545 20.2131 19.4462 19.4463 19.4462H18.5848V16.8616C18.5848 16.6331 18.494 16.4139 18.3324 16.2524C18.1709 16.0908 17.9517 16 17.7232 16H12.554V14.277H14.2771C14.5056 14.277 14.7247 14.1862 14.8863 14.0246C15.0478 13.863 15.1386 13.6439 15.1386 13.4154V11.6923H16.8617C17.3187 11.6923 17.7569 11.5108 18.0801 11.1877C18.4032 10.8645 18.5848 10.4262 18.5848 9.96926V9.61603C19.6156 10.0316 20.5303 10.6908 21.2507 11.5371C21.9711 12.3835 22.4757 13.3918 22.7213 14.4757C22.9669 15.5597 22.9462 16.687 22.6609 17.7612C22.3756 18.8354 21.8343 19.8244 21.0832 20.6437ZM15.1386 22.832C11.7355 22.4099 9.10784 19.5151 9.10784 16C9.10784 15.4659 9.17677 14.949 9.28877 14.4579L13.4155 18.5846V19.4462C13.4155 19.9032 13.5971 20.3414 13.9202 20.6646C14.2434 20.9877 14.6816 21.1693 15.1386 21.1693M16.0002 7.38464C14.8688 7.38464 13.7485 7.60749 12.7032 8.04045C11.6579 8.47341 10.7082 9.10802 9.90815 9.90803C8.29246 11.5237 7.38477 13.7151 7.38477 16C7.38477 18.285 8.29246 20.4763 9.90815 22.092C10.7082 22.892 11.6579 23.5266 12.7032 23.9596C13.7485 24.3926 14.8688 24.6154 16.0002 24.6154C18.2851 24.6154 20.4764 23.7077 22.0921 22.092C23.7078 20.4763 24.6155 18.285 24.6155 16C24.6155 14.8686 24.3927 13.7483 23.9597 12.7031C23.5268 11.6578 22.8922 10.708 22.0921 9.90803C21.2921 9.10802 20.3424 8.47341 19.2971 8.04045C18.2519 7.60749 17.1315 7.38464 16.0002 7.38464Z" fill="#0060F0" />
                                        </svg>
                                    </span>
                                    <div className="search_engine_item_info">
                                        <Text variant="bodyLg" as="p">{t("Shopify App Store")}</Text>
                                        <div className='flex_layout'>
                                            {
                                                Boolean(curLanguageSel && isEditObjState) ? <Text variant="bodySm" as="p" tone='subdued'>
                                                    {formatOutUrl(previewUrl, curLanguageSel, urlValue)}
                                                </Text> : <Text variant="bodySm" as="p" tone='subdued'>{`${previewUrl}${urlValue}`}</Text>
                                            }
                                            <Button icon={DuplicateIcon} variant='tertiary' onClick={() => copyUrlRes(Boolean(curLanguageSel && isEditObjState) ? formatOutUrl(previewUrl, curLanguageSel, urlValue) : `${previewUrl}${urlValue}`)}></Button>
                                        </div>
                                    </div>
                                </div>
                                {
                                    Boolean(metaTitleValue || metaDescriptionValue || metaTitleTip || metaDescriptionTip) && <div className="search_engine_item_desc">
                                        <Text variant="headingLg" as="h2">{metaTitleValue || metaTitleTip}</Text>
                                        <div className='ellipsis_2'>
                                            <Text variant="bodySm" as="p" tone="subdued">{metaDescriptionValue || metaDescriptionTip}</Text>
                                        </div>
                                    </div>

                                }
                            </BlockStack>
                        </Card>
                    </div>
                }
                <Collapsible
                    id="audit_meta_collapsible"
                    open={metaCollStatus}
                    transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                >
                    <BlockStack gap={400}>
                        <div className={`meta_title_bar ${optPurpleArray.includes('metaTitleValue') ? 'purple_input' : ''}`}>
                            <BlockStack gap={100}>
                                <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                                    <Text variant="bodyMd" as="p">{t("Meta title")}</Text>
                                    <Text variant="bodySm" as="p" tone='subdued'>{t("{{v1}} of {{v2}} characters used", !metaTitleValue ? metaTitleTip.length : metaTitleValue.length, 70)}</Text>
                                </div>
                                <TextField
                                    id="metaTitleValue"
                                    value={metaTitleValue}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                    disabled={globalLoading || (editableObj.filter(i => i['key'] === 'meta_title').length === 0 && isEditObjState)}
                                    placeholder={!metaTitleValue ? metaTitleTip : t("Enter the meta title")}
                                />
                            </BlockStack>
                        </div>
                        <div className={`meta_desc_bar ${optPurpleArray.includes('metaDescriptionValue') ? 'purple_input' : ''}`}>
                            <BlockStack gap={100}>
                                <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                                    <Text variant="bodyMd" as="p">{t("Meta description")}</Text>
                                    <Text variant="bodySm" as="p" tone='subdued'>{t("{{v1}} of {{v2}} characters used", !metaDescriptionValue ? metaDescriptionTip.length : metaDescriptionValue.length, 160)}</Text>
                                </div>
                                <TextField
                                    id="metaDescriptionValue"
                                    value={metaDescriptionValue}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                    disabled={globalLoading || (editableObj.filter(i => i['key'] === 'meta_description').length === 0 && isEditObjState)}
                                    multiline
                                    placeholder={!metaDescriptionValue ? metaDescriptionTip : t("Enter the meta description")}
                                />
                            </BlockStack>
                        </div>
                        <div className={`url_bar ${optPurpleArray.includes('urlValue') ? 'purple_input' : ''}`}>
                            <TextField
                                id="urlValue"
                                label={t("URL and handle")}
                                value={urlValue}
                                onChange={handleInputChange}
                                helpText={t("Modifying the URL will automatically create a redirect from the old link to the new one")}
                                prefix={Boolean(isEditObjState && curLanguageSel)
                                    ? formatOutUrl(previewUrl, curLanguageSel, '')
                                    : formatPreviewUrl(previewUrl, windowWidth)}
                                disabled={globalLoading || isEditObjState}
                                error={urlValue.length > 255 ? t("handle - is too long (maximum is {{v1}} characters)", 255) : !urlValue ? t("URL and handle is required") : null}
                            />
                        </div>
                    </BlockStack>
                </Collapsible>
            </BlockStack>
        </Card>
        {
            !isEditObjState && <StructuredData
                id={getCurrentEntityId()}
                level={level}
                structured_data={structured_data}
                structureModalType={structureModalType}
                disabled={specialTaskLoading}
                publishLoading={publishLoading}
                updOpenJSONLD={updOpenJSONLD}
                isPublishState={isPublishState}
                jsonLdTestUrl={jsonLdTestUrl}
                handleContactService={handleContactService}
                updateDataAnalysis={updateDataAnalysis}
                updStructuredDataByDetect={updStructuredDataByDetect}
                handlePublishData={handlePublishData}
                updOpenJsonldStatus={updOpenJsonldStatus}
                fixSchemaDone={handleFixSchemaDone}
                toggleToast={props.toggleToast}
                upgradeModal={props.upgradeModal}
                ai_usage_status={ai_usage_status}
                aiUse={aiUse}
                creditsPoints={creditsPoints}
                verifyOverchargeState={verifyOverchargeState}
                pagetype={getSourceType(pagetypeRef.current || pagetype)}
                // getPageDataRedux={props.getPageDataRedux}
                STRUCTURED_DATA_TYPE_FIELDS={STRUCTURED_DATA_TYPE_FIELDS}
                syncStructLoading={syncStructLoading}
            />
        }
        {
            !isEditObjState && <AdvancedSettings
                level={level}
                show={() => props.upgradeModal(1, 'OnPageSEO', 'content_audit_detail', false)}
                initData={{ noindex: [String(noindex)], nofollow: [String(nofollow)] }}
                toggleToast={props.toggleToast}
                onSave={handleSaveIndexAndFollow}
            />
        }
    </BlockStack>

    // 任务进度 模块
    const taskLoadingIcon = () => {
        return <div className="task_loading_icon_box" style={{ minWidth: 20, minHeight: 20 }}>
            <span className="task_loading_icon opt_icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12.0004" r="10" fill="var(--color-primary)" />
                    <g clipPath="url(#paint0_angular_6228_10823_clip_path)" data-figma-skip-parse="true">
                        <g transform="matrix(-0.00557143 0.00342857 -0.00342857 -0.00557143 12 12)">
                            <foreignObject x="-1682.4" y="-1682.4" width="3364.81" height="3364.81">
                                <div
                                    xmlns="http://www.w3.org/1999/xhtml"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        opacity: 1,
                                        background: `
                                        conic-gradient(
                                            from 90deg,
                                            rgba(209, 209, 209, 0.554) 0deg,
                                            rgba(255, 255, 255, 1) 127.631deg,
                                            rgba(153, 153, 153, 0) 201.449deg,
                                            rgba(209, 209, 209, 0.554) 360deg
                                        )
                                    `,
                                    }}
                                />
                            </foreignObject>
                        </g>
                    </g>
                    <path d="M12 6C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8.00001 12 8.00001C11.2088 8.00001 10.4351 8.23431 9.77731 8.67384C9.11957 9.11336 8.60738 9.73888 8.30465 10.4697C8.00201 11.2006 7.9228 12.0045 8.07711 12.7803C8.23145 13.5562 8.61243 14.2687 9.17184 14.8282C9.73125 15.3876 10.4438 15.7685 11.2197 15.9229C11.9955 16.0772 12.7994 15.998 13.5303 15.6953C14.2611 15.3926 14.8866 14.8804 15.3262 14.2227C15.7657 13.5649 16 12.7911 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 13.1865 17.6483 14.3464 16.9893 15.333C16.33 16.3197 15.3922 17.0889 14.2959 17.543C13.1995 17.9971 11.9929 18.1163 10.8291 17.8848C9.66531 17.6533 8.59681 17.0813 7.75778 16.2422C6.91874 15.4032 6.34675 14.3347 6.11519 13.1709C5.88368 12.0071 6.00288 10.8005 6.45699 9.70411C6.91112 8.60775 7.68026 7.67004 8.66696 7.01075C9.65355 6.35167 10.8135 6 12 6Z" data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.35453048348426819},{&#34;color&#34;:{&#34;r&#34;:0.60000002384185791,&#34;g&#34;:0.60000002384185791,&#34;b&#34;:0.60000002384185791,&#34;a&#34;:0.0},&#34;position&#34;:0.55958020687103271}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.35453048348426819},{&#34;color&#34;:{&#34;r&#34;:0.60000002384185791,&#34;g&#34;:0.60000002384185791,&#34;b&#34;:0.60000002384185791,&#34;a&#34;:0.0},&#34;position&#34;:0.55958020687103271}],&#34;transform&#34;:{&#34;m00&#34;:-11.142859458923340,&#34;m01&#34;:-6.8571419715881348,&#34;m02&#34;:21.000001907348633,&#34;m10&#34;:6.8571419715881348,&#34;m11&#34;:-11.142859458923340,&#34;m12&#34;:14.142859458923340},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}" />
                    <defs>
                        <clipPath id="paint0_angular_6228_10823_clip_path"><path d="M12 6C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8.00001 12 8.00001C11.2088 8.00001 10.4351 8.23431 9.77731 8.67384C9.11957 9.11336 8.60738 9.73888 8.30465 10.4697C8.00201 11.2006 7.9228 12.0045 8.07711 12.7803C8.23145 13.5562 8.61243 14.2687 9.17184 14.8282C9.73125 15.3876 10.4438 15.7685 11.2197 15.9229C11.9955 16.0772 12.7994 15.998 13.5303 15.6953C14.2611 15.3926 14.8866 14.8804 15.3262 14.2227C15.7657 13.5649 16 12.7911 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 13.1865 17.6483 14.3464 16.9893 15.333C16.33 16.3197 15.3922 17.0889 14.2959 17.543C13.1995 17.9971 11.9929 18.1163 10.8291 17.8848C9.66531 17.6533 8.59681 17.0813 7.75778 16.2422C6.91874 15.4032 6.34675 14.3347 6.11519 13.1709C5.88368 12.0071 6.00288 10.8005 6.45699 9.70411C6.91112 8.60775 7.68026 7.67004 8.66696 7.01075C9.65355 6.35167 10.8135 6 12 6Z" /></clipPath></defs>
                </svg>
            </span>
        </div >
    }

    // 任务完成 icon
    const taskFinishIcon = () => {
        return <div className="task_loading_icon_box" style={{ minWidth: 20, minHeight: 20 }}>
            <span className="task_finish_icon opt_icon">
                <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12.0004" r="10" fill="var(--color-primary)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M16.8841 8.29289C17.2391 8.68342 17.2391 9.31658 16.8841 9.70711L11.4296 15.7071C11.0746 16.0976 10.499 16.0976 10.1439 15.7071L7.41666 12.7071C7.06164 12.3166 7.06164 11.6834 7.41666 11.2929C7.77168 10.9024 8.34728 10.9024 8.70231 11.2929L10.7868 13.5858L15.5985 8.29289C15.9535 7.90237 16.5291 7.90237 16.8841 8.29289Z" fill="#FDFDFF" />
                </svg>
            </span>
        </div >
    }

    // 右侧卡片
    const smallScoreView = <div className='right_score_view_content small_right_score'>
        <CircularViewGauge
            value={Math.ceil(seo_score)}
        />
        <Text as='p' variant='bodyXs' tone='subdued'>{t("Content Score")}</Text>
    </div>
    const smallScoreLoadingView = <div className='right_score_view_content small_right_score'>
        {taskLoadingIcon()}
        <Text as='p' variant='bodyXs' tone='subdued'>{t("Under analysis")}</Text>
        <span>...</span>
    </div>
    const scorePanel = (score, loading = false) => {
        return <div className={`right_score_view_content_score ${loading ? 'panel_view_loading' : ''}`}>
            <CircularGauge
                score={loading ? 0 : Math.ceil(score)}
                width={280}
                c_redEndScore={33}
                c_yellowStartScore={34}
                c_yellowEndScore={66}
                c_greenStartScore={67}
                loading={loading}
            />
            <Text variant="heading2xl" as="h2">
                {
                    loading ? <span style={{ color: '#b5b5b5' }}>--</span> : <span style={{ color: score <= 33 ? '#D33430' : score <= 66 ? '#F1930F' : '#27AE60' }}>{Math.ceil(score)}</span>
                }
            </Text>
        </div>
    }
    // 生成错误提示块
    const errorTipBlock = <div className="none_keyword_error">
        <img src="/imgs/ai/start_over.png" alt="" />
        <Text variant="bodyMd" as="p" fontWeight="subdued">{t("Task failed. Please try again with a new topic keyword.")}</Text>
        <div className="none_keyword_error_btn">
            <Button onClick={handleContactService}>{t("Contact us")}</Button>
            <Button variant="primary" loading={startOverLoading} onClick={handleStartOver}>{t("Start over")}</Button>
        </div>
    </div>

    // SEO Checklist 和 Keyword Coverage 的容器
    const uncoveredKeywords = semantic_keywords.filter(e => Number(e.total_matched) <= 0);
    const kCoverageList = (coverageTab === 'all' ? semantic_keywords : uncoveredKeywords);
    const InfoContanierBox = (_state) => {
        return <BlockStack>
            <div className='seo_checklist collect_data'>
                <div className='seo_checklist_item collect_data_item' onClick={() => setSEOChecklistCol(!SEOChecklistCol)}>
                    <div className='seo_checklist_item_info'>
                        <Text as='h2' variant='headingMd'>{t("SEO Checklist")}</Text>
                        <div className='flex_layout'>
                            <ProgressRing percent={Math.ceil((checkLens / checklistData.length) * 100)} />
                            <Text as='p' variant='bodySm' tone='subdued'>{t("{{v1}}/{{v2}} checks", checkLens, checklistData.length)}</Text>
                        </div>
                    </div>
                    <div className='flex_layout'>
                        <Button variant='tertiary' icon={SEOChecklistCol ? ChevronUpIcon : ChevronDownIcon}></Button>
                    </div>
                </div>
                <Collapsible
                    id='target_seo_checklist_collapsible'
                    open={SEOChecklistCol}
                    transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                >
                    <div className='checklist_item_data_container'>
                        {
                            specialTaskLoading ? <div style={{ padding: '12px' }}>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </div> : <div className='checklist_all_list'>
                                {
                                    checklistData.map((item, index) => {
                                        return (
                                            <span key={`checklist_all_item_${item.key}-${index}`} className={`checklist_all_item`}>
                                                <span className='flex_layout' style={{ alignItems: "flex-start" }}>{schemaIconStatus(item.passed ? 1 : 2)}</span>
                                                {
                                                    (item.key === 'title_keyword') ? <Text as='span' variant='bodyMd'>
                                                        {!item.passed ? t("Title should include the") : t("Title includes the")}&nbsp;
                                                        <Tooltip content={t("The target keyword is your input or the top-ranked keyword in the Keyword Coverage list.")}>
                                                            <span style={{ borderBottom: '1px dashed #ccc' }}>{t("target keyword.")}</span>
                                                        </Tooltip>
                                                    </Text> :
                                                        (item.key === 'meta_title_keyword') ? <Text as='span' variant='bodyMd'>
                                                            {!item.passed ? t("Meta title should include the") : t("Meta title includes the")}&nbsp;
                                                            <Tooltip content={t("The target keyword is your input or the top-ranked keyword in the Keyword Coverage list.")}>
                                                                <span style={{ borderBottom: '1px dashed #ccc' }}>{t("target keyword.")}</span>
                                                            </Tooltip>
                                                        </Text> :
                                                            (item.key === 'meta_desc_keyword') ? <Text as='span' variant='bodyMd'>
                                                                {!item.passed ? t("Meta description should include the") : t("Meta description includes the")}&nbsp;
                                                                <Tooltip content={t("The target keyword is your input or the top-ranked keyword in the Keyword Coverage list.")}>
                                                                    <span style={{ borderBottom: '1px dashed #ccc' }}>{t("target keyword.")}</span>
                                                                </Tooltip>
                                                            </Text> :
                                                                <Text as='span' variant='bodyMd'>{t(item.message)}</Text>
                                                }
                                                {
                                                    (
                                                        (
                                                            (item.key === 'images' && (item?.origin || item.message).includes('alt')) ||
                                                            ['article_schema', 'faq_schema'].includes(item.key) ||
                                                            [
                                                                'keyword_type_match',
                                                                'product_tags',
                                                                'product_schema',
                                                                'return_schema',
                                                                'shipping_schema',
                                                                'review_schema',
                                                                'breadcrumb_schema',
                                                            ].includes(item.key) ||
                                                            (item.key === 'h1_single' && item.message.includes('Multiple'))
                                                        ) && item.passed === false
                                                    ) && <span
                                                        className='checklist_all_item_status'
                                                        style={(specialTaskLoading || fixLoadingType) ? { cursor: 'not-allowed', opacity: 0.5 } : {}} onClick={() => handleFixItem(item.key)}
                                                    >
                                                        {
                                                            fixLoadingType === item.key ? <Spinner size="small" /> : <>
                                                                <span style={{ wordBreak: 'keep-all' }}>{t("Fix")}</span>
                                                                <Icon source={ArrowRightIcon} />
                                                            </>
                                                        }
                                                    </span>
                                                }
                                            </span>
                                        );
                                    })
                                }
                            </div>
                        }
                    </div>
                </Collapsible>
            </div>
            <div className='target_keyword_coverage collect_data'
                onMouseEnter={() => handleMouseEventKC('enter', keywordCoverageCol, kCoverageList)}
                onMouseLeave={() => handleMouseEventKC('leave', keywordCoverageCol, kCoverageList)}
            >
                <div className='target_keyword_coverage_item collect_data_item' onClick={() => setKeywordCoverageCol(!keywordCoverageCol)}>
                    <div className='target_keyword_coverage_item_info'>
                        <div className='flex_layout'>
                            <Text as='h2' variant='headingMd'>{t("Keyword Coverage")}</Text>
                            <Tooltip content={t("Semantic keywords extracted from competitor to help improve your topic coverage.")}>
                                <span><Icon source={QuestionCircleIcon} tone="subdued" /></span>
                            </Tooltip>
                        </div>
                        <div className='flex_layout'>
                            {
                                analysisError ? <>
                                    <span><Icon source={AlertCircleIcon} tone='warning' /></span>
                                    <Text as='p' variant='bodySm' tone='subdued'>{t("Analysis failed")}</Text>
                                </> :
                                    Boolean(_state === '1') ? <>
                                        <span><Icon source={AlertCircleIcon} tone='warning' /></span>
                                        <Text as='p' variant='bodySm' tone='subdued'>{t("Awaiting analysis")}</Text>
                                    </> :
                                        Boolean(['1-2', '2-2'].includes(_state)) ? <div className='kc_analysis_loading'>
                                            <span><Spinner size="small" /></span>
                                            <Text as='p' variant='bodySm' tone='subdued'>{t("Analyzing")}...</Text>
                                        </div> :
                                            Boolean(semantic_keywords.length === 0) ? <>
                                                <span><Icon source={AlertCircleIcon} tone='warning' /></span>
                                                <Text as='p' variant='bodySm' tone='subdued'>{t("No keywords found")}</Text>
                                            </> : <>
                                                <ProgressRing percent={Math.ceil((coverageLens / semantic_keywords.length) * 100)} />
                                                <Text as='p' variant='bodySm' tone='subdued'>{t("{{v1}}/{{v2}} covered", coverageLens, semantic_keywords.length)}</Text>
                                            </>
                            }
                        </div>
                    </div>
                    <div className='flex_layout'>
                        <Button variant='tertiary' icon={keywordCoverageCol ? ChevronUpIcon : ChevronDownIcon}></Button>
                    </div>
                </div>
                <Collapsible
                    id='target_keyword_coverage_collapsible'
                    open={keywordCoverageCol}
                    transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                >
                    {
                        Boolean(['1-2', '2-2'].includes(_state)) ? (
                            analysisError ? errorTipBlock : analysisView(recordData)
                        ) :
                            Boolean(_state === '1') ? (
                                analysisError ? errorTipBlock : <div className='ca_empty_block'>
                                    {emptySearchIcon}
                                    <Text as='p' variant='bodyMd' tone='subdued'>{t("Click \"Run Analysis\" below to see competitor coverage.")}</Text>
                                </div>
                            ) :
                                Boolean(semantic_keywords.length === 0) ? <div className='ca_empty_block'>
                                    {emptySearchIcon}
                                    <Text as='p' variant='bodyMd' fontWeight='medium'>{t("Couldn't extract semantic keywords")}</Text>
                                    <Text as='p' variant='bodyMd' tone='subdued'>{t("Try another target keyword or pick different competitors to analyze.")}</Text>
                                    <ButtonGroup>
                                        <Button variant='secondary' icon={AdjustIcon} onClick={() => patchSettingState({
                                            searchSettingsModalState: false,
                                            activeTab: 'research',
                                            isShowCompetitorsModal: true,
                                        })}>{t('Select Competitors')}</Button>
                                        <Button variant='primary' onClick={() => {
                                            (!researchLoading && !isEditObjState && !insertLoading && !autoOptimizeLoading) && handleToggleSettingSearch(true);
                                        }}>{t("Use another keyword")}</Button>
                                    </ButtonGroup>
                                </div> :
                                    <div className='coverage_item_data_container'>
                                        <div className='coverage_item_data'>
                                            <div className='coverage_item_tab'>
                                                <div className='coverage_tab_item' onClick={() => handleChangeCoverageTab('all')}>{t("All")} <span>{semantic_keywords.length}</span></div>
                                                <div className='coverage_tab_item' onClick={() => handleChangeCoverageTab('uncovered')}>{t("Uncovered")} <span>{uncoveredKeywords.length}</span></div>
                                                <div className='coverage_tab_block' style={{ left: coverageTab === 'all' ? '4px' : 'calc(50% + 4px)' }}></div>
                                            </div>
                                        </div>
                                        {
                                            specialTaskLoading ? <div style={{ padding: '12px' }}>
                                                <BlockStack gap={400}>
                                                    <SkeletonBodyText />
                                                    <SkeletonBodyText />
                                                </BlockStack>
                                            </div> : <div className='coverage_item_data_all'>
                                                {
                                                    kCoverageList.length > 0 ? <div className='coverage_all_list'>
                                                        {
                                                            kCoverageList.map((item, index) => {
                                                                const range1 = item.body_df_min;
                                                                const range2 = item.body_df_max;
                                                                const t_df = item.total_matched;
                                                                const status = (t_df <= 0) ? 0 : t_df >= range1 && t_df <= range2 ? 1 : 2;
                                                                const activeKeyState = item.keyword.toLowerCase() === activeKeyword.toLowerCase();
                                                                return <Tooltip key={`coverage_all_item_${item.keyword}_${index}`} content={
                                                                    range1 === range2 ? t("Recommend {{v1}} times, Currently used {{v2}} times", range1, t_df) :
                                                                        t("Recommend {{v1}}-{{v2}} times, Currently used {{v3}} times", range1, range2, t_df)
                                                                }>
                                                                    <span
                                                                        key={`${item.keyword}-${index}`}
                                                                        className={
                                                                            `
                                                            coverage_all_item
                                                            ${status === 0 ? '' : status === 1 ? 'all_green' : 'all_yellow'}
                                                            ${activeKeyState ? (status === 0 ? 'active_default' : status === 1 ? 'active_green' : status === 2 ? 'active_yellow' : '') : ''}
                                                        `
                                                                        }
                                                                        onMouseEnter={() => handleSetHoverKeyword(item.keyword, status)}
                                                                        onMouseLeave={() => handleSetHoverKeyword('', 0)}
                                                                        onClick={() => handleSetActiveKeyword(item.keyword, status)}
                                                                    >
                                                                        {/* <span className='flex_layout'>{schemaIconStatus(status)}</span> */}
                                                                        {Number(item.headings_df_max) > 0 && <span className='flex_layout' style={{ marginRight: '4px' }}>
                                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
                                                                                <path d="M4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#E3E3E3" />
                                                                                <path d="M6.40767 14V5.27273H7.8608V9.0142H12.0582V5.27273H13.5071V14H12.0582V10.2457H7.8608V14H6.40767Z" fill="#616161" />
                                                                            </svg>
                                                                        </span>}
                                                                        <Text as='span' variant='bodyMd'>{item.keyword}</Text>
                                                                        <Text as='span' variant='bodySm' tone='subdued'>
                                                                            {range1 === range2 ? `${t_df} / ${range1}` : `${t_df} / ${range1} - ${range2}`}
                                                                        </Text>
                                                                    </span>
                                                                </Tooltip>
                                                            })
                                                        }
                                                    </div> : <div className='coverage_empty_list'>
                                                        {emptyModule("No data to show here")}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            kCoverageList.length > 0 && <div className='coverage_copy_all_footer'>
                                                <Button variant='tertiary' icon={CopyIcon} onClick={() => handleCopyAllKeywords(kCoverageList)}>{t("Copy")}</Button>
                                            </div>
                                        }
                                    </div>
                    }
                </Collapsible>
            </div >
            <SearchPerformance
                searchPerformanceData={searchPerformanceData}
                isGscConnected={isGscConnected}
                rankingLoading={rankingLoading}
                rankingKeywordsList={rankingKeywordsList}
                searchPerformanceCol={searchPerformanceCol}
                setSearchPerformanceCol={setSearchPerformanceCol}
                gscConnecting={gscConnecting}
                handleConnectGsc={handleConnectGsc}
                titleValue={titleValue}
                metaTitleValue={metaTitleValue}
                metaDescriptionValue={metaDescriptionValue}
                descValue={descValue}
            />
        </BlockStack >
    }

    // 分析中视图
    const analysisView = (data = {}) => {
        const cs = Number(data?.current_step) || 0;
        const cst = data?.current_status;
        // 复用旧版四步进度逻辑，页面上仅展示第三步、第四步
        const getStepStatus = (index) => {
            let status = 0;
            if (cs >= index + 1) {
                status = (cs === index + 1 && cst !== 2) ? 2 : 1;
            }
            if (cs === index && ![2, 3].includes(cst)) {
                status = 2;
            }
            if (cs < index + 1) {
                status = 0;
            }
            return status;
        };
        // index 对应旧版四步中的第三步、第四步
        const stepArr = [
            {
                index: 2,
                title: t("Analyzing Reference Articles"),
                desc: t("Extracting semantic keywords and content structure from competitors"),
            },
            {
                index: 3,
                title: t("Audit Page Content"),
                desc: t("Evaluating topic keyword coverage, content structure, and SEO issues."),
            },
        ];
        return <div className='ca_analysis_view'>
            <img src='/imgs/ai/analysing.gif' alt='' />
            <div className='ca_analysis_view_step'>
                {
                    stepArr.map((step, i) => {
                        let status = getStepStatus(step.index);
                        // 默认展示第一个步骤（Analyzing Reference Articles），未开始时按进行中展示
                        if (i === 0 && status === 0) status = 2;
                        // 其余未开始的步骤先不展示，进行到该步骤时再淡入把内容往上推
                        if (status === 0) return null;
                        return <div className={`aly_step_item ${status === 1 ? 'is_done' : 'is_active'}`} key={step.index}>
                            <div className="aly_loading">
                                {status === 1 ? taskFinishIcon() : taskLoadingIcon()}
                                <span>{step.title}</span>
                            </div>
                            <Text as='p' variant='bodyMd' tone='subdued'>{step.desc}</Text>
                        </div>
                    })
                }
            </div>
        </div>
    }

    // 获取GSC第一个关键词
    const gscFirstKeyword = (rankingKeywordsList || []).length > 0 ? String(rankingKeywordsList[0]?.keyword || '') : '';

    // 没有关键词的视图
    const NoneKeywordView = <div className={`right_score_view_content full_right_score ca_none_keyword_view ${!targetKeywordValue ? 'none_keyword_view_disabled' : ''}`}>
        {scorePanel(seo_score, researchLoading)}
        {/* {chooseTipsCase} */}
        <div>
            <BlockStack gap={200}>
                <Text as='p' variant='bodyMd'>{t("Target Keyword")}</Text>
                <div className='set_keyword_container' onClick={() => {
                    !researchLoading && handleToggleSettingSearch(true);
                }}>
                    <div className='keyword_edit'>
                        {
                            targetKeywordValue ? <Tooltip content={
                                (isUsePositionKeyword && rankingKeywordsList.length > 0 && ((gscFirstKeyword.toLowerCase()) === (targetKeywordValue.toLowerCase()))) ? t("Top-performing keyword from Google Search Console selected. Click to change.") : targetKeywordValue
                            }>
                                <Text as='span' variant='bodyMd'>{targetKeywordValue}</Text>
                            </Tooltip> : <Text as='span' variant='bodyMd' tone="subdued">{t("Enter a keyword you want to rank for...")}</Text>
                        }
                        <Button icon={EditIcon} variant='tertiary' size='micro' disabled={researchLoading || specialTaskLoading}></Button>
                    </div>
                </div>
            </BlockStack>
            {
                isShowKeywordBannerTip ? (
                    Boolean(!((closedReplaceTipIds[pagetypeRef.current || pagetype] || []).includes(getCurrentEntityId())) && targetKeywordValue && isGscConnected && rankingKeywordsList.length > 0 && ((targetKeywordValue.toLowerCase()) !== (gscFirstKeyword.toLowerCase()))) ? <div className='gsc_key_tip'>
                        <span><Icon source={LightbulbIcon} /></span>
                        <Text as='p' variant='bodyMd'>{gscFirstKeyword}</Text>
                        <div className='tip_btn_group'>
                            <Button onClick={() => handleReplaceKeyword(gscFirstKeyword)}>{t("Replace")}</Button>
                            <Button icon={XIcon} variant='tertiary' onClick={() => handleCloseReplaceTip(pagetypeRef.current || pagetype, getCurrentEntityId())}></Button>
                        </div>
                    </div> : Boolean(isRepetitionKey) ? <div className='tip_view_banner'>
                        <Banner
                            tone='warning'
                            title={t("This keyword is already used by another page.")}
                            onDismiss={() => { patchSettingState({ isShowKeywordBannerTip: false }); }}
                        ></Banner>
                    </div> : null
                ) : null
            }
        </div>
        {
            isShowKeywordTip && <Banner
                title={t("Please enter the target keyword")}
                tone='critical'
                onDismiss={() => { setIsShowKeywordTip(false); }}
            ></Banner>
        }
        <Tooltip content={t("Analyze top-ranking pages for target keyword to identify related semantic topics and keyword opportunities.")}>
            <Button icon={SearchResourceIcon} size='large' variant='primary' fullWidth disabled={!targetKeywordValue} loading={researchLoading} onClick={() => handleStartResearch('panel')}>{t("Run Analysis")}</Button>
        </Tooltip>
        {InfoContanierBox(panelState)}
    </div>

    // 关键词视图
    const TargetKeywordView = <div className='right_score_view_content full_right_target_keyword'>
        <BlockStack gap={400}>
            <div className='target_keyword_view_container'>
                <div className='tip_view_container'>
                    <div className='target_keyword_view' onClick={() => {
                        (!researchLoading && !isEditObjState && !insertLoading && !autoOptimizeLoading) && handleToggleSettingSearch(true);
                    }}>
                        <Text as='p' variant='bodyMd'>{targetKeywordValue}</Text>
                        <Button icon={EditIcon} variant='tertiary' size='micro' disabled={researchLoading || specialTaskLoading}></Button>
                    </div>
                    {
                        isShowKeywordBannerTip ? (
                            Boolean(!((closedReplaceTipIds[pagetypeRef.current || pagetype] || []).includes(getCurrentEntityId())) && targetKeywordValue && isGscConnected && rankingKeywordsList.length > 0 && ((targetKeywordValue.toLowerCase()) !== (gscFirstKeyword.toLowerCase()))) ? <div className='gsc_key_tip'>
                                <span><Icon source={LightbulbIcon} /></span>
                                <Text as='p' variant='bodyMd'>{gscFirstKeyword}</Text>
                                <div className='tip_btn_group'>
                                    <Button onClick={() => handleReplaceKeyword(gscFirstKeyword)}>{t("Replace")}</Button>
                                    <Button icon={XIcon} variant='tertiary' onClick={() => handleCloseReplaceTip(pagetypeRef.current || pagetype, getCurrentEntityId())}></Button>
                                </div>
                            </div> : Boolean(isRepetitionKey) ? <div className='tip_view_banner'>
                                <Banner
                                    tone='warning'
                                    title={t("This keyword is already used by another page.")}
                                    onDismiss={() => { patchSettingState({ isShowKeywordBannerTip: false }); }}
                                ></Banner>
                            </div> : null
                        ) : null
                    }
                </div>
                <div className='target_keyword_tab'>
                    <div className={`tk_tab_item ${activeTab === 'write_optimize' ? 'active' : ''}`} onClick={() => patchSettingState({ activeTab: 'write_optimize' })}>{t("Write & Optimize")}</div>
                    <div className={`tk_tab_item ${activeTab === 'research' ? 'active' : ''}`} onClick={() => patchSettingState({ activeTab: 'research' })}>{t("Research")}</div>
                    <div className='tk_bottom_line' style={activeTab === 'write_optimize' ? { left: 16 } : { left: 'calc(50% + 5px)' }}></div>
                </div>
            </div>
            {
                activeTab === 'write_optimize' ? <BlockStack gap={400}>
                    <div className='right_score_view_content_score'>
                        {
                            isNeedUpdAnalysis && <BlockStack inlineAlign='end'>
                                <Popover
                                    active={isShowUpdOpt}
                                    preferredPosition='above'
                                    activator={
                                        <div className='time_update flex_layout' onMouseEnter={() => handleToggleUpdOpt(true)}>
                                            <Icon source={AlertCircleIcon} tone='warning' />
                                            <Text as='p' variant='bodySm'>{updAnalysisText}</Text>
                                        </div>
                                    }
                                    onClose={() => handleToggleUpdOpt(false)}
                                >
                                    <div className='popover_update_opt' onMouseEnter={() => handleToggleUpdOpt(true)} onMouseLeave={() => handleToggleUpdOpt(false)}>
                                        <BlockStack align='center' gap={100}>
                                            <Text as='p' variant='bodySm'>{t("The last time this page was analyzed for SEO performance.")}</Text>
                                            <Button onClick={() => handleStartResearch('re_analyze')} loading={researchLoading || insertLoading} icon={RefreshIcon} variant='plain'>{t("Refresh")}</Button>
                                        </BlockStack>
                                    </div>
                                </Popover>
                            </BlockStack>
                        }
                        <div className={`right_score_gauge ${(researchLoading || insertLoading) ? 'panel_view_loading' : ''}`}>
                            <CircularGauge
                                score={(researchLoading || insertLoading) ? 0 : Math.ceil(seo_score)}
                                width={280}
                                c_redEndScore={33}
                                c_yellowStartScore={34}
                                c_yellowEndScore={66}
                                c_greenStartScore={67}
                                loading={(researchLoading || insertLoading)}
                            />
                        </div>
                        <Text variant="heading2xl" as="h2">
                            {
                                (researchLoading || insertLoading) ? <span style={{ color: '#d8d8d8' }}>--</span> : <Tooltip content={<span>
                                    {t("Content Score is a number between 1 and 100 that grades content quality and relevancy.")}&nbsp;
                                    <Link url={t(`${process.env.PUBLIC_HELP_CENTER_ADMIN}/content-optimization/guideline/g2/`)} target='_blank' removeUnderline>{t("Learn more")}.</Link>
                                </span>}>
                                    <span style={{ color: seo_score <= 33 ? '#D33430' : seo_score <= 66 ? '#F1930F' : '#27AE60' }}>{Math.ceil(seo_score)}</span>
                                </Tooltip>
                            }
                        </Text>
                    </div>
                    {
                        (pagetypeRef.current || pagetype) === 'blog' && (
                            <div className='content_collect_data'>
                                <Tooltip width={240} content={t("Competitors use {{v1}}-{{v2}} words", words_min, words_max)}>
                                    <span className='collect_item'>
                                        <Text as='span' variant='bodySm' tone='subdued'>{t("Words")}</Text>
                                        <Text as='span' variant='bodyMd'>{wordsValue}</Text>
                                        <Text as='span' variant='bodySm' tone='subdued'>{words_min}-{words_max}</Text>
                                    </span>
                                </Tooltip>
                                <Tooltip width={240} content={t("Competitors use {{v1}}-{{v2}} headings", headings_min, headings_max)}>
                                    <span className='collect_item'>
                                        <Text as='span' variant='bodySm' tone='subdued'>{t("Headings")}</Text>
                                        <Text as='span' variant='bodyMd'>{headingsValue}</Text>
                                        <Text as='span' variant='bodySm' tone='subdued'>{headings_min}-{headings_max}</Text>
                                    </span>
                                </Tooltip>
                                <Tooltip width={240} content={t("Competitors use {{v1}}+ paragraphs", paragraphs_avg)}>
                                    <span className='collect_item'>
                                        <Text as='span' variant='bodySm' tone='subdued'>{t("Paragraphs")}</Text>
                                        <Text as='span' variant='bodyMd'>{paragraphsValue}</Text>
                                        <Text as='span' variant='bodySm' tone='subdued'>{paragraphs_avg}{paragraphs_avg ? '+' : '-'}</Text>
                                    </span>
                                </Tooltip>
                            </div>
                        )
                    }
                    <BlockStack gap={200}>
                        <div className='auto_optimize_btn_group'>
                            <Tooltip content={t("{{v1}} credits per use.", 4)}>
                                <Button size="large" variant='primary' icon={MagicIcon} disabled={insertLoading || researchLoading || analysisError} loading={autoOptimizeLoading} onClick={() => handleAutoOptimize(isShowSaveBar)}>{t("Auto-Optimize")}</Button>
                            </Tooltip>
                            {
                                pagetype === 'product' && <Button icon={AdjustIcon} size="large" disabled={insertLoading || autoOptimizeLoading} onClick={handleOpenAutoOptPref}></Button>
                            }
                        </div>
                        {
                            pagetype === 'blog' && <Tooltip content={t("{{v1}} credits per use.", 2)}>
                                <Button size="large" fullWidth icon={LinkIcon} loading={insertLoading} disabled={specialTaskLoading || researchLoading} onClick={handleOpenInsertModal}>{t("Insert Internal links")}</Button>
                            </Tooltip>
                        }
                    </BlockStack>
                    {InfoContanierBox(panelState)}
                </BlockStack> :
                    activeTab === 'research' ? (
                        isShowRefreshAnalysis ? (
                            analysisError ? errorTipBlock : (
                                (researchLoading && analysisTypeRef.current !== 'refresh') ? <div style={{ padding: '0 0 16px' }}>
                                    <BlockStack gap={400}>
                                        <SkeletonDisplayText />
                                        <SkeletonBodyText lines={3} />
                                        <SkeletonBodyText lines={3} />
                                        <SkeletonBodyText lines={3} />
                                    </BlockStack>
                                </div> : <AnalyzeContent
                                    refresh={true}
                                    recordData={recordData}
                                />
                            )
                        ) : <SearchIntent
                            sourceType={getSourceType(pagetypeRef.current || pagetype)}
                            id={getCurrentEntityId()}
                            recordId={recordId}
                            intentResData={intentResData}
                            specialTaskLoading={specialTaskLoading}
                            toggleToast={props.toggleToast}
                            intentLoading={intentLoading}
                            isShowCompetitorsModal={isShowCompetitorsModal}
                            handleRefreshAnalysis={handleRefreshAnalysis}
                            handleShowGetMoreUsageModal={() => props.handleShowGetMoreUsageModal('onpage', product_use)}
                            updCompetitorsModalState={(e) => patchSettingState({ isShowCompetitorsModal: e })}
                        />
                    ) : null
            }
        </BlockStack>
    </div >

    const autoOptCompareModalTitle = {
        title: t("Title optimized"),
        content: t("Content optimized"),
        meta: t("Meta tags optimized"),
        tags: t("Product tags optimized"),
    };

    const noop = () => { };

    // 取消优化弹窗
    const cancelAutoOptModal = <Modal
        size='small'
        open={cancelAutoOptModalOpen}
        title={t("Cancel Auto-Optimize?")}
        onClose={() => handleChangeAutoOptimizeState(false, '')}
        secondaryActions={{
            content: t("Go Back"),
            onAction: () => handleChangeAutoOptimizeState(false, '')
        }}
        primaryAction={
            {
                content: t("Confirm"),
                onAction: handleAutoOptCancel,
                loading: autoOptimizeConfirmLoading,
            }
        }
    >
        <Modal.Section>
            <Text as='p' variant='bodyMd'>{t("Your current edits will not be saved.")}</Text>
            <Text as='p' variant='bodyMd'>{t("{{v1}} Auto-Optimize credits have already been deducted.", 4)}</Text>
        </Modal.Section>
    </Modal>;

    // 自动优化偏好设置弹窗（仅产品类型）
    const autoOptPrefModal = <Modal
        open={autoOptPrefModalOpen}
        title={t("Auto-Optimization Preferences")}
        onClose={handleCloseAutoOptPref}
        secondaryActions={{
            content: t("Cancel"),
            onAction: handleCloseAutoOptPref,
            disabled: autoOptPrefSaveLoading,
        }}
        primaryAction={{
            content: t("Save"),
            onAction: handleSaveAutoOptPref,
            loading: autoOptPrefSaveLoading,
        }}
    >
        <Modal.Section>
            <div className='auto_opt_pref_modal'>
                <BlockStack gap={300}>
                    <Text as='p' variant='bodyMd' tone='subdued'>
                        {t("These settings will be applied each time you auto-optimize a product page.")}
                    </Text>

                    <BlockStack gap={200}>
                        <Text as='p' variant='bodyMd' fontWeight='semibold'>{t("FAQ")}</Text>
                        <RadioButton
                            label={t("Add when relevant")}
                            name='autoOptFaq'
                            checked={autoOptPrefDraft.faq === 'relevant'}
                            onChange={() => handleChangeAutoOptPref({ faq: 'relevant' })}
                        />
                        <RadioButton
                            label={t("Never add")}
                            name='autoOptFaq'
                            checked={autoOptPrefDraft.faq === 'never'}
                            onChange={() => handleChangeAutoOptPref({ faq: 'never' })}
                        />
                    </BlockStack>

                    <BlockStack gap={200}>
                        <Text as='p' variant='bodyMd' fontWeight='semibold'>{t("Content Length")}</Text>
                        <RadioButton
                            label={t("Adaptive")}
                            helpText={t("AI adjusts content length naturally based on SEO opportunities.")}
                            name='autoOptLength'
                            checked={autoOptPrefDraft.length === 'adaptive'}
                            onChange={() => handleChangeAutoOptPref({ length: 'adaptive' })}
                        />
                        <RadioButton
                            label={t("Custom range")}
                            name='autoOptLength'
                            checked={autoOptPrefDraft.length === 'custom'}
                            onChange={() => handleChangeAutoOptPref({ length: 'custom' })}
                        />
                        <div className='auto_opt_pref_range'>
                            <InlineStack gap={200} blockAlign='center' wrap={false}>
                                <div className='auto_opt_pref_range_select'>
                                    <TextField
                                        label={t("Minimum words")}
                                        labelHidden
                                        type='number'
                                        min={0}
                                        autoComplete='off'
                                        value={autoOptPrefDraft.minWords}
                                        disabled={autoOptPrefDraft.length !== 'custom'}
                                        onChange={(v) => handleChangeAutoOptPref({ minWords: v.replace(/[^0-9]/g, '') })}
                                    />
                                </div>
                                <Text as='span' variant='bodyMd'>{t("To")}</Text>
                                <div className='auto_opt_pref_range_select'>
                                    <TextField
                                        label={t("Maximum words")}
                                        labelHidden
                                        type='number'
                                        min={0}
                                        autoComplete='off'
                                        value={autoOptPrefDraft.maxWords}
                                        disabled={autoOptPrefDraft.length !== 'custom'}
                                        onChange={(v) => handleChangeAutoOptPref({ maxWords: v.replace(/[^0-9]/g, '') })}
                                    />
                                </div>
                                <Text as='span' variant='bodyMd'>{t("words")}</Text>
                            </InlineStack>
                        </div>
                    </BlockStack>

                    <BlockStack gap={200}>
                        <Text as='p' variant='bodyMd'>{t("Add instructions")}</Text>
                        <TextField
                            label={t("Add instructions")}
                            labelHidden
                            multiline={3}
                            autoComplete='off'
                            value={autoOptPrefDraft.instructions}
                            onChange={(v) => handleChangeAutoOptPref({ instructions: v })}
                            placeholder={t("e.g. \"Keep the current layout structure and avoid adding new sections.\"")}
                        />
                    </BlockStack>
                </BlockStack>
            </div>
        </Modal.Section>
    </Modal>;

    /* 优化对比：标题 */
    const autoOptCompareTitleBody = (
        <AutoOptCompareTwoCol
            original={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='original' />
                    <div className='title_compare_input'>
                        <TextField
                            label={t("Title")}
                            value={originalOptimizeData?.titleValue}
                            onChange={noop}
                            multiline={2}
                            disabled
                            autoComplete='off'
                        />
                    </div>
                </BlockStack>
            }
            optimized={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='optimized' />
                    <div className='title_compare_input purple_input'>
                        <TextField
                            id="optTitleValue"
                            label={t("Title")}
                            value={autoOptimizeModalData?.title}
                            onChange={handleInputOptModalData}
                            multiline={2}
                            autoComplete='off'
                        />
                    </div>
                </BlockStack>
            }
        />
    );

    /* 优化对比：内容 */
    const autoOptCompareContentBody = (
        <AutoOptCompareTwoCol
            original={
                <BlockStack gap='0'>
                    <AutoOptCompareSideLabel variant='original' />
                    <TinyMce
                        id={"original_tiny_mac"}
                        minHeight={400}
                        maxHeight={400}
                        disabled={true}
                        isFocus={false}
                        trans_content={originalOptimizeData?.descValue}
                        onTransChange={noop}
                        onTransFocus={noop}
                    />
                </BlockStack>
            }
            optimized={
                <BlockStack gap='0'>
                    <AutoOptCompareSideLabel variant='optimized' />
                    <TinyMce
                        id={"optimized_tiny_mac"}
                        minHeight={400}
                        maxHeight={400}
                        // disabled={true}
                        isFocus={false}
                        trans_content={autoOptimizeModalData?.description}
                        onTransChange={handleTransOptModalData}
                        onTransFocus={noop}
                    />
                </BlockStack>
            }
        />
    );

    /* 优化对比：Meta */
    const autoOptCompareMetaBody = (
        <AutoOptCompareTwoCol
            original={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='original' />
                    <div className='meta_compare_input'>
                        {
                            Boolean(autoOptimizeData?.meta_title) && <BlockStack gap='100'>
                                <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                    <Text as='span' variant='bodyMd'>{t('Meta Title')}</Text>
                                    <Text as='span' variant='bodySm' tone='subdued'>{t('{{v1}} of {{v2}} characters used', (originalOptimizeData?.metaTitleValue || '').length, 70)}</Text>
                                </InlineStack>
                                <TextField
                                    labelHidden
                                    value={originalOptimizeData?.metaTitleValue}
                                    onChange={noop}
                                    multiline={2}
                                    autoComplete='off'
                                    disabled
                                />
                            </BlockStack>
                        }
                        {
                            Boolean(autoOptimizeData?.meta_description) && <BlockStack gap='100'>
                                <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                    <Text as='span' variant='bodyMd'>{t('Meta description')}</Text>
                                    <Text as='span' variant='bodySm' tone='subdued'>{t('{{v1}} of {{v2}} characters used', (originalOptimizeData?.metaDescriptionValue || '').length, 160)}</Text>
                                </InlineStack>
                                <TextField
                                    labelHidden
                                    value={originalOptimizeData?.metaDescriptionValue}
                                    onChange={noop}
                                    multiline={3}
                                    rows={4}
                                    autoComplete='off'
                                    disabled
                                />
                            </BlockStack>
                        }
                        {
                            Boolean(autoOptimizeData?.url_slug) && <BlockStack gap='100'>
                                <TextField
                                    label={t('URL handle')}
                                    value={originalOptimizeData?.urlValue}
                                    onChange={noop}
                                    prefix={(pagetypeRef.current || pagetype) === 'blog' ? `blogs/${blog_handle}/` : `${PAGE_URL_PREFIX_MAP[pagetypeRef.current || pagetype]}/`}
                                    autoComplete='off'
                                    disabled
                                />
                            </BlockStack>
                        }
                    </div>
                </BlockStack>
            }
            optimized={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='optimized' />
                    <div className='meta_compare_input purple_input'>
                        {
                            Boolean(autoOptimizeData?.meta_title) && <BlockStack gap='100'>
                                <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                    <Text as='span' variant='bodyMd'>{t('Meta Title')}</Text>
                                    <Text as='span' variant='bodySm' tone='subdued'>{t('{{v1}} of {{v2}} characters used', (autoOptimizeModalData?.meta_title || '').length, 70)}</Text>
                                </InlineStack>
                                <TextField
                                    id="optMetaTitleValue"
                                    labelHidden
                                    value={autoOptimizeModalData?.meta_title}
                                    onChange={handleInputOptModalData}
                                    multiline={2}
                                    autoComplete='off'
                                />
                            </BlockStack>
                        }
                        {
                            Boolean(autoOptimizeData?.meta_description) && <BlockStack gap='100'>
                                <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                    <Text as='span' variant='bodyMd'>{t('Meta description')}</Text>
                                    <Text as='span' variant='bodySm' tone='subdued'>{t('{{v1}} of {{v2}} characters used', (autoOptimizeModalData?.meta_description || '').length, 160)}</Text>
                                </InlineStack>
                                <TextField
                                    id="optMetaDescriptionValue"
                                    labelHidden
                                    value={autoOptimizeModalData?.meta_description}
                                    onChange={handleInputOptModalData}
                                    multiline={3} rows={4}
                                    autoComplete='off'
                                />
                            </BlockStack>
                        }
                        {
                            Boolean(autoOptimizeData?.url_slug) && <BlockStack gap='100'>
                                <TextField
                                    id="optUrlValue"
                                    label={t("URL handle")}
                                    value={autoOptimizeModalData?.url_slug}
                                    prefix={(pagetypeRef.current || pagetype) === 'blog' ? `blogs/${blog_handle}/` : `${PAGE_URL_PREFIX_MAP[pagetypeRef.current || pagetype]}/`}
                                    onChange={handleInputOptModalData}
                                    autoComplete='off'
                                />
                            </BlockStack>
                        }
                    </div>
                </BlockStack>
            }
        />
    );

    /* 优化对比：产品标签 */
    const autoOptCompareTagsBody = (
        <AutoOptCompareTwoCol
            original={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='original' />
                    <div className='tags_compare_view'>
                        <Text as='span' variant='bodyMd' tone='subdued'>{t("Product Tag")}</Text>
                        <InlineStack gap='200' blockAlign='center'>
                            {
                                (originalOptimizeData?.productTags || []).length > 0
                                    ? (originalOptimizeData?.productTags || []).map((tag, index) => <Tag key={`${tag}-${index}`}>{tag}</Tag>)
                                    : <Text as='span' variant='bodySm' tone='subdued'>{t("No tags")}</Text>
                            }
                        </InlineStack>
                    </div>
                </BlockStack>
            }
            optimized={
                <BlockStack>
                    <AutoOptCompareSideLabel variant='optimized' />
                    <div className='tags_compare_input purple_input'>
                        <Text as='span' variant='bodyMd'>{t("Product Tag")}</Text>
                        <TagTextInput
                            id="optProductTags"
                            SelectCurrentItem={autoOptimizeModalData?.product_tags || []}
                            setChangeTagsData={handleTagsOptModalData}
                        />
                    </div>
                </BlockStack>
            }
        />
    );

    // 优化对比弹窗
    const AutoOptCompareModal = <Modal
        open={Boolean(autoOptCompareKey)}
        title={autoOptCompareKey ? autoOptCompareModalTitle[autoOptCompareKey] : ''}
        onClose={() => setAutoOptCompareKey(null)}
        size='large'
        limitHeight
        primaryAction={{
            content: t('Apply Changes'),
            onAction: () => handleApplyAutoOptChanges(autoOptCompareKey, autoOptimizeModalData),
            disabled: autoOptCompareKey === 'title' ? autoOptimizeData?.title === autoOptimizeModalData?.title :
                autoOptCompareKey === 'content' ? (autoOptimizeData?.description === autoOptimizeModalData?.description && descSetNumModal <= 1) :
                    autoOptCompareKey === 'meta' ? (autoOptimizeData?.meta_title === autoOptimizeModalData?.meta_title && autoOptimizeData?.meta_description === autoOptimizeModalData?.meta_description && autoOptimizeData?.url_slug === autoOptimizeModalData?.url_slug) :
                        autoOptCompareKey === 'tags' ? JSON.stringify(autoOptimizeData?.product_tags || []) === JSON.stringify(autoOptimizeModalData?.product_tags || []) : false,
        }}
        secondaryActions={[
            {
                content: t('Cancel'),
                onAction: () => setAutoOptCompareKey(null),
            },
        ]}
    >
        <div className='auto_opt_compare_modal'>
            {autoOptCompareKey === 'title' && autoOptCompareTitleBody}
            {autoOptCompareKey === 'content' && autoOptCompareContentBody}
            {autoOptCompareKey === 'meta' && autoOptCompareMetaBody}
            {autoOptCompareKey === 'tags' && autoOptCompareTagsBody}
        </div>
    </Modal>;

    // 自动优化视图
    const isMbStyle = windowWidth < 1000;
    const AutoOptimizeView = <div className='auto_optimize_view'>
        {
            autoOptimizeLoading ? <BlockStack gap={400}>
                <div className='panel_view_loading'>
                    {scorePanel(0, true)}
                    <BlockStack gap={400}>
                        <SkeletonBodyText lines={2} />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </div>
                <div className="aly_loading">
                    {taskLoadingIcon()}
                    <span>{t("Analyze and optimize in progress")}…</span>
                </div>
                {/* <Button fullWidth onClick={handleCancelAutoOptTip}>{t("Cancel")}</Button> */}
            </BlockStack> : <BlockStack gap={400}>
                {scorePanel(seo_score)}
                <Card padding={400}>
                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                        <Text as='span' variant='bodySm' fontWeight='subdued'>{t("Boosted Score")}</Text>
                        <div className='score_increase_container'>
                            <Text as='span' variant='bodyMd'>
                                <span className='auto_optimize_boosted_from'>{Math.ceil(autoOriginScore)}</span>
                                <span className='auto_optimize_boosted_arrow'> → </span>
                                <span className='auto_optimize_boosted_to'>{Math.ceil(autoOptScore)}</span>
                            </Text>
                            {
                                autoOptScore > autoOriginScore ? <div className='score_increase'>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.0835 4.08398H9.91683V9.91732" stroke="#27AE60" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.0835 9.91732L9.91683 4.08398" stroke="#27AE60" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <Text as='span' variant='bodySm' fontWeight='medium'>{Math.ceil(autoOptScore - autoOriginScore)}</Text>
                                </div> : null
                            }
                        </div>
                    </InlineStack>
                </Card>
                <BlockStack gap={300}>
                    <Text as='h3' variant='headingMd'>{t("Adjustments")}</Text>
                    <BlockStack gap={200}>
                        {
                            Boolean(autoOptimizeData?.title) && <Card padding={300}>
                                <div className='auto_optimize_adjustment_item' onClick={() => {
                                    if (!setSaveLoading) {
                                        setAutoOptCompareKey('title');
                                    }
                                }}>
                                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                        <InlineStack gap='100' blockAlign='center' wrap={false}>
                                            <span className='auto_optimize_adjustment_icon'><Icon source={ListBulletedIcon} tone='subdued' /></span>
                                            <Text as='span' variant='bodyMd'>{t("Title optimized")}</Text>
                                        </InlineStack>
                                        <InlineStack gap='200' blockAlign='center' wrap={false}>
                                            <div className='compare_btn'>{t("Compare")}</div>
                                            <div className='do_btn' onClick={(e) => {
                                                if (setSaveLoading) return;
                                                e.stopPropagation();
                                                handleRollbackData('title');
                                            }}>
                                                {
                                                    rollbackLoading === 'title' && <span className='do_loading_icon'><Spinner size="small" /></span>
                                                }
                                                {optPurpleArray.includes('titleValue') ? t("Undo") : t("Redo")}
                                            </div>
                                        </InlineStack>
                                    </InlineStack>
                                </div>
                            </Card>
                        }
                        {
                            Boolean(autoOptimizeData?.description) && <Card padding={300}>
                                <div className='auto_optimize_adjustment_item' onClick={() => {
                                    if (!setSaveLoading) {
                                        setAutoOptCompareKey('content');
                                    }
                                }}>
                                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                        <InlineStack gap='100' blockAlign='center' wrap={false}>
                                            <span className='auto_optimize_adjustment_icon'><Icon source={NoteIcon} tone='subdued' /></span>
                                            <Text as='span' variant='bodyMd'>{t("Content optimized")}</Text>
                                        </InlineStack>
                                        <InlineStack gap='200' blockAlign='center' wrap={false}>
                                            <div className='compare_btn'>{t("Compare")}</div>
                                            <div className='do_btn' onClick={(e) => {
                                                if (setSaveLoading) return;
                                                e.stopPropagation();
                                                handleRollbackData('desc');
                                            }}>
                                                {
                                                    rollbackLoading === 'desc' && <span className='do_loading_icon'><Spinner size="small" /></span>
                                                }
                                                {optPurpleArray.includes('descValue') ? t("Undo") : t("Redo")}
                                            </div>

                                        </InlineStack>
                                    </InlineStack>
                                </div>
                            </Card>
                        }
                        {
                            Boolean(autoOptimizeData?.meta_title || autoOptimizeData?.meta_description || autoOptimizeData?.url_slug) && <Card padding={300}>
                                <div className='auto_optimize_adjustment_item' onClick={() => {
                                    if (!setSaveLoading) {
                                        setAutoOptCompareKey('meta');
                                    }
                                }}>
                                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                        <InlineStack gap='100' blockAlign='center' wrap={false}>
                                            <span className='auto_optimize_adjustment_icon'><Icon source={CodeIcon} tone='subdued' /></span>
                                            <Text as='span' variant='bodyMd'>{t("Meta tags optimized")}</Text>
                                        </InlineStack>
                                        <InlineStack gap='200' blockAlign='center' wrap={false}>
                                            <div className='compare_btn'>{t("Compare")}</div>
                                            <div className='do_btn' onClick={(e) => {
                                                if (setSaveLoading) return;
                                                e.stopPropagation();
                                                handleRollbackData('meta_tag');
                                            }}>
                                                {
                                                    rollbackLoading === 'meta_tag' && <span className='do_loading_icon'><Spinner size="small" /></span>
                                                }
                                                {['metaTitleValue', 'metaDescriptionValue', 'urlValue'].some(key => optPurpleArray.includes(key)) ? t("Undo") : t("Redo")}
                                            </div>
                                        </InlineStack>
                                    </InlineStack>
                                </div>
                            </Card>
                        }
                        {
                            Boolean(autoOptimizeData?.product_tags?.length) && <Card padding={300}>
                                <div className='auto_optimize_adjustment_item' onClick={() => {
                                    if (!setSaveLoading) {
                                        setAutoOptCompareKey('tags');
                                    }
                                }}>
                                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                        <InlineStack gap='100' blockAlign='center' wrap={false}>
                                            <span className='auto_optimize_adjustment_icon'><Icon source={CollectionIcon} tone='subdued' /></span>
                                            <Text as='span' variant='bodyMd'>{t("Product tags optimized")}</Text>
                                        </InlineStack>
                                        <InlineStack gap='200' blockAlign='center' wrap={false}>
                                            <div className='compare_btn'>{t("Compare")}</div>
                                            <div className='do_btn' onClick={(e) => {
                                                if (setSaveLoading) return;
                                                e.stopPropagation();
                                                handleRollbackData('tags');
                                            }}>
                                                {
                                                    rollbackLoading === 'tags' && <span className='do_loading_icon'><Spinner size="small" /></span>
                                                }
                                                {optPurpleArray.includes('productTags') ? t("Undo") : t("Redo")}
                                            </div>
                                        </InlineStack>
                                    </InlineStack>
                                </div>
                            </Card>
                        }
                        {
                            level === 1 || inactiveNum === 0 ? null : <Card padding={400}>
                                <div className={`auto_optimize_adjustment_item auto_optimize_adjustment_item--static ${!autoOptStructureSel ? 'disabled_str_type' : ''}`} onClick={() => {
                                    patchSettingState({ autoOptStructureSel: !autoOptStructureSel });
                                }}>
                                    <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                        <InlineStack gap='100' blockAlign='center' wrap={false}>
                                            <span className='auto_optimize_adjustment_icon'><Icon source={CodeAddIcon} tone='subdued' /></span>
                                            <Text as='span' variant='bodyMd'>{t("{{v1}} structured data", inactiveNum)}</Text>
                                        </InlineStack>
                                        <InlineStack gap='200' blockAlign='center' wrap={false}>
                                            <Switch onChange={() => patchSettingState({ autoOptStructureSel: !autoOptStructureSel })} checked={Boolean(autoOptStructureSel)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                                        </InlineStack>
                                    </InlineStack>
                                </div>
                            </Card>
                        }
                    </BlockStack>
                </BlockStack>
                {/* <Button fullWidth onClick={handleCancelAutoOptTip}>{t("Cancel")}</Button> */}
            </BlockStack>
        }
    </div>
    const RightCardMain = <Card padding={0}>
        <div className='right_score_view'>
            <div className='right_score_view_header' style={{ justifyContent: (sidePanel === 'right' || isMbStyle) ? 'space-between' : 'center' }}>
                {
                    (sidePanel === 'right' || isMbStyle) && (
                        panelState === '3' ? <div className='flex_layout auto_optimize_header'>
                            <Button icon={ChevronLeftIcon} variant='tertiary' onClick={handleCancelAutoOptTip}></Button>
                            <Text as='h2' variant='headingMd'>{t("Auto-Optimize")}</Text>
                        </div> : <Text as='h2' variant='headingMd'>{panelState === '1' ? t("Content Audit") : t("Target Keyword")}</Text>
                    )
                }
                {
                    !isMbStyle && <Button icon={(sidePanel === 'right' || isMbStyle) ? MinimizeIcon : MaximizeIcon} onClick={toggleSidePanel} variant='tertiary'></Button>
                }
            </div>
            {
                sidePanel === 'left' && !isMbStyle ? (researchLoading ? smallScoreLoadingView : smallScoreView) : (
                    panelState.includes('1') ? NoneKeywordView : panelState.includes('2') ? TargetKeywordView : panelState === '3' ? AutoOptimizeView : null
                )
            }
        </div>
    </Card>

    // 内容loading
    const pageSkeletonLoading = <>
        <div className="content_audit_detail_center">
            <BlockStack gap={400}>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </BlockStack>
        </div>
        {
            !Boolean(isEditObjState && curLanguageSel) && <div className={`content_audit_detail_panel content_audit_detail_right ${sidePanel === 'right' ? 'is_expanded' : ''}`}>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </div>
        }
    </>

    // 左列表卡片
    const LeftListCard = <div className={`content_audit_detail_panel content_audit_detail_left ${sidePanel === 'left' || isMbStyle ? 'is_expanded' : ''}`}>
        {LeftCardMain}
        <div className='toggle_list_icon_btn' style={{ marginRight: sidePanel === 'left' ? '-30px' : '-15px', display: isMbStyle ? 'none' : 'block' }}>
            <Button onClick={toggleSidePanel}>{toggleListIcon}</Button>
        </div>
    </div>

    // 页面内容：左中右三栏，左/右可伸缩且互斥；
    const pageContent = (
        <div className={`content_audit_detail_page_content ${sidePanel === 'left' || isMbStyle ? 'has_left_expanded' : ''} ${sidePanel === 'right' || isMbStyle ? 'has_right_expanded' : ''}`}>
            {
                !isMbStyle ? LeftListCard : <div className='left_list_col'>
                    <Collapsible
                        id='content_audit_detail_left_list_collapsible'
                        open={isOpenList}
                        transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                        expandOnPrint
                    >
                        {LeftListCard}
                    </Collapsible>
                    <div className='left_list_col_btn' onClick={() => setIsOpenList((prev) => !prev)}>
                        <Button variant='plain'>{isOpenList ? t("Collapse list") : t("View List")}</Button>
                        <Icon source={isOpenList ? ChevronUpIcon : ChevronDownIcon} />
                    </div>
                </div>
            }
            {
                pageLoading ? pageSkeletonLoading : <>
                    <div id="scroll_center_container" className="content_audit_detail_center">
                        {
                            Boolean(isEditObjState && curLanguageSel && isShowMoreLangTip) && <div style={{ marginBottom: '16px' }}>
                                <Banner
                                    title={t("On-page Audit is currently only available for your store's primary language")}
                                    tone="info"
                                    onDismiss={() => patchPagePublicState({ isShowMoreLangTip: false })}
                                ></Banner>
                            </div>
                        }
                        {CenterCardMain}
                    </div>
                    {
                        !Boolean(isEditObjState && curLanguageSel) && <div className={`content_audit_detail_panel content_audit_detail_right ${sidePanel === 'right' || isMbStyle ? 'is_expanded' : ''}`}>
                            {RightCardMain}
                        </div>
                    }
                </>
            }
        </div>
    );

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    return (
        <div id='contentAuditDetailMain'>
            <Page
                fullWidth
            >
                <title>SEOWILL - Content Audit Detail</title>

                <SaveBarTop
                    isShowSaveBar={isShowSaveBar}
                    saveLoading={setSaveLoading}
                    handleSaveAction={handleSaveAction}
                    handleDiscardAction={handleDiscardAction}
                />

                <div className='content_audit_detail_topbar' style={{ width: '100%' }}>
                    <div className='topbar_left alignCenter'>
                        <Button icon={ArrowLeftIcon} variant='tertiary' onClick={() => goBack(false)}></Button>
                        {
                            SheetTitle ? <>
                                <h1 className='content_audit_detail_title ellipsis_1'>
                                    {SheetTitle}
                                </h1>
                                {
                                    (pagetype === 'product' && productState) ? <Badge tone={productState === 'ACTIVE' ? 'success' : productState === 'DRAFT' ? 'info' : ''}>{t(productState === 'ACTIVE' ? 'Active' : productState === 'DRAFT' ? 'Draft' : 'Unlisted')}</Badge> :
                                        (pagetype === 'blog' || pagetype === 'otherpage') ? <Badge tone={isPublishState ? 'success' : 'info'}>{isPublishState ? t("Active") : t("Hidden")}</Badge> :
                                            null
                                }
                                <Popover
                                    active={isShowLangList}
                                    activator={
                                        <Button
                                            disclosure={!tLoading}
                                            loading={tLoading}
                                            disabled={publishLoading || pageLoading || researchLoading || globalLoading}
                                            onClick={() => changeSelectLanguage(false, '', LanguageList)}
                                        >{t(langeName)}</Button>
                                    }
                                    autofocusTarget="first-node"
                                    onClose={() => patchSettingState({ isShowLangList: false })}
                                >
                                    <Scrollable shadow style={{ maxHeight: '300px' }}>
                                        <ActionList
                                            actionRole="menuitem"
                                            items={LanguageList}
                                        />
                                    </Scrollable>
                                </Popover>
                            </> : <div style={{ width: '24vw' }}>
                                <SkeletonBodyText lines={2} />
                            </div>
                        }
                    </div>
                    <div className='topbar_right alignCenter'>
                        {
                            (isShowVideoAudit) && <div className='alignCenter video_audit' onClick={() => {
                                // setContentAuditVMState(true)
                                // 改成跳转帮助中心
                                window.open(`${process.env.PUBLIC_HELP_CENTER_ADMIN}/content-optimization/guideline/g2/`, "_blank");
                            }}>
                                <span><Icon source={QuestionCircleIcon} /></span>
                                <Text as='p' variant='bodySm'>{t("See how Content Audit works")}</Text>
                                <span onClick={(e) => {
                                    e && e.stopPropagation();
                                    handleCloseVideoAudit();
                                }}><Icon source={XIcon} /></span>
                            </div>
                        }
                        <div className='grey_style alignCenter'>
                            <Tooltip content={t("Version History")}>
                                <Button icon={ClockIcon} disabled={publishLoading || pageLoading || globalLoading} onClick={() => setHistoryRecordModalOpen(true)}></Button>
                            </Tooltip>
                            <div className='items_change alignCenter'>
                                <Tooltip content={t("Previous")}>
                                    <Button icon={ChevronUpIcon} disabled={itemNavPrevDisabled || pageLoading || globalLoading} loading={changeType === 'prev'} onClick={() => handlePageItemChange('prev')}></Button>
                                </Tooltip>
                                <Tooltip content={t("Next")}>
                                    <Button icon={ChevronDownIcon} disabled={itemNavNextDisabled || pageLoading || globalLoading} loading={changeType === 'next'} onClick={() => handlePageItemChange('next')}></Button>
                                </Tooltip>
                            </div>
                        </div>
                        <div className='topbar_right_buttons alignCenter'>
                            {
                                (isPublishState || pagetype !== 'blog') && <Button onClick={handlePreviewUrl} disabled={pageLoading}>{t("View")}</Button>
                            }
                            {
                                (!isPublishState && (pagetype === 'blog')) && <Button variant='primary' onClick={handlePublishData} loading={publishLoading} disabled={pageLoading}>{t("Publish")}</Button>
                            }
                        </div>
                    </div>
                </div>

                {/* 页面内容 */}
                <div className="content_audit_detail_page">
                    {pageContent}
                </div>

                {SearchSettingsModal}
                {AutoOptCompareModal}
                {pagesListModal}
                {AltEditModal}
                {/* {contentAuditVM} */}
                {historyRecordModal}
                {cancelAutoOptModal}
                {autoOptPrefModal}
                {cancelInsertModal}
                {notSaveModal}
                {OverExcessModal}
                {gscFailModal}
                {gscPermissionModal}

                <ReviewPopup
                    open={reviewPopupOpen}
                    onClose={() => setReviewPopupOpen(false)}
                    toggleToast={props.toggleToast}
                />

                {/* 底部 */}
                {FooterHelpBox}
            </Page>
        </div>
    );
}

export default withWindowWidth(withRouter(ContentAuditDetail));